/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, Input, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Breadcrumb } from 'app/core/services/breadcrumb/breadcrumb.interface';
import { BreadcrumbService } from 'app/core/services/breadcrumb/breadcrumb.service';
import { LocalisationService } from 'app/core/services/localisation/zuper.localisation.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import moment, { Moment } from 'moment';
import { Observable, ReplaySubject, Subscription, concat, forkJoin, of } from 'rxjs';
import { rrulestr } from 'rrule';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PreviewAddressFormComponent } from 'app/components/preview-address-form/preview-address-form.component';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { Provider, Type } from 'app/components/location-preview/location-preview.interface';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { DataPickerService } from 'app/core/services/data_picker/data_picker.service';
import { HotToastService } from '@ngneat/hot-toast';
import { JobsService } from 'app/core/services/jobs/jobs.service';
import { EditorOptions } from 'app/components/text-editor/text-editor.interface';
import { NewCategoryComponent } from 'app/components/new-category/new-category.component';
import { LineItemPickerComponent } from 'app/components/line-item-picker/line-item-picker.component';
import { LineItemService } from 'app/core/services/lineitem/lineitem.service';
import { LineItemPickerColumnType, LineItemPickerColumns, LineItemPickerOptions } from 'app/components/line-item-picker/line-item-picker.interface';
import { LineItemPickerService } from 'app/components/line-item-picker/line-item-picker.service';
import { ProductDetailsModelComponent } from 'app/components/product-details/product-details.model.component';
import { DeletePartsConfirmationComponent } from '../job-details/delete-parts-confirmation copy/delete-parts-confirmation.component';
import { UpdatePartsOrServicesComponent } from 'app/components/update-parts-services/update-parts-services.component';
import { CustomFieldConfig } from 'app/components/custom-field-form/custom-field-form.interface';
import { PickerFilterOptions, PickerOptions, PickerSelectOptions, PickerSelectDisableOptions } from 'app/components/data-picker/data-picker.interface';
import { BadgeOptions } from 'app/components/badge/badge.interface';
import { AssistedSchedulerComponent } from 'app/components/assisted-scheduler/assisted-scheduler.component';
import { MapsService } from 'app/modules/maps/maps.service';
import { AssetsService } from 'app/core/services/assets/assets.service';
import { ContractsService } from 'app/core/services/contracts/contracts.service';
import { CustomFieldService } from 'app/components/custom-field-form/custom-field.service';
import { AddressObj, AddressOptions } from 'app/components/address-component/address.component.interface';
import { PartsOrServicesOptions } from 'app/components/update-parts-services/update-parts-services.interface';
import { QuotationService } from 'app/core/services/quotations/quotation.service';
import { OrganizationService } from 'app/core/services/organization/organization.service';
import { PropertyService } from 'app/core/services/properties/properties.service';
import { CustomersService } from 'app/core/services/customers/customers.service';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import { AddServiceTaskComponent } from 'app/components/add-service-task/add-service-task.component';
import { JobDate, RRuleDateOptions } from 'app/components/rrule-date/rrule-date.type';
import { TaskReorderComponent } from 'app/components/task-reorder/task-reorder.component';
import { InvoicesService } from 'app/core/services/invoices/invoices.service';
import { NgxTippyService } from 'ngx-tippy-wrapper';
import _ from 'lodash';
import { PPMsService } from 'app/core/services/ppms/ppms.service';
import { JobData } from './job-form.type';
import { LineitemHeaderComponent } from 'app/components/lineitem-header/lineitem-header.component';
import { FileUploaderService } from 'app/components/file-uploader/file-uploader.service';
import { FileUploaderComponent } from 'app/components/file-uploader/file-uploader.component';
import { FilePlaceholderOptions } from 'app/components/file-placeholder/file-placeholder.interface';
import { DownloadFileLinkService } from 'app/core/services/download_file_link/download_file_link.service';
import { TranslateService } from '@ngx-translate/core';
import { ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { AnalyticsService } from 'app/core/services/analytics/analytics.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { catchError, debounceTime, distinctUntilChanged, filter, map, pairwise, switchMap, tap } from 'rxjs/operators';
import { TimeZoneDataType, TimezonePickerService } from 'app/core/services/timezone/timezone-picker.service';
import { PricelistAssociations, PricelistAssociationsActive, PricelistService } from 'app/core/services/products/pricelist.service';
import { PricelistType } from 'app/modules/price-list/price-list.interface';
import { ProjectsService } from 'app/core/services/project/projects.service';
import { MetaData } from 'ng-event-bus/lib/meta-data';
import { ZuperSdkDataService } from 'app/core/services/sdk_service/sdk-data.service';
import { ProductBundleItemPickerComponent} from 'app/components/product-bundle-item-picker/product-bundle-item-picker.component';
import { BundleItemPickerService } from 'app/components/product-bundle-item-picker/product-bundle-item-picker.service';
import { ProductBundleEditFormComponent } from 'app/components/product-bundle-edit-form/product-bundle-edit-form.component';
import { ProductType } from 'app/core/constants/constants';
import { bundlePricingLevel } from 'app/modules/products/products.types';
import { NgxMatDatetimepicker } from '@angular-material-components/datetime-picker';
import { PartsBulkAction } from '../job-details/job-details.component.interface';
import { UpdateMarkupComponent } from 'app/components/update-markup/update-markup.component';
import { AccountingService } from 'app/core/services/Accounting/accounting.service';
import { JobCategoryUpdateDialogComponent } from 'app/components/job-category-update-dialog/job-category-update-dialog.component';


dayjs.extend(utc);

@Component({
  selector: 'app-job-form',
  templateUrl: './job-form.component.html',
  styleUrls: ['./job-form.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class JobFormComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('jobDetailsRef') jobDetailsRef: TemplateRef<HTMLElement>;
  @ViewChild('jobScheduleRef') jobScheduleRef: TemplateRef<HTMLElement>;
  @ViewChild('serviceAddressRef') serviceAddressRef: TemplateRef<HTMLElement>;
  @ViewChild('billingAddressRef') billingAddressRef: TemplateRef<HTMLElement>;
  @ViewChild('primaryDetailsRef') primaryDetailsRef: TemplateRef<HTMLElement>;
  @ViewChild('partServiceRef') partServiceRef: TemplateRef<HTMLElement>;
  @ViewChild('customFieldRef') customFieldRef: TemplateRef<HTMLElement>;
  @ViewChild('assignUserRef') assignUserRef: TemplateRef<HTMLElement>;
  @ViewChild('organizationRef') organizationRef: TemplateRef<HTMLElement>;
  @ViewChild('customerRef') customerRef: TemplateRef<HTMLElement>;
  @ViewChild('propertyRef') propertyRef: TemplateRef<HTMLElement>;
  @ViewChild('contractRef') contractRef: TemplateRef<HTMLElement>;
  @ViewChild('assetRef') assetRef: TemplateRef<HTMLElement>;
  @ViewChild('attachmentsRef') attachmentsRef: TemplateRef<HTMLElement>;
  @ViewChild('serviceTaskRef') serviceTaskRef: TemplateRef<HTMLElement>;
  @ViewChild('requestRef') requestRef: TemplateRef<HTMLElement>;
  @ViewChild('projectRef') projectRef: TemplateRef<HTMLElement>;
  @ViewChild('secondaryContactsRef') secondaryContactsRef: TemplateRef<HTMLElement>;
  @ViewChild('scrollElementCenter') scrollElementCenter: ElementRef;


  jobForm: UntypedFormGroup;
  rruleForm: UntypedFormGroup;
  rruleDateOptions: RRuleDateOptions = {
    hasJob: false
  };
  dateGroup: UntypedFormGroup = new UntypedFormGroup({
    dates: new UntypedFormArray([])
  });
  jobs: JobDate[];


  dateFormat: string = 'DD/MM/YYYY';
  timeFormat: string = 'HH:mm A';
  dateTimeFormat: string = 'DD/MM/YYYY HH:mm A';
  showMeridian: boolean = false;
  userRole: string = '';
  companyConfig: any;
  company: any;
  module: string;
  uid: string;
  urlState: string;
  breadcrumbData: Breadcrumb;
  actionState: string;
  jobDetails: any;
  formPlacement: any = {};
  startDate: any;
  endDate: any;
  conflictingJobs: number = 0;
  conflictingJobData: any = [];
  options: any = {
    position: 'right',
    mode: 'over',
    hasBackDrop: true,
  };
  openPicker: boolean = false;
  currentRruleValue: any;
  activeRrule: string;
  activeDates: any[] = [];
  currentRruleDates: any[] = [];
  currentRruleCount: number = 0;
  today: Moment;
  redirect: any;
  selectedQuote: any;
  showError: boolean = false;
  attachments: any[] = [];
  currentPickerTarget: any;
  timeZone: string = '';
  showContractAlert: boolean = false;
  showContractAlertDisplay: boolean = false;
  isDescriptionModified: boolean = false;
  isJobCreating: boolean = false;

  //Address
    defaultAddress: any = {
      'firstName': '',
      'lastName': '',
      'email': '',
      'phone': '',
      'street': '',
      'landmark': '',
      'city': '',
      'state': '',
      'country': {
          'value': '',
          'label': ''
      },
      'zipcode': '',
      'latitude': 0,
      'longitude': 0
  };
  currentServiceAddress: any = {...this.defaultAddress};
  currentBillingAddress: any = {...this.defaultAddress};
  showServiceAddress: boolean = false;
  serviceMapOption: any = {
    module:'',
    moduleUid:'',
    coords: [],
    extraClass: '',
    width: 250,//send without units
    height: 100,
    zoom: 13,
    provider: Provider.GOOGLE,
    type: Type.IMAGE
  };
  sameAsServiceAddress: boolean = true;

  jobCategory: any;
  showParentMandatory: boolean = false;
  currentCategory: any;
  currentCategorySkills: any[] = [];
  tagsOption: any = {
    module: 'JOB'
  };
  showTag: boolean = false;
  skillOptions: any[] = [];
  skillValue: any[] = [];
  textEditorOptions: EditorOptions = {
    editorId:'jobDescription',
    attachmentType: 'JOB_NOTE',
    module:'JOB',
    isForm: true,
    showTemplate: false
  };
  showEditor: boolean = false;
  //Line items
  selectedLineItems: any[] = [];
  lineItemsDisplayedColumns: Array<string> = ['id','select','product', 'location', 'quantity', 'price', 'total', 'action'];

  customFieldConfig: CustomFieldConfig;
  showCustomFields: boolean = false;
  customFieldValue: any[];
  currentCategoryId: string = '';

  //Employee Assignment
  assignEmployeeOptions: any = {
    details: {
      'assigned_to': [],
      'service_territory': {},
      'skills': []
    },
    hideNotify: true,
    module:'JOB'
  };
  openEmployee: boolean = false;

  //Service Task
  openTask: boolean = false;
  serviceTaskOption: any = {
    drawerName: 'serviceTaskDrawer',
    header: 'header.task.create.custom',
    footer: {
      submit: 'text.save'
    },
    isCustom: true,
    state: 'new'
  };
  selectedServiceTask: any[] = [];
  taskDisplayedColumns: Array<string> = ['checkbox', 'service_task', 'description', 'inspection_form', 'estimated_duration', 'asset', 'assign', 'action'];
  serviceTaskAssets: any[] = [];
  serviceTaskDuration: any = {};
  serviceTaskMinutes: number;
  jobScheduleDuration: any = {};
  jobScheduleMinutes: number;
  showSkip: boolean = true;
  serviceTaskIndex: number;
  currentExecution: 'PARALLEL' | 'SERIES';
  currentServiceTask: any;
  masterAssignmentCopy: any[] = [];
  propertyPickedFirst: boolean = false;

  //Data picker
  currentPickerModule: string;
  currentPickerOptions: any = {
    position: 'right',
    mode: 'over',
    hasBackDrop: false,
    allowQuickCreate: false,
    selectOption: PickerSelectOptions.select
  };
  openDataPicker: boolean = false;

  //Organization
  selectedOrganizations: any = [];
  organizationPickerOptions: PickerOptions = {
    header: {
      displayKey: null,
      displayName: this.utilityService.getLocaleValue('choose.organization')
    },
    position: 'right',
    mode: 'over',
    hasBackDrop: false,
    allowQuickCreate: false,
    showListCount: true,
    selectOption: PickerSelectOptions.select
  };

  //Customer
  selectedCustomers: any = [];
  customerPickerOptions: any = {
    header: {},
    position: 'right',
    mode: 'over',
    hasBackDrop: false,
    allowQuickCreate: false,
    showListCount: true,
  };

  //Secondary Contacts
  selectedSecondaryContacts: any = [];

  //Property
  selectedProperty: any[] = [];
  propertyPickerOptions: any = {
    header: {
      displayKey: null,
      displayName: this.utilityService.getLocaleValue('text.choose_property')
    },
    position: 'right',
    mode: 'over',
    hasBackDrop: false,
    allowQuickCreate: false,
    showListCount: true,
    selectOption: PickerSelectOptions.select
  };

  //Project
  selectedProject: any[] = [];
  projectPickerOptions: any = {
    header: {
      displayKey: null,
      displayName: this.utilityService.getLocaleValue('text.choose_project')
    },
    position: 'right',
    mode: 'over',
    hasBackDrop: false,
    allowQuickCreate: false,
    showListCount: true,
    selectOption: PickerSelectOptions.select
  };

  //Request
  selectedRequest: any[] = [];
  requestPickerOptions: any = {
    header: {
      displayKey: null,
      displayName: this.utilityService.getLocaleValue('text.choose_request')
    },
    position: 'right',
    mode: 'over',
    hasBackDrop: false,
    allowQuickCreate: false,
    showListCount: true,
    selectOption: PickerSelectOptions.select
  };

  //Contract
  selectedContract: any[] = [];
  contractPickerOptions: any = {
    header: {
      displayKey: null,
      displayName: this.utilityService.getLocaleValue('text.choose_contract')
    },
    position: 'right',
    mode: 'over',
    hasBackDrop: false,
    allowQuickCreate: false,
    showListCount: true,
    selectOption: PickerSelectOptions.select
  };

  //Asset
  selectedAssets: any[] = [];
  assetPickerOptions: any = {
    header: {
      displayKey: null,
      displayName: this.utilityService.getLocaleValue('text.choose_asset')
    },
    position: 'right',
    mode: 'over',
    hasBackDrop: false,
    allowQuickCreate: false,
    showListCount: true,
    selectOption: PickerSelectOptions.multiSelect
  };
  assetPickerState: 'STANDALONE' | 'TASK';
  customerPickerState: 'CUSTOMER' | 'SECONDARY_CONTACTS';
  currentTaskAsset: any;

  //Job
  selectedJob: any[] = [];
  jobPickerOptions: any = {
    header: {
      displayKey: null,
      displayName: this.utilityService.getLocaleValue('text.choose_job')
    },
    position: 'right',
    mode: 'over',
    hasBackDrop: false,
    allowQuickCreate: false,
    showListCount: true,
    selectOption: PickerSelectOptions.select
  };

  //Address picker
  addressOptions: AddressOptions = {
    drawerTitle: 'all.address.label',
    submitButtonDisplayKey: 'maps.picker.submit.label',
    submitButtonDisplayName: 'Use this Address',
    uid: '',
    addressList: [],
    // prefillDetails: ContactDetailsstring,
    addressModule: 'CUSTOMER',
    selectedAddress: null,
  };
  showManageAddress: boolean = false;
  allAddresses: AddressObj[] = [];
  currentAddressEdit: string;

  breadcrumbSubscription: Subscription;
  paramMapSubscription: Subscription;
  organizationPickerSubscription: Subscription;
  customerPickerSubscription: Subscription;
  propertyPickerSubscription: Subscription;
  requestPickerSubscription: Subscription;
  contractPickerSubscription: Subscription;
  assetPickerSubscription: Subscription;
  jobPickerSubscription: Subscription;
  projectPickerSubscription: Subscription;
  secondaryContactsSubscription: Subscription;

  //assign employye in task
  assignEmployeeTask: boolean = false;
  tooltipName: string = '';
  tippyTargetEle: any = document.body;
  showAssetModule: boolean = false;
  //Drag and Drop
  isInvalidDragEvent: boolean = false;

  modulesCreatePermission = {
    'CUSTOMER': this.utilityService.hasPermission('customer.new'),
    'ORGANIZATION': this.utilityService.hasPermission('organization.new'),
    'PROPERTY': this.utilityService.hasPermission('property.new'),
    'ASSETS': this.utilityService.hasPermission('asset.new'),
  };

  //pricelist
  isPricelistEnabled: boolean = false;
  pricelist: Observable<any[]> = new Observable<any[]>();
  isPricelistFetching: boolean = false;
  pricelistValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  pricelistFormControl = new UntypedFormControl(null);
  pricelistParamObj: any = {
    'count': 10,
    'page': 1,
    'sort': 'DESC',
    'filter.is_active': true
  };
  pricelistPagination: any = {
    loadingIndex: 1,
    totalPage: 1,
    keyword: ''
  };
  preloadedValue: any[] = [];
  pricelistUid: string;
  currentPricelistType: any;
  pricelistDetails: any;
  productsInPricelist: any[];
  isPricelistDropdownOpened: boolean = false;
  currentPricelistObj: any;
  isProjectRestricted: boolean = false;

  isServiceTaskEnabled: any;
  isPartsServicesEnabled: boolean;
  service_territory: any = {};
  serviceTerritoryOptions: any = {};
  currentPage: any;
  jobFormValueChangeSubscriptions: Subscription[] = [];
  oldRruleFormvalue: any;

  // timezone
  timezoneSubscription: Subscription;
  defaultTimeZone: string = '';
  timeZoneData: Array<TimeZoneDataType> = [];
  timePickerHovered: boolean = false;
  accountTimeZone: string = this.utilityService.preferredTimeZone;
  fromTimeInAccountTimeZone: string;
  toTimeInAccountTimeZone: string;
  jobScheduled: boolean = false;
  openBundleDetails: boolean = false;
  bundleDetails: any = {};
  showPartsBulkAction: boolean = false;
  selectedProductCount: number = 0;
  partsBulkActions: Array<PartsBulkAction> =  [
    {
      displayKey: 'text.markup',
      displayName: 'Markup',
      icon: 'ti ti-percentage',
      action: 'EDIT_MARKUP'
    }
  ]
  selectedJobParts: any = [];
  selectedSlotObj: any = {};
  currentUser: any;
  defaultPreferredLocationUid: string = null;


  constructor(
    private _localisationService: LocalisationService,
    private _localStorageService: LocalStorageService,
    private _breadcrumbService: BreadcrumbService,
    private _route: ActivatedRoute,
    private _titleService: Title,
    private _router: Router,
    private _zuperDialogService: ZuperDialogService,
    private _dataCollectorService: DataCollectorService,
    private _pickerService: DataPickerService,
    private _toast: HotToastService,
    private _jobsService: JobsService,
    private _lineItemService: LineItemService,
    private _lineItemPickerService: LineItemPickerService,
    private _zuperDrawerService: ZuperDrawerService,
    private _dataPickerService: DataPickerService,
    private _MapService: MapsService,
    private _assetService: AssetsService,
    private _contractService: ContractsService,
    private _customFieldService: CustomFieldService,
    private _quotationService: QuotationService,
    private _organizationService: OrganizationService,
    private _propertyService: PropertyService,
    private _customerService: CustomersService,
    private _invoiceService: InvoicesService,
    private _ppmsService: PPMsService,
    private _fileuploaderService: FileUploaderService,
    private _downloadFileService: DownloadFileLinkService,
    private _analytics: AnalyticsService,
    private dialogRef: MatDialogRef<JobFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: JobData,
    public utilityService: UtilityService,
    public tippyService: NgxTippyService,
    private translateService: TranslateService,
    private pricelistService: PricelistService,
    private projectsService: ProjectsService,
    private elementRef: ElementRef,
    public timezoneService: TimezonePickerService,
    private _zuperSDKDataService: ZuperSdkDataService,
    private _bundleItemPickerService: BundleItemPickerService,
    private _changeDetectorRef: ChangeDetectorRef,
    private accountingService: AccountingService
  ) {
    this.currentPage = this._route.snapshot.data['page'];
    this.listenForPatchFormViaSDK();
  }

  getBreadcrumbData(): void {
    this.breadcrumbSubscription = this._breadcrumbService.breadcrumbActionPerformed.subscribe
      ((res: any) => {
        const action = res?.displayName;
        switch(action){
          case 'Create Job':
            if (this.isJobCreating) {
              return;
            }
            this.getFormValue();
            break;
          case 'Cancel':
            if (this.isJobCreating) {
              return;
            }
            this.utilityService.showCancelAlert('job');
        }
      });
  }

  trackEventAnalytics(state): void{
    let page = '';
    if((this.actionState === 'new' || this.actionState === 'clone')){
      page = 'new_job_';
    }else if(this.actionState === 'edit'){
      page = 'edit_job_';
    }
    page += state;
    this._analytics.trackEvent(page);
  }
  togglePicker(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.currentPickerTarget = target;
    setTimeout(()=>{
      target.blur();
    }, 100);
  }

  handleBlur(): void {
    if(this.currentPickerTarget){
      setTimeout(()=>{
        this.currentPickerTarget.blur();
      });
    }
  }

  addAttachments(event): void{
    event?.stopPropagation();
    this._fileuploaderService.previewFiles.next([]);
    // this.fileUploadService.attachments.next([]);
    this.trackEventAnalytics('add_attachment');
    const attachmentDialog: any = this._zuperDialogService.openCustom(FileUploaderComponent,
      {
        extraClass: 'form-attachment-file-uploader',
        data:  {
          multiple: true,
          attachmentType: 'ATTACHMENT',
          showProgress: true,
          showPreview: true,
          uploadDetails: false,
          header: {
            isHeader: true,
            headerDisplayKey: 'add.attachments',
            headerDisplayName: 'Add Attachments'
          },
          description: {
            descriptionKey: 'notes.panel.attachment.description',
            descriptionName: 'Supported Files: Image, Video, Audio, PDF, DOC, XLS'
          },
          close: {
            isClose: true,
            closeDisplayKey: 'close.text',
            closeDisplayName: 'Close'
          },
          allowFileTypes: this.utilityService.basicSupportedFileTypes
        }
      });
    attachmentDialog.disableClose = true;
    attachmentDialog.afterClosed().subscribe((_result: any) => {
      const attachmentSubscription: Subscription = this._fileuploaderService.attachments.subscribe((attachments: any) => {
        if (attachments?.length) {
          const dataAttachment: any[] = [];
          attachments.forEach((attachment: any) => {
            dataAttachment.push({
              'file_name': attachment.attachment_name,
              'file_url': attachment.attachment_path,
              'attachment_uid': attachment?.attachment_uid,
              'company_attachment_uid': attachment?.attachment_uid
            });
          });
          this.attachments= [...this.attachments,...dataAttachment];
        }
      });
      attachmentSubscription.unsubscribe();
      this._fileuploaderService.previewFiles.next([]);
      this._fileuploaderService.attachments.next([]);
    });
  }

   //attachments
   getPlaceholderOptions(attachment: any): FilePlaceholderOptions {
    const fileLink: string = attachment.url ?? attachment.file_url;
    const attachmentType: string = this.utilityService.getAttachmentExtension(fileLink);
    return {
        fileName: attachment.file_name ?? 'Untitled',
        fileSize: attachment.attachment_size,
        fileType: this.utilityService.getAttachmentTypeEnum(attachmentType),
        fileLink: fileLink,
        showCloseIcon: true,
        showDownloadIcon: true
    };
  }

  fileEventEmitHandler(event: any, index?: number): void {
    if (event) {
        if (event.type === 'download') {
            this.downloadNoteAttachment(event.data);
        }

        if (event.type === 'remove') {
            this.removeFileFromCollection(index);
        }
    }
  }

  downloadNoteAttachment(attachment: any): void {
    if (attachment.attachment) {
        const options: any = {
            params: {
                'file_url': attachment.attachment
            },
            responseType: 'arraybuffer',
            observe: 'response'
        };
        this._downloadFileService.downloadFileFromLink(attachment.attachment_name, options);
    } else {
      this._toast.error(this.utilityService.getLocaleValue('invalid_file'));
    }
  }

  removeFileFromCollection(index: number): void {
    if (this.attachments.length) {
      //checking if user is deleting a newly attached data
      this.attachments.splice(index, 1);
    }
    else{
      this.attachments.splice(index, 1);
    }
  }

  getParsedRRuleValue(rrule: string): string {
    try{
      if(rrule){
        return rrulestr(rrule).toText();
      }else{
        return null;
      }
    }catch(err){

    }
  }

  getStatusText(status: string): string {
    if(status){
      if(status === 'AWAIT_APPROVAL'){
        return this.utilityService.getLocaleValue('text.pending');
      } else if (status === 'ON_HOLD'){
        return this.utilityService.getLocaleValue('text.on_hold');
      } else if (status === 'APPROVED'){
        return this.utilityService.getLocaleValue('text.approved');
      } else if (status === 'REJECTED'){
        return this.utilityService.getLocaleValue('text.rejected');
      } else if (status === 'AWAIT_CUSTOMER_APPROVAL'){
        return this.utilityService.getLocaleValue('text.await_customer_approval');
      } else if (status === 'CUSTOMER_REJECTED'){
        return this.utilityService.getLocaleValue('text.customer_rejected');
      }else if (status === 'CUSTOMER_APPROVED'){
        return this.utilityService.getLocaleValue('text.customer_approved');
      }
    } else {
      return '';
    }
  }

  getAssetStatusText(status: string): string {
    return status ? status.split('_').join(' ').toLowerCase() : '';
  }

  getBadgeOptions(type: string, displayName?: string, displayKey?: any, color?: string, extraClass?: string): BadgeOptions {
    return {
      type: type,
      displayType: 'tags',
      displayKey: displayKey ?? null,
      displayName: displayName ?? (type ? type.toLowerCase() : type),
      color: color ?? null,
      extraClass: 'text-base'
    };
  }

  setTitle(): void{
    if(this.module === 'JOB' && this.urlState === 'new'){
      this._titleService.setTitle(this.utilityService.getLocaleValue('zuper.title.new_job', 'Zuper Pro - New Job'));
    }else if(this.module === 'JOB' && this.urlState === 'edit'){
      this._titleService.setTitle(this.utilityService.getLocaleValue('zuper.title.edit_job', 'Zuper Pro - Edit Job'));
    }
  }

  clearServiceAddress(): void {
    this.currentServiceAddress = {
        'firstName': '',
        'lastName': '',
        'email': '',
        'phone': '',
        'street': '',
        'landmark': '',
        'city': '',
        'state': '',
        'country': {
            'value': '',
            'label': ''
        },
        'zipcode': '',
        'latitude': 0,
        'longitude': 0
    };
    if(this.sameAsServiceAddress){
        this.currentBillingAddress = {
          'firstName': '',
          'lastName': '',
          'email': '',
          'phone': '',
          'street': '',
          'landmark': '',
          'city': '',
          'state': '',
          'country': {
              'value': '',
              'label': ''
          },
          'zipcode': '',
          'latitude': 0,
          'longitude': 0
      };
      this.jobForm.get('billingAddress').reset(this.currentBillingAddress);
    }
    this.jobForm.get('serviceAddress').reset(this.currentServiceAddress);
    this.serviceTerritoryOptions = {};
    this.service_territory ={};
  }

  clearBillingAddress(): void {
        this.currentBillingAddress = {
          'firstName': '',
          'lastName': '',
          'email': '',
          'phone': '',
          'street': '',
          'landmark': '',
          'city': '',
          'state': '',
          'country': {
              'value': '',
              'label': ''
          },
          'zipcode': '',
          'latitude': 0,
          'longitude': 0
      };
      this.jobForm.get('billingAddress').reset(this.currentBillingAddress);
  }

  onBillingAddressFlagChange(): void{
    if(this.sameAsServiceAddress){
      this.currentBillingAddress = this.currentServiceAddress;
      this.jobForm.get('billingAddress').setValue(this.currentBillingAddress);
    }
  }

  changeTags(event: any): void {
    const tagGroup = this.jobForm.get('primaryDetails') as UntypedFormGroup;
    tagGroup.get('tags').setValue(event);
  }

  addServiceTask(event: Event): void {
    this.trackEventAnalytics('add_service_task');
    const addServicetask: MatDialogRef<AddServiceTaskComponent> = this._zuperDialogService.openCustom(AddServiceTaskComponent,
      {
        extraClass: 'add-service-task',
        data: {}
      });
    addServicetask.disableClose = true;
    addServicetask.afterClosed().subscribe((result: any)=>{
      if(result){
        if(this.selectedServiceTask?.length){
          this.selectedServiceTask = [...this.selectedServiceTask,...result];
        }else{
          this.selectedServiceTask = [...result];
        }
      }
      this.calculateTotalMin();
    });
  }

  calculateTotalMin(): void {
    let sum = 0;
    this.selectedServiceTask.forEach((task: any) => {
      if(task?.estimated_duration?.days){
        sum += (task?.estimated_duration?.days * 24 * 60);
      }
      if(task?.estimated_duration?.hours){
        sum += task?.estimated_duration?.hours * 60;
      }
      if(task?.estimated_duration?.minutes){
        sum += task?.estimated_duration?.minutes;
      }
    });
    this.serviceTaskMinutes = sum;
    this.serviceTaskDuration = {
      'days': this.getDays(sum),
      'hours': this.getHours(sum),
      'minutes': this.getMin(sum)
    };
  }

  getDays(mins: number): number{
    return Math.floor(mins / (24 * 60));
  }

  getHours(min: number): number {
    return Math.floor((min - (this.getDays(min) * 24 * 60)) / 60);
  }

  getMin(min: number): number {
    return Math.floor(min % 60);
  }

  rescheduleJob(): void{
    const diff = this.serviceTaskMinutes - this.jobScheduleMinutes;
    const scheduleGroup  = this.jobForm.get('jobSchedule') as UntypedFormGroup;
    const endDate = scheduleGroup.get('endDate').value;
    scheduleGroup.get('endDate').setValue(moment(endDate).add(diff,'minutes'));
  }

  removeTaskAsset(index: number): void {
    const deletedAsset = this.serviceTaskAssets[index];
    this.serviceTaskAssets[index] = null;

    //Check if asset is added in another task
    const assetAdded = this.serviceTaskAssets.find((asset: any) => asset?.asset_uid === deletedAsset?.asset_uid);
    if(assetAdded){
      return;
    }

    //Check if asset is added to master assets through service task
    const fromTaskAsset = this.selectedAssets.findIndex((asset: any) => (asset?.asset_uid === deletedAsset?.asset_uid) && (asset?.fromTask));
    if(fromTaskAsset > -1){
      this.selectedAssets.splice(fromTaskAsset, 1);
    }
  }

  clearAllTask(): void {
    this.selectedAssets = this.selectedAssets.filter((asset: any) => (!asset?.fromTask));
    if(this.assignEmployeeOptions['details']['assigned_to']?.length){
      this.assignEmployeeOptions['details']['assigned_to'] = this.assignEmployeeOptions['details']['assigned_to'].filter((assign: any) => !assign?.fromTask);
      this.masterAssignmentCopy = [];
      this.constructMasterAssignment(this.assignEmployeeOptions['details']['assigned_to']);
    }
    this.serviceTaskAssets = [];
    this.selectedServiceTask = [];
  }

  performTaskAction(action: string, task: any, index?: number): void {
    switch(action) {
      case 'clone' :
        if(this.serviceTaskAssets[index]){
          this.serviceTaskAssets[this.selectedServiceTask?.length] = {...this.serviceTaskAssets[index]};
        }
        const data = {...task};
        this.selectedServiceTask.push(data);
        this.selectedServiceTask = [...this.selectedServiceTask];
        this.calculateTotalMin();
      break;
      case 'edit' :
        //TODO: Add service task edit component
        this.serviceTaskIndex = index;
        this.serviceTaskOption = {
          drawerName: 'serviceTaskDrawer',
          header: 'text.edit_task',
          footer: {
            submit: 'update'
          },
          isCustom: true,
          state: 'edit',
          data: task
        };
        this.toggleTaskDrawer(this.serviceTaskOption?.drawerName);

      break;
      case 'remove':
        this.removeTaskAsset(index);
        this.assignedEmployeeEmitter({
          type: 'UNASSIGN',
          assigned: this.selectedServiceTask[index]['assigned_to'] || []
        });
        this.serviceTaskAssets.splice(index, 1);
        this.selectedServiceTask.splice(index, 1);
        this.selectedServiceTask = [...this.selectedServiceTask];
        this.calculateTotalMin();
      break;
    }
  }

  openAssistedScheduler(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    let workHours = 0;
    if(this.currentCategory?.estimated_duration?.days){
      workHours = 480;
    }else{
      if (this.currentCategory?.estimated_duration?.hours){
        workHours += this.currentCategory?.estimated_duration?.hours * 60;
      }
      if (this.currentCategory?.estimated_duration?.minutes){
        workHours += this.currentCategory?.estimated_duration?.minutes;
      }
    };
    this.trackEventAnalytics('assisted_scheduler');
    const scheduler: MatDialogRef<AssistedSchedulerComponent> = this._zuperDialogService.openCustom(AssistedSchedulerComponent,
      {
        extraClass: 'w-3/5',
          data: {
            workHours: workHours,
            territory: this.service_territory?.matched_territory?.territory,
            timeZone : this.jobForm.get('jobSchedule').get('job_timezone').value,
            selectedSlotObj: this.selectedSlotObj
          }
      });
    scheduler.disableClose = true;
    scheduler.afterClosed().subscribe((result: any) => {
      if(result){
        this.assignEmployeeOptions['details']['assigned_to'] = [];
        this.selectedSlotObj = result;
        const dateGroup = this.jobForm.get('jobSchedule') as UntypedFormGroup;
        if(result?.startTime){
          dateGroup.get('startDate').setValue(moment(result?.startTime, 'YYYY-MM-DD HH:mm:ss'));
        }
        if(result?.endTime){
          dateGroup.get('endDate').setValue(moment(result?.endTime, 'YYYY-MM-DD HH:mm:ss'));
        }
        if(result?.timezone){
          dateGroup.get('job_timezone').setValue(result?.timezone,{emitEvent: false});
        }
        const selectedUser = {
          user: '',
          team: ''
        };
        if(result?.user?.user_uid){
          selectedUser['user'] = result?.user;
        }
        // if(result?.team?.team_uid){
        //   selectedUser['team'] = result?.team;
        //   if(result?.user?.user_uid || result?.team?.team_uid){
        //     const assignedTo = this.assignEmployeeOptions?.['details']?.['assigned_to'];
        //     if( assignedTo?.length > 0 ) {
        //       this.assignEmployeeOptions['details']['assigned_to'] = [...assignedTo, selectedUser];
        //     }else{
        //       this.assignEmployeeOptions['details']['assigned_to'] = [selectedUser];
        //     }
        //     this.constructMasterAssignment(this.assignEmployeeOptions['details']['assigned_to']);
        //   }
        // } else 
        if(result?.user?.user_uid) {
          const filter = {
            'filter.user_uid': result?.user?.user_uid
          };
          this.getTeamSummary(filter, selectedUser);
        }
      }
    });
  }

  constructMasterAssignment(assignedTo: any[], type?: string): void {
    assignedTo.forEach((assign: any) => {
      const found = this.masterAssignmentCopy.findIndex((data: any) => (data?.user?.user_uid === assign?.user?.user_uid) && (data?.team?.team_uid === assign?.team?.team_uid));
      if(found === -1){
        this.masterAssignmentCopy.push(assign);
      }
    });
    this.getServiceTerritoryDetails();
  }

  getTeamSummary(filter: any, selectedUser: any): void {
    this._dataCollectorService.getData(this._jobsService.jobAPIUrls.teamSummaryUrl, filter).subscribe(
      (res: any) =>{
        if(res?.data?.length > 0){
          selectedUser['team'] = res?.data[0];
          const assignedTo = this.assignEmployeeOptions?.['details']?.['assigned_to'];
          if( assignedTo?.length > 0 ) {
            this.assignEmployeeOptions['details']['assigned_to'] = [...assignedTo, selectedUser];
          }else{
            this.assignEmployeeOptions['details']['assigned_to'] = [selectedUser];
          }
          this.constructMasterAssignment(this.assignEmployeeOptions['details']['assigned_to']);
        }
      }
    );
  }

  openServiceAddress(): void {
    this.trackEventAnalytics('service_address');
    const previewAddress: MatDialogRef<PreviewAddressFormComponent> = this._zuperDialogService.openCustom(PreviewAddressFormComponent,
      {
          extraClass: 'preview-address-form',
          data: {
            header: {
                titleDisplayKey: 'text.service_address',
                titleDisplayName: 'Service Address'
            },
            allowMultipleEmails: true,
            formGroupName: 'serviceAddress',
            formGroup: this.jobForm,
            value: this.currentServiceAddress
        }
      });
    previewAddress.disableClose = true;
    previewAddress.afterClosed().subscribe((result: any) => {
      if(result){
        this.utilityService.castEventToSdk(`${this.currentPage}.service_address`, {
          oldValue: this.constructAddressFields(this.currentServiceAddress),
          newValue: this.constructAddressFields(result),
        });
        this.prepareServiceAddressDetails(result);
      }else{
        this.jobForm.get('serviceAddress').setValue(this.currentServiceAddress);
        if(!this.utilityService.isEmptyOrUndefined(this.currentServiceAddress)){
          this.getServiceTerritoryDetails();
        }
      }
    });
  }

  prepareServiceAddressDetails(address: any): void{
    this.showServiceAddress = false;
    this.jobForm.get('serviceAddress').setValue(address);
    this.currentServiceAddress = address;
    if(this.sameAsServiceAddress){
      this.currentBillingAddress = address;
      const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
      billingGroup.setValue(address);
    }
    if(this.currentServiceAddress?.latitude && this.currentServiceAddress?.longitude){
      this.serviceMapOption['coords'] = [this.currentServiceAddress?.latitude, this.currentServiceAddress?.longitude];
      setTimeout(()=>{
        this.showServiceAddress = true;
      });
    }
    this.getServiceTerritoryDetails();
  }

  getServiceTerritoryDetails(): void{
    let payload: any = {
      'customer_address': {
        'zip_code': '',
        'geo_cordinates': []
      },
      'assigned_to':[]
    };

    if(!_.isEmpty(this.currentServiceAddress)){
      payload = {
        ...payload,
          'customer_address': {
          'zip_code': this.currentServiceAddress?.zipcode ?? '',
          'geo_cordinates': this.currentServiceAddress?.latitude ? [this.currentServiceAddress?.latitude,this.currentServiceAddress?.longitude] : [],
        },
      };
    }

    if(this.assignEmployeeOptions['details']['assigned_to']?.length > 0){
      payload = {
        ...payload,
        'assigned_to': this.assignEmployeeOptions['details']['assigned_to']?.map((data: any)=>({team_uid: data?.team?.team_uid,user_uid: data?.user?.user_uid}))
      };
    }

    if(this.isServiceTerritoryEnabled){
      this._jobsService.getServiceTerritoryDetails(payload).subscribe((response: any)=>{
        this.service_territory = response?.data;
        this.serviceTerritoryOptions = {
          mode: 'new',
          territory: this.service_territory
        };
        this.assignEmployeeOptions['details']['service_territory']['territory'] = this.service_territory?.matched_territory?.territory;
      });
    }

  }

  openReorder(): void {
    this.trackEventAnalytics('reorder_service_task');
    const reorderTask: MatDialogRef<TaskReorderComponent> = this._zuperDialogService.openCustom(TaskReorderComponent,
      {
        extraClass:'reorder-modal',
        data: {
          header: {
            titleDisplayKey: 'header.title.reorder_service_task',
            titleDisplayName: ''
          },
          data: this.selectedServiceTask
        }
      });
      reorderTask.disableClose = true;
      reorderTask.afterClosed().subscribe((result: any) => {
        if(result){
          this.selectedServiceTask = [...result];
        }
      });
  }

  openBillingAddress(): void {
    this.trackEventAnalytics('billing_address');
    const previewAddress: MatDialogRef<PreviewAddressFormComponent> = this._zuperDialogService.openCustom(PreviewAddressFormComponent,
      {
          extraClass: 'preview-address-form',
          data: {
            header: {
                titleDisplayKey: 'billing.address.text',
                titleDisplayName: 'Billing Address'
            },
            formGroupName: 'billingAddress',
            formGroup: this.jobForm,
            value: this.currentBillingAddress,
            allowMultipleEmails: true
        }
      });
    previewAddress.disableClose = true;
    previewAddress.afterClosed().subscribe((result: any) => {
      if(result){
        this.utilityService.castEventToSdk(
          `${this.currentPage}.billing_address`,
          {
            oldValue: this.constructAddressFields(this.currentBillingAddress),
            newValue: this.constructAddressFields(result)
          });
        this.jobForm.get('billingAddress').setValue(result);
        this.currentBillingAddress = result;
      }else{
        this.jobForm.get('billingAddress').setValue(this.currentBillingAddress);
      }
    });
  }

  getBreadCrumbConfig(): Breadcrumb {

    if(this.module === 'JOB' && this.urlState === 'new'){
      return {
         'moduleName': 'Job',
         'displayKey': 'text.jobs',
         'moduleKey': 'JOB',
         'redirectTo': 'jobs',
         'breadcrumbItems': [{
           'displayKey': 'text.new_job',
           'displayName': 'New Job'
         }],
         'breadcrumbButtons': [
          {
            'displayName': 'Cancel',
            'displayKey': 'cancel.text',
            'type': 'SINGLE',
            'icon': '',
            'style': '',
            'showIf': true,
          },
          {
            'displayName': 'Create Job',
            'displayKey': 'create.job.text',
            'type': 'SINGLE',
            'icon': 'ti ti-device-floppy',
            'style': '',
            'showIf': this.utilityService.hasPermission('job.new'),
            'isPrimary': true
          },
         ]
       };
    }else if(this.module === 'JOB' && this.urlState === 'edit'){
      return {
         'moduleName': 'Job',
         'displayKey': 'text.jobs',
         'moduleKey': 'JOB',
         'redirectTo': 'jobs',
         'breadcrumbItems': [
          {
            'displayKey':'',
            'redirectTo': `jobs/${this.uid}/details`,
            'displayName': '#' + (this.jobDetails.prefix ?? '') + (this.jobDetails.work_order_number ?? '') + ' - ' + this.jobDetails.job_title
          },
          {
           'displayKey': 'job.edit.title',
           'displayName': 'Edit Job'
         }
        ],
         'breadcrumbButtons': [
           {
             'displayName': 'Update Job',
             'displayKey': 'job.button.update',
             'type': 'SINGLE',
             'icon': 'ti ti-device-floppy',
             'style': '',
             'showIf': this.utilityService.hasPermission('job.update'),
           }
         ]
       };
    }
  }

  getRoute(): void {
    this.paramMapSubscription = this._route.paramMap.subscribe(
      (params: any)=>{
        this.uid = params.get('uid');
        const url = this._route.snapshot.url.join().split(',');
        if(url[1]){
          this.urlState = url[1];
        }else{
          this.urlState = 'new';
        }
        if(this.urlState === 'new'){
          if(!this.redirect?.state?.isDialog){
            this.breadcrumbData = this.getBreadCrumbConfig();
            this._breadcrumbService.subject.next(this.breadcrumbData);
            this._breadcrumbService.count = '';
          }
          this.setTitle();
          this.customFieldConfig = {
            expansionDisabled: false,
            originalTemplate: true,
            module:'JOB',
            page: 'new',
            hasCategory: true
          };
          setTimeout(()=>{
            this.showCustomFields = true;
          }, 1000);
          if(this.actionState === 'clone'){
            this.uid = window.history.state?.uid;
            if(!this.utilityService.isEmptyOrUndefined(this.data)){
              if(this.data?.data?.job_uid){
                this.uid = this?.data?.data?.job_uid;
              }
            }
            const jobScheduleGroup = this.jobForm.get('jobSchedule') as UntypedFormGroup;
            const jobDetailGroup = this.jobForm.get('jobDetails') as UntypedFormGroup;
            const jobPrimaryGroup = this.jobForm.get('primaryDetails') as UntypedFormGroup;

            if(this.redirect?.state?.organization){
              this.selectedOrganizations = [this.redirect?.state?.organization];
              this.prefillOrganizationAddress();
            }

            if(this.redirect?.state?.customer){
              this.selectedCustomers = [this.redirect?.state?.customer];
              this.getAllCustomerAddressDetails(this.selectedCustomers[0]?.customer_uid);
            }

            if(this.redirect?.state?.property){
              this.selectedProperty = [this.redirect?.state?.property];
              this.prefillPropertyAddress();
            }

            if(this.redirect?.state?.request){
              this.selectedRequest = [this.redirect?.state?.request];
              this.sameAsServiceAddress = false;
            }

            if(this.redirect?.state?.project){
              this.selectedProject = [this.redirect?.state?.project];
              this.isProjectRestricted = this.selectedProject[0]?.config?.product?.restrict_to_project;
            }

            if(this.redirect?.state?.job_title){
             jobDetailGroup.get('jobTitle').setValue(this.redirect?.state?.job_title);
            }

            if(this.redirect?.state?.job_description){
              jobPrimaryGroup?.get('jobDescription').setValue(this.redirect?.state?.job_description);
            }

            if(this.redirect?.state?.job_category){
              this.currentCategory = this.jobCategory.find((category: any)=>category.category_uid === this.redirect?.state?.job_category);
              this.currentCategoryId = this.redirect?.state?.job_category;
              jobPrimaryGroup?.get('category').setValue(this.redirect?.state?.job_category);
              if(this.currentCategory?.category_description && !jobPrimaryGroup?.get('jobDescription').value){
                jobPrimaryGroup?.get('jobDescription').setValue(this.currentCategory?.category_description);
              }
              this.getCategoryServiceTask(this.redirect?.state?.job_category);
            }

            if(this.redirect?.state?.scheduled_start_time){
              jobScheduleGroup.get('startDate').setValue(moment.utc(this.redirect?.state?.scheduled_start_time, 'YYYY-MM-DD HH:mm:ss').tz(this.redirect?.state?.job_timezone || this.accountTimeZone));
            }
            if(this.redirect?.state?.scheduled_end_time){
              jobScheduleGroup.get('endDate').setValue(moment.utc(this.redirect?.state?.scheduled_end_time, 'YYYY-MM-DD HH:mm:ss').tz(this.redirect?.state?.job_timezone || this.accountTimeZone));
            }

            if(this.redirect?.state?.due_date){
              jobScheduleGroup.get('dueDate').setValue(moment(this.redirect?.state?.due_date, 'YYYY-MM-DD'));
            }

            if(this.redirect?.state?.job_timezone){
              jobScheduleGroup.get('job_timezone').setValue(this.redirect?.state?.job_timezone);
            }

            if(this.redirect?.state?.customer_address){
              const address = this.redirect?.state?.customer_address;
              this.updateServiceAddress(address);
            }

            if(this.redirect?.state?.customer_billing_address){
              const address = this.redirect?.state?.customer_billing_address;
              this.updateBillingAddress(address);
            }

            if(this.redirect?.state?.job_priority){
              jobPrimaryGroup?.get('priority').setValue(this.redirect?.state?.job_priority);
            }

            if(this.redirect?.state?.job_description || this.redirect?.state?.request?.request_description){
              const description = this.redirect?.state?.job_description ?? this.redirect?.state?.request?.request_description;
              jobPrimaryGroup?.get('jobDescription').setValue(description);
            }

            if(this.redirect?.state?.job_tags?.length){
              jobPrimaryGroup?.get('tags').setValue(this.redirect?.state?.job_tags);
              this.tagsOption = {...this.tagsOption, fieldValue: this.redirect?.state?.job_tags};
              this.showTag = true;
            }


            if(this.redirect?.state?.line_items){
              this.selectedLineItems = this.redirect?.state?.line_items.map((item: any) =>({...item, product_name: item?.name, price: item?.unit_price,product_description: item?.product_description ?? item?.description}));
              this.removeSerialNumber(this.selectedLineItems);
              this.calculateTotalWithoutTax();
            }

            if(this.redirect?.state?.assigned_to){
              this.assignEmployeeOptions['details']['assigned_to'] = this.redirect?.state?.assigned_to;
              this.masterAssignmentCopy = [];
              this.constructMasterAssignment(this.assignEmployeeOptions['details']['assigned_to']);
            }

            if(this.redirect?.state?.assets){
              this.selectedAssets = [this.redirect?.state?.assets];
            }

            if(this.redirect?.state?.module === 'ASSET'){
              this.getAssetDetails(null, this.uid, true);
              this.showTag = true;
            }else if(this.redirect?.state?.module === 'SERVICE_CONTRACT'){
              this.getContractDetails(null, this.uid, true);
              this.showTag = true;
            }else if(this.redirect?.state?.module === 'ESTIMATES'){
              this.getQuotationDetails();
              this.showTag = true;
            }else if(this.redirect?.state?.module === 'ORGANIZATION'){
              this.getOrganizationDetails();
              this.showTag = true;
            }else if(this.redirect?.state?.module === 'PROPERTY'){
              this.getPropertyDetails();
              this.showTag = true;
            }else if(this.redirect?.state?.module === 'CUSTOMER'){
              this.getCustomerDetails();
              this.showTag = true;
            }else if(this.redirect?.state?.module === 'INVOICE'){
              this.getInvoiceDetails();
              this.showTag = true;
            }else if(this.redirect?.state?.module === 'PPM'){
              this.getPPMDetails();
              this.showTag = true;
            }
            else if(this.uid) {
              this.getJobDetails();
              this.showTag = true;

            }
            else{
              this.showTag = true;
            }

            if(this.isPricelistEnabled){
              const pricelistObj = this.pricelistService.constructPricelistObject(this.selectedProject[0]);
              this.setPricelist();
              if(pricelistObj){
              this.preloadedValue = [...this.preloadedValue, pricelistObj];
              this.pricelistUid = this.selectedProject[0]?.pricelist?.pricelist_uid;
                this.pricelistFormControl.disable();
                }else{
                  this.pricelist = this.getPricelist('');
                }
              }
          } else if(this.actionState === 'parent') {
            this.uid = window.history.state?.uid;
            this.getParentJobDetails();
            this.showTag = true;
          }
          else{
            this.showTag = true;
            if(this.isPricelistEnabled){

            const pricelistObj = this.pricelistService.constructPricelistObject(this.selectedProject[0]);
            if(pricelistObj){
              this.preloadedValue = [...this.preloadedValue, pricelistObj];
              this.loadLookupValues();
              this.pricelistUid = this.selectedProject[0]?.pricelist?.pricelist_uid;
              this.changePricelist(this.selectedProject[0]?.pricelist);
              this.pricelistFormControl.disable();
              }else{
                this.pricelist = this.getPricelist('');
              }
            }
          }
        }else if(this.urlState === 'edit'){
          this.uid = this._route.snapshot.paramMap.get('job_uid');
          this.setTitle();
          this._breadcrumbService.count = '';
          //call job details
        }
      });
  }

  removeSerialNumber(lineitems: any): void{
    lineitems.forEach((ele: any)=>{
      if(ele?.serial_nos?.length > 0){
        ele.serial_nos = [];
      }
      if(ele?.associated_products?.length > 0){
        ele?.associated_products?.forEach((prd: any)=>{
          if(prd?.serial_nos?.length > 0){
            prd.serial_nos = [];
          }
        });
      }
    });
  }

  getPPMDetails(): void {
    this._dataCollectorService.getData(this._ppmsService.getPPMDetails(this.uid)).subscribe(
      (res: any) => {
        const ppm = res?.data;
        const jobDetailGroup = this.jobForm.get('jobDetails') as UntypedFormGroup;
        const jobPrimaryGroup = this.jobForm.get('primaryDetails') as UntypedFormGroup;
        const jobScheduleGroup = this.jobForm.get('jobSchedule') as UntypedFormGroup;
        jobDetailGroup.get('jobTitle').setValue('Job for PPM - '+ppm?.ppm_number);
        if(ppm?.job_settings?.job_category?.category_uid){
          jobPrimaryGroup?.get('category').setValue(ppm?.job_settings?.job_category?.category_uid);
          this.currentCategory = ppm?.job_settings?.job_category;
          this.currentCategoryId = ppm?.job_settings?.job_category?.category_uid;
          if(this.currentCategory?.category_description && !this.jobForm.controls['primaryDetails'].get('jobDescription').value){
            this.jobForm.controls['primaryDetails'].get('jobDescription').setValue(this.currentCategory?.category_description);
          }
          this.jobCategoryChange();
        }
        if(ppm?.job_settings?.job_priority){
          jobPrimaryGroup?.get('priority').setValue(ppm?.job_settings?.job_priority);
        }
        if(ppm?.next_service_date){
          jobScheduleGroup.get('startDate').setValue(moment(ppm?.next_service_date));
        }
        if(ppm?.asset?.asset_uid){
          this.getPPMAssetDetails(ppm, ppm?.asset?.asset_uid);
        }
        if(ppm?.service_contract){
          this.selectedContract = [ppm?.service_contract];
        }
        if(ppm?.product){
          if(ppm?.product?.product_ref_id){
            this.selectedLineItems = [ppm?.product?.product_ref_id];
          }else if(ppm?.product?.product){
            this.selectedLineItems = [ppm?.product?.product];
          }
          this.calculateTotalWithoutTax();
        }
      }, (error: any) => {

      });
  }

  getPPMAssetDetails(ppmData: any, uid: string): void {
    this._dataCollectorService.getData(this._assetService.getAssetUrl(uid))
      .subscribe((res: any) => {
        const asset = res?.data;
        let title;
        if(asset?.asset_code){
          title = asset?.asset_code +' - ';
        }
        title += asset?.asset_name;
        const jobDetailGroup = this.jobForm.get('jobDetails') as UntypedFormGroup;
        jobDetailGroup.get('jobTitle').setValue('Job for PPM - '+title);
        this.selectedAssets = [asset];
        if(asset?.customer?.customer_uid || asset?.organization?.organization_uid){
          if(asset?.customer?.customer_uid){
            this.selectedCustomers = [asset?.customer];
            this.prefillCustomer();
          }else if(asset?.organization?.organization_uid){
            this.selectedOrganizations = [asset?.organization];
            if(res[0]?.custom_fields?.length > 0 ){
              this.customFieldValue = this.selectedOrganizations[0]?.custom_fields;
            }
            this.prefillOrganizationAddress();
          }
        }else if(ppmData?.service_contract?.contract_uid){
          this.getPPMContractDetails(ppmData?.service_contract?.contract_uid);
        }
        if(ppmData?.job_settings?.job_location){
          this.currentServiceAddress = this.populateAddressFields(ppmData?.job_settings?.job_location);
          if(this.sameAsServiceAddress){
            this.currentBillingAddress = this.populateAddressFields(ppmData?.job_settings?.job_location);
            const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
            billingGroup.setValue(this.populateAddressFields(ppmData?.job_settings?.job_location));
          }
        }
        if(ppmData?.assets){
         ppmData?.assets.forEach((element) => {
          this.selectedAssets.push(element.asset);
         });
         this.selectedAssets = this.selectedAssets.filter((item, index, self) =>
          index === self.findIndex(obj => obj.asset_uid === item.asset_uid)
        );
        }
      });
  }

  getPPMContractDetails(uid: string): void {
      this._dataCollectorService.getData(this._contractService.getContractDetails(uid)).subscribe(
        (res: any) => {
          const contract = res?.data;
          if(contract?.customer?.customer_uid){
            this.selectedCustomers = [contract?.customer];
            this.prefillCustomer();
          }else if(contract?.organization?.organization_uid){
            this.selectedOrganizations = [contract?.organization];
            if(res[0]?.custom_fields?.length > 0 ){
              this.customFieldValue = this.selectedOrganizations[0]?.custom_fields;
            }
            this.prefillOrganizationAddress();
          }
        }
      );
  }

  prefillCustomer(): void {
    if(this.selectedCustomers[0]?.custom_fields?.length > 0 ){
      this.customFieldValue = this.selectedCustomers[0]?.custom_fields;
    }

    if(this.selectedCustomers[0]?.customer_organization?.organization_uid){
      this.selectedOrganizations = [this.selectedCustomers[0]?.customer_organization];
      this.prefillOrganizationAddress();
    }

    if(!this.selectedCustomers[0]?.customer_all_addresses) {
      this.getAllCustomerAddressDetails(this.selectedCustomers[0]?.customer_uid);
    }
    else{
      this.prefillCustomerAllAddress();
    }

    if(this.selectedCustomers[0]?.customer_organization?.organization_uid && !this.selectedOrganizations?.length && !this.selectedCustomers[0]?.customer_organization?.is_deleted){
      this.selectedOrganizations = [this.selectedCustomers[0]?.customer_organization];
      if(this.selectedOrganizations[0]?.organization_address?.street){
        this.sameAsServiceAddress = false;
        const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
        this.currentBillingAddress = this.populateAddressFields(this.selectedOrganizations[0]?.organization_address);
        if(!this.currentBillingAddress?.phone){
          this.currentBillingAddress['phone']=this.getPhoneNumber();
        }
        billingGroup.setValue(this.currentBillingAddress);
      }
    }
  }


  getInvoiceDetails(): void {
    const url: string = this._invoiceService.getInvoiceUrl(this.uid);
    this._dataCollectorService.getData(url)
      .subscribe((res: any) => {
        this.prefillDetails(res?.data);
        this.prefillCustomerAllAddress();
      }, (error: any) => {
        if(error?.message){

        }
      });
  }

  getServiceTasks(): void {
    this._dataCollectorService.getData(this._jobsService.jobAPIUrls.serviceTasks,{
      'filter.module': 'JOB',
      'filter.module_uid': this.uid,
      'page': 1,
      'sort': 'ASC',
      'sort_by': 'sequence_no',
      'count': 100
      }).subscribe((res: any) => {
        const tasks = res?.data;
        if(tasks?.length > 0){
          this.serviceTaskAssets = [];
          this.selectedServiceTask = tasks.map((task: any, index: number)=>{
            if(task?.asset?.asset_uid){
              this.serviceTaskAssets[index] = task?.asset;
            }else{
              this.serviceTaskAssets[index] = null;
            }
            return {
              'sequence_no': index + 1,
              'service_task_master': task?.service_task_master_uid || null,
              'service_task_title': task?.service_task_title,
              'service_task_description': task?.service_task_description || '',
              'estimated_duration': {
                  'days': task?.estimated_duration?.days,
                  'hours': task?.estimated_duration?.hours,
                  'minutes': task?.estimated_duration?.minutes
              },
              'inspection_form': task?.inspection_form || null,
            };
          });
          this.calculateTotalMin();
        }
      },(err: any)=>{

      });
  }

  getJobDetails(): void {
    const url: string = this._jobsService.getJobUrl(this.uid);
    this._dataCollectorService.getData(url).subscribe(
      (res: any) => {
        //Form Groups
        const jobPrimaryGroup = this.jobForm.get('primaryDetails') as UntypedFormGroup;
        const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
        const serviceGroup = this.jobForm.get('serviceAddress') as UntypedFormGroup;
        const jobScheduleGroup = this.jobForm.get('jobSchedule') as UntypedFormGroup;
        const jobDetailGroup = this.jobForm.get('jobDetails') as UntypedFormGroup;

        this.jobDetails = res?.data;
        if(this.jobDetails?.service_task?.is_enabled){
          this.currentExecution = this.jobDetails?.service_task?.execution_type;
          this.getServiceTasks();
        }
        if(this.jobDetails?.assets?.length > 0 && !this.redirect?.state?.assets){
          this.selectedAssets = this.jobDetails?.assets.map((asset: any) => asset.asset);
        }
        if(this.jobDetails?.organization && !this.redirect?.state?.organization){
          this.selectedOrganizations = [this.jobDetails?.organization];
          this.prefillOrganizationAddress();
          this.getOrgDetails(this.jobDetails?.organization?.organization_uid, false);
        }
        if(this.jobDetails?.customer && !this.redirect?.state?.customer){
          this.selectedCustomers = [this.jobDetails?.customer];
          this.setCustomerTimeZone();
          this.getAllCustomerAddressDetails(this.selectedCustomers[0]?.customer_uid);
        }
        if(this.jobDetails?.secondary_customers && !this.redirect?.state?.secondary_customers){
          let associatedCustomers = [];
          if (this.jobDetails?.secondary_customers?.length > 0) {
            associatedCustomers = _.map(this.jobDetails.secondary_customers, 'customer');
          }
          this.selectedSecondaryContacts = associatedCustomers;
        }
        if(this.jobDetails?.property && !this.redirect?.state?.property){
          this.selectedProperty = [this.jobDetails?.property];
          this.prefillPropertyAddress();
        }
        if(this.jobDetails?.request && !this.redirect?.state?.request){
          this.selectedRequest = [this.jobDetails?.request];
        }
        if(this.jobDetails?.service_contract){
          this.selectedContract = [this.jobDetails?.service_contract];
        }
        if(this.jobDetails?.project){
          this.selectedProject = [this.jobDetails?.project];
        }
        if(this.jobDetails?.customer_address && !this.redirect?.state?.customer_address){
          this.currentServiceAddress = this.populateAddressFields(this.jobDetails?.customer_address);
          serviceGroup.setValue(this.currentServiceAddress);
          this.getServiceTerritoryDetails();
        }
        if(this.jobDetails?.customer_address?.geo_cordinates?.length > 0 && !this.redirect?.state?.customer_address){
          this.showServiceAddress = false;
          this.serviceMapOption['coords'] = this.jobDetails?.customer_address?.geo_cordinates;
          setTimeout(()=>{
            this.showServiceAddress = true;
          });
        }
        if(this.jobDetails?.customer_billing_address && !this.redirect?.state?.customer_billing_address){
          this.sameAsServiceAddress = false;
          this.currentBillingAddress = this.populateAddressFields(this.jobDetails?.customer_billing_address);
          billingGroup.setValue(this.currentBillingAddress);
        }

        if(this.jobDetails?.job_description && !this.redirect?.state?.job_description){
          jobPrimaryGroup?.get('jobDescription').setValue(this.jobDetails?.job_description);
        }

        if(this.jobDetails?.attachments?.length > 0){
          this.attachments = this.jobDetails.attachments.map((attachment: any) => (
            {
              'file_name': attachment?.file_name || '',
              'file_url': attachment?.url || ''
            }
          ));
        }

        if(!this.jobDetails?.job_category?.is_deleted && !this.redirect?.state?.job_category){
          jobPrimaryGroup?.get('category').setValue(this.jobDetails?.job_category?.category_uid);
          this.currentCategory = this.jobCategory.find((category: any)=>category.category_uid === this.jobDetails?.job_category?.category_uid);
          this.currentCategoryId = this.jobDetails?.job_category?.category_uid;
          if(this.currentCategory?.category_description && !this.jobForm.controls['primaryDetails'].get('jobDescription').value){
            this.jobForm.controls['primaryDetails'].get('jobDescription').setValue(this.currentCategory?.category_description);
          }
        }

        if(this.jobDetails?.custom_fields?.length > 0 ){
          setTimeout(()=>{
            this.customFieldValue = this.jobDetails?.custom_fields;
          }, 2000);
        }

        if(this.jobDetails?.job_timezone && !this.redirect?.state?.job_timezone){
          jobScheduleGroup.get('job_timezone').setValue(this.jobDetails?.job_timezone);
        }

        if(this.jobDetails?.due_date && !this.redirect?.state?.due_date){
          jobScheduleGroup.get('dueDate').setValue(moment(this.jobDetails?.due_date));
        }

        if(this.jobDetails?.job_priority && !this.redirect?.state?.job_priority){
          jobPrimaryGroup?.get('priority').setValue(this.jobDetails?.job_priority);
        }
        if(this.jobDetails?.job_tags?.length && !this.redirect?.state?.job_tags){
          jobPrimaryGroup?.get('tags').setValue(this.jobDetails?.job_tags);
          this.tagsOption = {...this.tagsOption, fieldValue: this.jobDetails?.job_tags};
        }
        this.showTag = true;
        if(!this.redirect?.state?.job_title){
          jobDetailGroup.get('jobTitle').setValue(this.jobDetails?.job_title);
        }
        if(this.jobDetails?.parent_job){
          const parentJobData = '#' + (this.jobDetails?.prefix ?? '') + (this.jobDetails?.work_order_number ?? '') + ' - ' + this.jobDetails.job_title;
          jobPrimaryGroup?.get('parent').setValue(parentJobData);
          this.selectedJob = [this.jobDetails?.parent_job];
        }
        if(this.jobDetails?.job_type){
          jobPrimaryGroup?.get('jobType').setValue(this.jobDetails?.job_type);
          this.jobTypeChange(false);
        }
        if(this.jobDetails?.prefix){
          jobDetailGroup.get('prefix').setValue(this.jobDetails?.prefix);
        }
        if(this.jobDetails?.products?.length > 0) {
          this.selectedLineItems = this.jobDetails?.products;
          this.removeSerialNumber(this.selectedLineItems);
          this.calculateTotalWithoutTax();
        }
        if(this.isPricelistEnabled){
          if(!this.jobDetails?.project?.pricelist?.is_deleted && this.jobDetails?.project?.pricelist?.is_active && this.jobDetails?.project?.pricelist?.pricelist_uid){
            const pricelistObj = this.pricelistService.constructPricelistObject(this.jobDetails?.project);
            if(pricelistObj){
              this.preloadedValue = [...this.preloadedValue, pricelistObj];
              this.loadLookupValues();
              this.pricelistUid = this.jobDetails?.project?.pricelist?.pricelist_uid;
              this.changePricelist(this.jobDetails?.project?.pricelist);
              this.pricelistFormControl.disable();
            }
          }else if(!this.jobDetails?.pricelist?.is_deleted && this.jobDetails?.pricelist?.is_active  && this.jobDetails?.pricelist?.pricelist_uid ){
            const pricelistObj = this.pricelistService.constructPricelistObject(this.jobDetails);
            if(pricelistObj){
              this.preloadedValue = [...this.preloadedValue, pricelistObj];
              this.loadLookupValues();
              this.pricelistUid = this.jobDetails?.pricelist?.pricelist_uid;
              setTimeout(() => {
                this.pricelistFormControl.setValue(this.jobDetails?.pricelist?.pricelist_uid ?? null);
                this._changeDetectorRef.markForCheck();
              }, 200);
            }
          }else{
            this.pricelist = this.getPricelist('');
          }
        }
        if(this.jobDetails?.scheduled_start_time && !this.redirect?.state?.scheduled_start_time){
          jobScheduleGroup.get('startDate').setValue(moment(this.jobDetails?.scheduled_start_time));
        }
        if(this.jobDetails?.scheduled_end_time && !this.redirect?.state?.scheduled_end_time){
          jobScheduleGroup.get('endDate').setValue(moment(this.jobDetails?.scheduled_end_time));
        }
        if(this.jobDetails?.skills?.length > 0){
          this.skillValue = this.jobDetails.skills.map((skill: any) => (skill?.skill_uid));
          this.currentCategorySkills = this.jobDetails?.skills;
          this.assignEmployeeOptions['details']['skills'] = this.currentCategorySkills;
        }else if(this.actionState === 'clone'){
          this.getCategorySkills();
        }
        if(this.jobDetails?.is_recurrence && this.jobDetails?.recurring_job  && !this.redirect?.state?.prefillRrule && !this.redirect?.state?.disableRecurrence){
          this.currentRruleCount = this.jobDetails?.recurring_job?.job_count;
          jobScheduleGroup.get('recurrence').setValue(true);

          this.currentRruleValue = {
            'rrule': this.jobDetails?.recurring_job?.rrule,
            'duration': this.jobDetails?.recurring_job?.duration,
            'startFrom': moment(this.jobDetails?.recurring_job?.job_start).format(this.dateFormat),
            'startTime': moment(this.jobDetails?.recurring_job?.job_start).format(this.timeFormat),
            'endTime': moment(this.jobDetails?.recurring_job?.job_end).format(this.timeFormat),
          };
          if(this.currentRruleValue?.rrule){
            const dates = rrulestr(this.currentRruleValue.rrule).all();
            if(dates?.length > 0){
              this.currentRruleDates = [];
              dates.forEach((date: any) => {
                const selectedDate = moment(date).format('YYYY-MM-DD');
                this.currentRruleDates.push({
                  scheduled_end_time: moment(selectedDate+' '+ this.currentRruleValue?.endTime, 'YYYY-MM-DD '+this.timeFormat).utc().format('YYYY-MM-DD HH:mm:ss'),
                  scheduled_start_time: moment(selectedDate+' '+ this.currentRruleValue?.startTime, 'YYYY-MM-DD '+this.timeFormat).utc().format('YYYY-MM-DD HH:mm:ss')
                });
              });
              this.currentRruleCount = this.currentRruleDates?.length;
            }else{
              this.currentRruleDates = [];
              this.currentRruleCount = 0;
            }
          }
          const rruleGroup = jobScheduleGroup.get('rruleForm') as UntypedFormGroup;
          const durationGroup = rruleGroup.get('duration') as UntypedFormGroup;
          durationGroup.get('value').setValue(moment(this.jobDetails?.recurring_job?.duration?.value));
          durationGroup.get('type').setValue(moment(this.jobDetails?.recurring_job?.duration?.type));
          rruleGroup.get('rrule').setValue(moment(this.jobDetails?.recurring_job?.rrule));
        }
      },(err)=>{

      });
    }

  getParentJobDetails(): void {
    const url: string = this._jobsService.getJobUrl(this.uid);
    this._dataCollectorService.getData(url).subscribe(
      (res: any) => {
        //Form Groups
        const jobPrimaryGroup = this.jobForm.get('primaryDetails') as UntypedFormGroup;
        const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
        const serviceGroup = this.jobForm.get('serviceAddress') as UntypedFormGroup;
        const jobDetailGroup = this.jobForm.get('jobDetails') as UntypedFormGroup;

        const jobDetails = res?.data;
        if(jobDetails?.assets?.length > 0){
          this.selectedAssets = jobDetails?.assets.map((asset: any) => asset.asset);
        }
        if(jobDetails?.custom_fields?.length > 0 ){
          this.customFieldValue = jobDetails?.custom_fields;
        }
        if(jobDetails?.organization){
          this.selectedOrganizations = [jobDetails?.organization];
        }
        if(jobDetails?.customer){
          this.selectedCustomers = [jobDetails?.customer];
        }
        if(jobDetails?.property){
          this.selectedProperty = [jobDetails?.property];
        }
        if(jobDetails?.service_contract){
          this.selectedContract = [jobDetails?.service_contract];
        }
        if(jobDetails?.customer_address){
          this.currentServiceAddress = this.populateAddressFields(jobDetails?.customer_address);
          serviceGroup.setValue(this.currentServiceAddress);
          this.getServiceTerritoryDetails();
        }
        if(jobDetails?.customer_address?.geo_cordinates?.length > 0){
          this.showServiceAddress = false;
          this.serviceMapOption['coords'] = jobDetails?.customer_address?.geo_cordinates;
          setTimeout(()=>{
            this.showServiceAddress = true;
          });
        }
        if(jobDetails?.customer_billing_address){
          this.sameAsServiceAddress = false;
          this.currentBillingAddress = this.populateAddressFields(jobDetails?.customer_billing_address);
          billingGroup.setValue(this.currentBillingAddress);
        }
        if(jobDetails?.job_description) {
          jobPrimaryGroup?.get('jobDescription').setValue(jobDetails?.job_description)
        }

        const parentJobData = '#' + (jobDetails?.prefix ?? '') + (jobDetails?.work_order_number ?? '') + ' - ' + jobDetails?.job_title;
        jobPrimaryGroup?.get('parent').setValue(parentJobData);
        this.selectedJob = [jobDetails];

        if(jobDetails?.prefix){
          jobDetailGroup.get('prefix').setValue(jobDetails?.prefix);
        }
        if(this.isPricelistEnabled){
          if( !jobDetails?.pricelist?.is_deleted && jobDetails?.pricelist?.is_active && jobDetails?.pricelist?.pricelist_uid){
            this.currentPricelistObj = this.pricelistService.constructPricelistObject(jobDetails);
            if(this.currentPricelistObj){
              this.pricelist = this.getPricelist('', this.currentPricelistObj);
              this.pricelistUid = jobDetails?.pricelist?.pricelist_uid;
              this.pricelistFormControl.setValue(jobDetails.pricelist.pricelist_uid);
            }
          }else{
            this.pricelist = this.getPricelist('');
          }
        }
      },(err)=>{

      });
    }

  setDate(group: UntypedFormGroup, picker: any, name: string): void {
    const date = group?.controls[name];
    const value =  date?.value && date?.status.toLowerCase() === 'valid' && date?.value !== undefined ?
    this.utilityService.getNextQuarterHour(moment(date?.value)) : moment(this.utilityService.getNextQuarterHour(moment(), true));
    picker.select(value)
  }

  hasDates(): boolean {
    const scheduleGroup  = this.jobForm.get('jobSchedule') as UntypedFormGroup;
    return scheduleGroup.get('startDate').value || scheduleGroup.get('endDate').value || scheduleGroup.get('dueDate').value;
  }

  startDateChange(): void {
    const scheduleGroup  = this.jobForm.get('jobSchedule') as UntypedFormGroup;
    if(scheduleGroup.get('startDate').value){
      this.jobScheduled = true;
      scheduleGroup.get('endDate').setValue(scheduleGroup.get('startDate').value);
      this.rruleForm.get('startFrom').setValue(scheduleGroup.get('startDate').value);
      this.rruleForm.get('startTime').setValue(moment(scheduleGroup.get('startDate').value).clone().format(this.timeFormat));
      this.rruleForm.get('endTime').setValue(moment(scheduleGroup.get('startDate').value).clone().format(this.timeFormat));
      const filter = {
        'filter.from_date': moment(scheduleGroup.get('startDate').value).format('YYYY-MM-DD HH:mm:ss'),
        'filter.to_date': moment(scheduleGroup.get('endDate').value).format('YYYY-MM-DD HH:mm:ss')
      };
      if(this.selectedCustomers?.length){
        // this.setDueDate();
        filter['filter.customer'] = this.selectedCustomers[0]['customer_uid'];
        this.getConflictingJobs(filter);
      }else if(this.selectedOrganizations?.length){
        filter['filter.customer_organization'] = this.selectedOrganizations[0]['organization_uid'];
        this.getConflictingJobs(filter);
      }
    }
    if(this.jobCategory){
      this.categoryChange(true);
    }
    this.calculateScheduleDuration();
    if(scheduleGroup.get('endDate')?.value){
      this.assignEmployeeOptions['details']['scheduled_end_time'] = this.timeZone ? moment.tz(moment(scheduleGroup.get('endDate')?.value).format('YYYY-MM-DD HH:mm:ss'), this.timeZone).utc().format('YYYY-MM-DD HH:mm:ss')
      : moment(scheduleGroup.get('endDate')?.value).utc().format('YYYY-MM-DD HH:mm:ss');
    }
    if(scheduleGroup.get('startDate')?.value){
      this.assignEmployeeOptions['details']['scheduled_start_time'] = this.timeZone ? moment.tz(moment(scheduleGroup.get('startDate')?.value).format('YYYY-MM-DD HH:mm:ss'), this.timeZone).utc().format('YYYY-MM-DD HH:mm:ss')
      : moment(scheduleGroup.get('startDate')?.value).utc().format('YYYY-MM-DD HH:mm:ss');
    }
    this.setAccountTimeZoneValue();
  }

  calculateScheduleDuration(): void {
    const scheduleGroup  = this.jobForm.get('jobSchedule') as UntypedFormGroup;
    const startDate = scheduleGroup.get('startDate').value;
    const endDate = scheduleGroup.get('endDate').value;
    const diff = moment(endDate).diff(startDate,'m');
    this.jobScheduleMinutes = diff;
    this.jobScheduleDuration = {
      'days': this.getDays(diff),
      'hours': this.getHours(diff),
      'minutes': this.getMin(diff)
    };
  }

  showScheduleDurationAlert(): boolean {
    const scheduleGroup  = this.jobForm.get('jobSchedule') as UntypedFormGroup;
    const startDate = scheduleGroup.get('startDate').value;
    const endDate = scheduleGroup.get('endDate').value;
    if(startDate && endDate && this.serviceTaskMinutes){
      return this.jobScheduleMinutes < this.serviceTaskMinutes;
    }else{
      return false;
    }
  }

  endDateChange(): void {
    const scheduleGroup  = this.jobForm.get('jobSchedule') as UntypedFormGroup;
    if(scheduleGroup.get('endDate').value && scheduleGroup.get('startDate').value){
      const filter = {
        'filter.from_date': moment(scheduleGroup.get('startDate').value).format('YYYY-MM-DD HH:mm:ss'),
        'filter.to_date': moment(scheduleGroup.get('endDate').value).format('YYYY-MM-DD HH:mm:ss')
      };
      if(this.selectedCustomers?.length){
        filter['filter.customer'] = this.selectedCustomers[0]['customer_uid'];
        this.getConflictingJobs(filter);
      }else if(this.selectedOrganizations?.length){
        filter['filter.customer_organization'] = this.selectedOrganizations[0]['organization_uid'];
        this.getConflictingJobs(filter);
      }
    }
    this.setAccountTimeZoneValue();
    this.calculateScheduleDuration();
  }

  getConflictingJobs(filter: any): void {
    filter.count = 50;
    this._dataCollectorService.getData(this._dataCollectorService.baseurl() + '/jobs', filter)
      .subscribe(
        (jobs: any) => {
          this.conflictingJobs = jobs?.total_records;
          this.conflictingJobData = jobs?.data;
        });
  }

  viewJobs(): void {
      this.currentPickerModule = 'JOB';
      const pickerOptions = {
        position: 'right',
        mode: 'over',
        hasBackDrop: false,
        allowQuickCreate: false,
        showCustomDataOnly: true,
        showListCount: true,
        header: {
          displayKey: 'header.jobs.conflicting_jobs',
          displayeName: 'Conflicting Jobs',
        }
      };
      pickerOptions['enableDataTab'] = true;
      pickerOptions['data'] = this.conflictingJobData;
      pickerOptions['selectOption'] = PickerSelectOptions.readOnly;
      this.currentPickerOptions = pickerOptions;
      this.openDataPicker = true;
  }

  recurrenceChange(): void {
    if(this.showUpdateRecurrence()) {
      this.openUpdateRecurrence();
    }
    else {
      const scheduleGroup  = this.jobForm.get('jobSchedule') as UntypedFormGroup;
      scheduleGroup.get('rruleForm').enable();
      this.rruleForm.reset();
      const durationGroup = this.rruleForm.get('duration') as UntypedFormGroup;
      durationGroup.get('value').setValue(1);
      durationGroup.get('type').setValue('DAYS');
      this.rruleForm.get('rrule').setValue('');
      this.rruleDateOptions = {
        hasJob: false
      };
      this.currentRruleValue = null;
      this.currentRruleDates = [];
      this.currentRruleCount = 0;
      this.jobs = null;
    }
  }

  openUpdateRecurrence(): void {
    if(this.activeDates?.length){
      this.jobs = [...this.activeDates];
    }
    this.openPicker=true;
    if(this.openPicker){
      this.oldRruleFormvalue = this.rruleForm.value;
      this._zuperDrawerService.getComponent('recurringDrawer').open();
    }else{
      this._zuperDrawerService.getComponent('recurringDrawer').close();
    }
  }

  showUpdateRecurrence(): boolean {
    const scheduleGroup = this.jobForm.get('jobSchedule') as UntypedFormGroup;
    return scheduleGroup.get('recurrence').value;
  }

  drawerOpenedChanged(event: any): void{
    const scheduleGroup  = this.jobForm.get('jobSchedule') as UntypedFormGroup;
    const tz = scheduleGroup.get('job_timezone').value;
    if(event && this.currentRruleValue){
      this.rruleForm.get('startFrom').setValue(moment.tz(moment(scheduleGroup.get('startDate')?.value).format('YYYY-MM-DD HH:mm:ss'), tz));
      this.rruleForm.get('startTime').setValue(moment.tz(moment(scheduleGroup.get('startDate')?.value).format('YYYY-MM-DD HH:mm:ss'), tz));
      this.rruleForm.get('endTime').setValue(moment.tz(moment(scheduleGroup.get('endDate')?.value).format('YYYY-MM-DD HH:mm:ss'), tz));
      this.rruleForm.get('rrule').setValue(this.currentRruleValue.rrule);
      const durationGroup = this.rruleForm.get('duration') as UntypedFormGroup;
      durationGroup.get('value').setValue(this.currentRruleValue.duration.value);
      durationGroup.get('type').setValue(this.currentRruleValue.duration.type);
    }else if(event){
      if(scheduleGroup.get('startDate')?.value){
        this.rruleForm.get('startFrom').setValue(moment.tz(moment(scheduleGroup.get('startDate')?.value).format('YYYY-MM-DD HH:mm:ss'), tz));
        this.rruleForm.get('startTime').setValue(moment.tz(moment(scheduleGroup.get('startDate')?.value).format('YYYY-MM-DD HH:mm:ss'), tz));
        this.rruleForm.get('endTime').setValue(moment.tz(moment(scheduleGroup.get('endDate')?.value).format('YYYY-MM-DD HH:mm:ss'), tz));
        this.rruleForm.get('rrule').setValue('');
        const durationGroup = this.rruleForm.get('duration') as UntypedFormGroup;
        durationGroup.get('value').setValue(1);
        durationGroup.get('type').setValue('DAYS');
      }else{
        this.rruleForm.reset();
        const durationGroup = this.rruleForm.get('duration') as UntypedFormGroup;
        durationGroup.get('value').setValue(1);
        durationGroup.get('type').setValue('DAYS');
        this.rruleForm.get('rrule').setValue('');
      }
    }else if(!event){
      if(this.rruleDateOptions?.rrule && this.currentRruleValue?.rrule){
        this.rruleDateOptions.rrule = this.currentRruleValue?.rrule;
      }
    }

    if(this.utilityService.isTimeZoneEnabled){
      this.rruleForm.addControl('job_timezone',new UntypedFormControl(tz));
    }

    this.openPicker = event;
    if (this.openPicker) {
      this._zuperDrawerService.getComponent('recurringDrawer').open();
    } else {
      this._zuperDrawerService.getComponent('recurringDrawer').close();
    }
  }

  getRrule(event: any): void {
    if(event?.rrule && event?.date){
      if(this.selectedContract?.[0]?.contract_uid){
        const contractEndDate = moment(this.selectedContract[0]?.end_date).format('YYYYMMDDTHHmmss');
        const recurrenceEndDate = moment(event?.toDate).format('YYYYMMDDTHHmmss');
        if(moment(contractEndDate, 'YYYYMMDDTHHmmss').isBefore(moment(recurrenceEndDate, 'YYYYMMDDTHHmmss'))){
          event.rrule = this.updateRRuleKey(event?.rrule, this.selectedContract[0]?.end_date);
          this.showContractAlert = true;
        }
        else {
          this.showContractAlert = false;
        }
      }
      this.activeRrule = event?.rrule;
      const options = {...this.rruleDateOptions};
      options.rrule = event?.rrule;
      options.startTime = this.rruleForm.get('startTime').value;
      options.endTime = this.rruleForm.get('endTime').value;
      this.rruleDateOptions = {...options};
    }
  }

  selectRrule(): void {
    this.currentRruleValue = this.rruleForm.value;
    if(this.currentRruleValue){
      this.currentRruleValue.rrule = this.activeRrule;
      const dates = rrulestr(this.currentRruleValue.rrule).all();
      if(dates?.length > 0){
        this.currentRruleDates = [];
        dates.forEach((date: any) => {
          const selectedDate = moment(date).format('YYYY-MM-DD');
          this.currentRruleDates.push({
            scheduled_end_time: moment(selectedDate+' '+ this.currentRruleValue?.endTime, 'YYYY-MM-DD '+this.timeFormat).utc().format('YYYY-MM-DD HH:mm:ss'),
            scheduled_start_time: moment(selectedDate+' '+ this.currentRruleValue?.startTime, 'YYYY-MM-DD '+this.timeFormat).utc().format('YYYY-MM-DD HH:mm:ss')
          });
        });
        this.currentRruleCount = this.currentRruleDates?.length;
      }else{
        this.currentRruleDates = [];
        this.currentRruleCount = 0;
      }
    }
    this.closeDrawer();
  }

  saveRrule(): void {
    this.dateGroup.markAllAsTouched();
    this.rruleForm.markAllAsTouched();
    
    if (this.dateGroup.invalid || this.rruleForm.invalid) {
      return;
    }
  
    this.currentRruleValue = this.rruleForm.value;
    this.utilityService.castEventToSdk(`${this.currentPage}:job_recurrence`, {
      oldValue: this.utilityService.convertMomentToDate(this.oldRruleFormvalue),
      newValue: this.utilityService.convertMomentToDate(this.currentRruleValue)
    });
    this.currentRruleValue.rrule = this.activeRrule;
    const dateArray = this.dateGroup.value.dates;
    this.activeDates = [...this.dateGroup.value.dates];
    if (dateArray.length > 0){
      this.currentRruleDates = [];
      const jobScheduleGroup = this.jobForm.get('jobSchedule') as UntypedFormGroup;  
      const date = moment.utc(dateArray[0].date).tz(this.timeZone, true);
      const endDate = moment.utc(dateArray[dateArray.length - 1].date).tz(this.timeZone, true);
      const startTime = moment(dateArray[0].startTime, this.timeFormat).format('HH:mm:ss');
      const endTime = moment(dateArray[0].endTime, this.timeFormat).format('HH:mm:ss');
      jobScheduleGroup.patchValue({
        startDate: moment.tz(`${date.format('YYYY-MM-DD')} ${startTime}`, 'YYYY-MM-DD HH:mm:ss', this.timeZone),
        endDate: moment.tz(`${endDate.format('YYYY-MM-DD')} ${endTime}`, 'YYYY-MM-DD HH:mm:ss', this.timeZone)
      }, { emitEvent: false });
      
      this.jobs = [...dateArray];
      this.currentRruleDates = dateArray.map((dateObj: any) => {
        const dateRrule = moment.utc(dateObj.date).tz(this.timeZone, true).format('YYYY-MM-DD');
        const startTimeRrule = moment(dateObj.startTime, this.timeFormat).format('HH:mm:ss');
        const endTimeRrule = moment(dateObj.endTime, this.timeFormat).format('HH:mm:ss');
        return {
          'scheduled_start_time': moment.tz(`${dateRrule} ${startTimeRrule}`, 'YYYY-MM-DD HH:mm:ss', this.timeZone).utc().format('YYYY-MM-DD HH:mm:ss'),
          'scheduled_end_time':  moment.tz(`${dateRrule} ${endTimeRrule}`, 'YYYY-MM-DD HH:mm:ss', this.timeZone).utc().format('YYYY-MM-DD HH:mm:ss')
        };
      });
      this.currentRruleCount = this.currentRruleDates?.length;
      this.rruleDateOptions['hasJob'] = true;
    } else {
      this.currentRruleDates = [];
      this.currentRruleCount = 0;
      this.rruleDateOptions['hasJob'] = false;
    }

    this.showContractAlertDisplay = this.showContractAlert;
    this.closeDrawer();
  }

  // dataPickerEventHandler(event: any): void {
  //     this.openPicker = false;
  //     this.rruleForm.setValue(this.currentRruleValue);
  // }

  getAddressFormGroup(): UntypedFormGroup {
    return new UntypedFormGroup({
      'firstName': new UntypedFormControl(''),
      'lastName': new UntypedFormControl(''),
      'email': new UntypedFormControl('', Validators.email),
      'phone': new UntypedFormControl(''),
      'street': new UntypedFormControl('', Validators.required),
      'landmark': new UntypedFormControl(''),
      'city': new UntypedFormControl('', Validators.required),
      'state': new UntypedFormControl(''),
      'latitude': new UntypedFormControl(''),
      'longitude': new UntypedFormControl(''),
      'country': new UntypedFormControl(''),
      'zipcode': new UntypedFormControl('')
    });
  }

  constructForm(): void {
    this.jobForm = new UntypedFormGroup({
      'jobDetails': new UntypedFormGroup({
        'prefix': new UntypedFormControl(this.companyConfig?.jobs?.prefix),
        'jobTitle': new UntypedFormControl('', Validators.required)
      }),
      'jobSchedule': new UntypedFormGroup({
        'dueDate': new UntypedFormControl(''),
        'startDate': new UntypedFormControl(null),
        'job_timezone': new UntypedFormControl(this.defaultTimeZone),
        'endDate': new UntypedFormControl(null),
        'recurrence': new UntypedFormControl(''),
        'rruleForm': new UntypedFormGroup({
          'startFrom': new UntypedFormControl('', Validators.required),
          'duration': new UntypedFormGroup({
            'value': new UntypedFormControl(1, Validators.required),
            'type': new UntypedFormControl('DAYS', Validators.required),
          }),
          'startTime': new UntypedFormControl(null, Validators.required),
          'endTime': new UntypedFormControl(null, Validators.required),
          'rrule': new UntypedFormControl('')
        })
      }),
      'serviceAddress': this.getAddressFormGroup(),
      'billingAddress': this.getAddressFormGroup(),
      'primaryDetails': new UntypedFormGroup({
        'category': new UntypedFormControl('', Validators.required),
        'priority': new UntypedFormControl('LOW'),
        'parent': new UntypedFormControl(''),
        'jobType': new UntypedFormControl('NEW'),
        'tags': new UntypedFormControl(''),
        'jobDescription': new UntypedFormControl('')
      }),
      'customFields': new UntypedFormGroup({})
    });
    const rruleGroup = this.jobForm.get('jobSchedule') as UntypedFormGroup;
    this.rruleForm = rruleGroup.get('rruleForm') as UntypedFormGroup;
    if(this.redirect?.state?.isRecurrence){
      this.jobForm.controls['jobSchedule'].get('recurrence').setValue(true);
    }else if( (this.redirect?.state?.isRecurringJob === false) && (this.redirect?.state?.project)){
      this.jobForm.controls['jobSchedule'].get('recurrence').setValue('');
    }
    this.subscribeFormValueChangesForSDKListeners();
  }

  closeDrawer(): void {
    this.openPicker = false;
    if(this.openPicker){
      this._zuperDrawerService.getComponent('recurringDrawer').open();
    }else{
      this._zuperDrawerService.getComponent('recurringDrawer').close();
    }
    if(this.rruleDateOptions?.rrule && this.currentRruleValue?.rrule){
      this.rruleDateOptions.rrule = this.currentRruleValue?.rrule;
    }
    // const drawer = this._zuperDrawerService.getComponent('recurringDrawer');
    // drawer.close();
  }

  getJobCategory(): void {
    this._dataCollectorService.getData(this._pickerService.pickerAPIUrls.jobsCategoryUrl).subscribe((response: any) => {
      this.jobCategory = response.data;
      this.getRoute();
    }, (error: any) => {

    });
  }

  openNewCategory(): void {
    this.trackEventAnalytics('new_category');
    const category: MatDialogRef<NewCategoryComponent> = this._zuperDialogService.openCustom(NewCategoryComponent,
      {
          extraClass: 'new-category-form',
          data: {}
      });
      category.disableClose = true;
      category.afterClosed().subscribe((result: any) => {
      if(result){
        this.jobCategory.push(result?.category);
        const categoryGroup = this.jobForm.get('primaryDetails') as UntypedFormGroup;
        categoryGroup.get('category').setValue(result?.category?.category_uid);
      }
    });
  }

  jobTypeChange(isShowAlert): void {
    const group = this.jobForm.get('primaryDetails') as UntypedFormGroup;
    if(group.get('jobType').value === 'REVISIT' && this.selectedCustomers?.length === 0 && this.selectedOrganizations?.length === 0) {
      group.get('jobType').setValue('NEW');
      if(isShowAlert) {
        this._toast.error(this.utilityService.getLocaleValue('estimate.error.choose_customer_organization'));
      }
    }
    if(group.get('jobType').value === 'REVISIT'){
      if(!group.get('parent').hasValidator(Validators.required)){
        group.get('parent').addValidators([Validators.required]);
        group.get('parent').updateValueAndValidity();
      }
      this.showParentMandatory = true;
    }else{
      if(group.get('parent').hasValidator(Validators.required)){
        group.get('parent').removeValidators([Validators.required]);
        group.get('parent').updateValueAndValidity();
      }
      this.showParentMandatory = false;
    }
  }

  disableField(): boolean {
    if(this.selectedCustomers[0]?.customer_uid || this.selectedOrganizations[0]?.organization_uid){
      return false;
    }else{
      return true;
    }
  }

  disableRequestField(): boolean {
    if(this.selectedCustomers[0]?.customer_uid){
      return false;
    }else{
      return true;
    }
  }

  disableProjectField(): boolean {
    if(this.selectedCustomers[0]?.customer_uid || this.selectedOrganizations[0]?.organization_uid){
      return false;
    }else{
      return true;
    }
  }

  disableSecondaryContactField(): boolean {
    if(this.selectedOrganizations[0]?.organization_uid || this.selectedCustomers[0]?.customer_uid){
      return false;
    }else{
      return true;
    }
  }

  getSkills(): void {
    this._dataCollectorService.getData(this._jobsService?.jobAPIUrls?.skills).subscribe(
      (res: any) => {
        this.skillOptions = res?.data?.map((data: any)=>({key: data?.skillset_name, value: data?.skillset_uid}));
      }
    );
  }

  getCategorySkills(): void {
    this._dataCollectorService.getData(this._jobsService?.jobAPIUrls?.jobsUrl+`/${this.currentCategory?.category_uid}/skill`).subscribe(
      (res: any) => {
        this.currentCategorySkills = res.data;
        if(this.currentCategorySkills?.length > 0){
          this.skillValue = this.currentCategorySkills.map((skill: any) => skill?.skillset?.skillset_uid);
          this.assignEmployeeOptions['details']['skills'] = this.currentCategorySkills;
        }else{
          this.skillValue = [];
        }
      },
      (err: any) => {

      }
    );
  }

  getCategoryServiceTask(uid: string): void {
    this._dataCollectorService.getData(this._jobsService.getCategoryServiceTask(uid))
      .subscribe((res: any) => {
        const data = res?.data;
        this.selectedServiceTask = [];
        if(data?.service_execution_type){
          this.currentExecution = data?.service_execution_type;
        }
        if(data?.service_tasks?.length > 0){
          this.selectedServiceTask = [...this.selectedServiceTask, ...data?.service_tasks.map((task: any) => task?.service_task)];
        }
        this.calculateTotalMin();
      });
  }

  jobCategoryChange(): void{
    const jobPrimaryGroup = this.jobForm.get('primaryDetails') as UntypedFormGroup;
    const jobDescriptionControl = jobPrimaryGroup?.get('jobDescription');
    if ((this.isServiceTaskEnabled && this.selectedServiceTask?.length) || jobDescriptionControl?.value) {
      this.isDescriptionModified = true;
    } else {
      this.isDescriptionModified = false;
    }

    if(this.isDescriptionModified){

      const jobCategoryUpdate: MatDialogRef<JobCategoryUpdateDialogComponent> = this._zuperDialogService.openCustom(JobCategoryUpdateDialogComponent,
        {
        extraClass: 'new-category-form',
        data: {
          title: this.isServiceTaskEnabled ? 'text.update_description_and_service_tasks.title' : 'job.details.actions.description',
          updateKey: this.isServiceTaskEnabled ? 'text.update_description_and_service_tasks' : 'text.update_description',
          retainKey: this.isServiceTaskEnabled ? 'text.retain_description_and_service_tasks' : 'text.retain_description',
        }
        });
        jobCategoryUpdate.disableClose = true;
        jobCategoryUpdate.afterClosed().subscribe((result: any) => {
        if(result){
          if(result?.category === 'UPDATE'){
            this.categoryChange(false);
          }else if(result?.category === 'RETAIN'){   
            this.categoryChange(true);
          }
        }
      });
    } else {
      this.categoryChange(false);
    }
  };

  categoryChange(dateFlag: boolean): void {
    const categoryGroup = this.jobForm.get('primaryDetails') as UntypedFormGroup;
    this.currentCategorySkills = [];
    //Handle category change
    const oldCategory = this.currentCategoryId;
    this.currentCategory = this.jobCategory.find((category: any)=>category.category_uid === categoryGroup.get('category').value);
    this.utilityService.castEventToSdk(`${this.currentPage}:category`, {
      oldValue: oldCategory,
      newValue: this.currentCategory
    });
    this.currentCategoryId = this.currentCategory?.category_uid;
    const dateGroup = this.jobForm.get('jobSchedule') as UntypedFormGroup;
    const startDate = dateGroup.get('startDate').value;
    if(startDate && this.currentCategory?.['estimated_duration']){
      const hours = this.currentCategory?.['estimated_duration']?.['hours'];
      const minutes = this.currentCategory?.['estimated_duration']?.['minutes'];
      const days = this.currentCategory?.['estimated_duration']?.['days'];
      const new_date_time = moment(startDate).add(days, 'days').add(hours, 'hours').add(minutes, 'minutes');
      dateGroup.get('endDate').setValue(new_date_time);
    }
    if(!dateFlag){
      const categoryDescription: string  = this.currentCategory?.category_description !== '' ? this.currentCategory?.category_description : '';
      categoryGroup.get('jobDescription').setValue(categoryDescription);
      this.getCategorySkills();
      this.clearAllTask();
      this.getCategoryServiceTask(this.currentCategoryId);
    }
    this.calculateScheduleDuration();
  }

  getLineItemsProductColumns(): LineItemPickerColumns[] {
    return [{
      type: LineItemPickerColumnType.LINE_ITEM,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.CATEGORY,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.TYPE,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.BRAND,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.SPECIFICATION,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.LOCATION,
      isEditable: true
    },
    {
      type: LineItemPickerColumnType.SERIAL_NO,
      isEditable: true,
      isRequired: false,
      multiple: true
    },
    {
      type: LineItemPickerColumnType.PURCHASE_PRICE,
      isEditable: true,
    },
    {
      type: LineItemPickerColumnType.MARKUP,
      isEditable: true,
    },
    {
      type: LineItemPickerColumnType.PRICE,
      isEditable: true,
      isRequired: true
    },
    {
      type: LineItemPickerColumnType.QUANTITY,
      isEditable: true,
      isRequired: true
    }];
  }


  getBundleLineItemsProductColumns(): LineItemPickerColumns[] {
    return [
    {
      type: LineItemPickerColumnType.LINE_ITEM,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.DESCRIPTION,
      isEditable: true
    },
    {
      type: LineItemPickerColumnType.TYPE,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.LOCATION,
      isEditable: true
    },
    {
      type: LineItemPickerColumnType.QUANTITY,
      isEditable: false
    },
    {
      type: LineItemPickerColumnType.SERIAL_NO,
      isEditable: true,
      isRequired: false,
      multiple: true,
      allowAddValue: true
    },
    {
      type: LineItemPickerColumnType.PURCHASE_PRICE,
      isEditable: true,
    },
    {
      type: LineItemPickerColumnType.MARKUP,
      isEditable: true,
    },
    {
      type: LineItemPickerColumnType.PRICE,
      isEditable: true,
      isRequired: true
    }
  ];
  }

  openContractLineItemPicker(event: Event): void {
    this.getContractDetails(event, this.selectedContract[0]['contract_uid']);
  }

  getContractDetails(event: Event, uid: string, redirect?: boolean): void {
    this._dataCollectorService.getData(this._contractService.getContractDetails(uid)).subscribe(
      (res: any) => {
        if(!redirect){
          if(res?.data?.line_items?.length > 0){
            const parts = res?.data?.line_items;
            this.openLineItemPicker(event, parts, 'SERVICE_CONTRACT');
          }else{

          }
        }else{
          this.prefillContractDetails(res?.data);
        }
      }
    );
  }

  prefillContractDetails(data: any): void {
    this.selectedContract = [data];
    this.prefillDetails(data);
  }

  prefillDetails(data: any): void {
    if(data?.customer && !this.redirect?.state?.customer){
      this.selectedCustomers = [data?.customer];
      if(this.selectedCustomers[0]?.customer_organization?.organization_uid){
        this.selectedOrganizations = [this.selectedCustomers[0]?.customer_organization];
      }
      this.setCustomerTimeZone();
      if(!this.selectedCustomers[0]?.customer_all_addresses) {
        this.getAllCustomerAddressDetails(this.selectedCustomers[0]?.customer_uid);
      }
    }
    if(data?.organization && !this.redirect?.state?.organization){
      this.selectedOrganizations = [data?.organization];
      this.prefillOrganizationAddress();
      this.setOrganizationTimezone();
    }
    if(data?.properties?.length > 0 && !this.redirect?.state?.properties) {
      this.selectedProperty = [data?.properties[0]?.property];
      this.prefillPropertyAddress();
    }
    if(data?.project?.project_uid) {
      this.getProjectDetails(data?.project?.project_uid);
    }
    if(data?.property && !this.redirect?.state?.property) {
      this.selectedProperty = [data?.property];
      this.prefillPropertyAddress();
    }
    this.endDateChange();
    if(data?.line_items && !this.redirect?.state?.line_items){
      this.selectedLineItems = data?.line_items.map((item: any) => (
        {
          ...item, product_description: item?.product_description ?? item?.description,
          product_name: item?.name, price: item?.unit_price
        })).filter((line_items => ((line_items?.approval_status && line_items?.approval_status === 'APPROVED') || true)));
      this.calculateTotalWithoutTax();
    }

    if(data?.custom_fields?.length > 0){
      this.customFieldValue = data?.custom_fields;
    }
    if(data?.assets?.length > 0 && !this.redirect?.state?.assets){
      this.selectedAssets = data?.assets.map((asset: any) => asset?.asset);
    }
    if(data?.customer_address && !this.redirect?.state?.customer_address){
      const serviceGroup = this.jobForm.get('serviceAddress') as UntypedFormGroup;
      this.currentServiceAddress = this.populateAddressFields(data?.customer_address);
      if(!this.currentServiceAddress?.phone){
        this.currentServiceAddress['phone']=this.getPhoneNumber();
      }
      serviceGroup.setValue(this.currentServiceAddress);
      this.getServiceTerritoryDetails();
    }
    if(data?.customer_address?.geo_cordinates?.length > 0 && !this.redirect?.state?.customer_address){
      this.showServiceAddress = false;
      this.serviceMapOption['coords'] = data?.customer_address?.geo_cordinates;
      setTimeout(()=>{
        this.showServiceAddress = true;
      });
    }
    if(data?.asset_location && !this.redirect?.state?.customer_address){
      const serviceGroup = this.jobForm.get('serviceAddress') as UntypedFormGroup;
      this.currentServiceAddress = this.populateAddressFields(data?.asset_location);
      if(!this.currentServiceAddress?.phone){
        this.currentServiceAddress['phone']=this.getPhoneNumber();
      }
      serviceGroup.setValue(this.currentServiceAddress);
      this.getServiceTerritoryDetails();
    }
    if(data?.asset_location && !this.redirect?.state?.customer_address){
      this.showServiceAddress = false;
      this.serviceMapOption['coords'] = data?.asset_location?.geo_cordinates;
      setTimeout(()=>{
        this.showServiceAddress = true;
      });
    }
    if(data?.customer_service_address && !this.redirect?.state?.customer_address){
      const serviceGroup = this.jobForm.get('serviceAddress') as UntypedFormGroup;
      this.currentServiceAddress = this.populateAddressFields(data?.customer_service_address);
      if(!this.currentServiceAddress?.phone){
        this.currentServiceAddress['phone']=this.getPhoneNumber();
      }
      serviceGroup.setValue(this.currentServiceAddress);
      this.getServiceTerritoryDetails();
    }
    if(data?.customer_service_address?.geo_cordinates?.length > 0 && !this.redirect?.state?.customer_address){
      this.showServiceAddress = false;
      this.serviceMapOption['coords'] = data?.customer_service_address?.geo_cordinates;
      setTimeout(()=>{
        this.showServiceAddress = true;
      });
    }
    if(data?.billing_address && !this.redirect?.state?.customer_billing_address){
      this.sameAsServiceAddress = false;
      const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
      this.currentBillingAddress = this.populateAddressFields(data?.billing_address);
      if(!this.currentBillingAddress?.phone){
        this.currentBillingAddress['phone']=this.getPhoneNumber();
      }
      billingGroup.setValue(this.currentBillingAddress);
    }
    if(data?.customer_billing_address && !this.redirect?.state?.customer_billing_address){
      this.sameAsServiceAddress = false;
      const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
      this.currentBillingAddress = this.populateAddressFields(data?.customer_billing_address);
      if(!this.currentBillingAddress?.phone){
        this.currentBillingAddress['phone']=this.getPhoneNumber();
      }
      billingGroup.setValue(this.currentBillingAddress);
    }

    if (!this.currentServiceAddress?.street) {
      if (this.selectedProperty?.length) {
        this.updateServiceAddress(this.selectedProperty[0]?.property_address);
      } else if (this.selectedCustomers?.length) {
        this.updateServiceAddress(this.selectedCustomers[0]?.customer_address);
      } else if (this.selectedOrganizations?.length) {
        this.updateServiceAddress(this.selectedOrganizations[0]?.organization_address);
      }
    }

    if (!this.currentBillingAddress?.street) {
      if (this.selectedOrganizations?.length) {
        this.updateBillingAddress(this.selectedOrganizations[0]?.organization_address);
      } else if (this.selectedCustomers?.length) {
        this.updateBillingAddress(this.selectedCustomers[0]?.customer_billing_address);
      }
    }
    if(this.isPricelistEnabled){
      if(!data?.pricelist?.is_deleted && data?.pricelist?.is_active && data?.pricelist?.pricelist_uid){
        this.currentPricelistObj = this.pricelistService.constructPricelistObject(data);
        if(this.currentPricelistObj){
          this.pricelist = this.getPricelist('', this.currentPricelistObj);
          this.pricelistUid = data?.pricelist?.pricelist_uid;
          this.pricelistFormControl.setValue(data.pricelist.pricelist_uid);
        }
      }else{
        this.pricelist = this.getPricelist('');
      }
      if(this.selectedOrganizations[0]?.organization_uid){
        this.getOrgDetails(this.selectedOrganizations[0]?.organization_uid, false, false);
      }
      if(this.selectedCustomers[0]?.customer_uid){
        this.getCusDetails(this.selectedCustomers[0].customer_uid, false);
      }
      if(this.selectedProperty[0]?.property_uid ){
        this.getPropDetails(this.selectedProperty[0].property_uid ,false);
      }
    }
    if(data?.proposal_title){
      const jobDetails = this.jobForm.get('jobDetails') as UntypedFormGroup;
      jobDetails.controls.jobTitle.setValue(data?.proposal_title);
    }
  }

  updateServiceAddress(serviceAddress: any): void {
    const serviceGroup = this.jobForm.get('serviceAddress') as UntypedFormGroup;
    this.currentServiceAddress = this.populateAddressFields(serviceAddress);
    if(!this.currentServiceAddress?.phone){
      this.currentServiceAddress['phone']=this.getPhoneNumber();
    }
    serviceGroup.setValue(this.currentServiceAddress);
    if(serviceAddress?.geo_cordinates?.length > 0){
      this.showServiceAddress = false;
      this.serviceMapOption['coords'] = serviceAddress?.geo_cordinates;
      setTimeout(()=>{
        this.showServiceAddress = true;
      });
    }
    this.getServiceTerritoryDetails();
  }

  updateBillingAddress(billingAddress: any): void {
    this.sameAsServiceAddress = false;
    const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
    this.currentBillingAddress = this.populateAddressFields(billingAddress);
    if(!this.currentBillingAddress?.phone){
      this.currentBillingAddress['phone']=this.getPhoneNumber();
    }
    billingGroup.setValue(this.currentBillingAddress);
  }

  openAssetLineItemPicker(event: Event, index: number): void {
    this.getAssetDetails(event, this.selectedAssets[index]['asset_uid']);
  }

  getAssetDetails(event: Event, uid: string, redirect?: boolean): void {
    this._dataCollectorService.getData(this._assetService.getAssetUrl(uid))
      .subscribe((res: any) => {
        if(!redirect){
          if(res?.data?.asset_parts?.length > 0){
            const parts = res.data.asset_parts.map((part: any) => part?.product_id);
            this.openLineItemPicker(event, parts, 'ASSET');
          }else{

          }
        }else{
          this.prefillAssetDetails(res?.data);
        }
      });
  }

  prefillAssetDetails(data: any): void {
    if(!this.redirect?.state?.assets){
      this.selectedAssets = [data];
    }
    this.prefillDetails(data);
  }

  getQuotationDetails(): void {
    const url: string = this._quotationService.getQuotationUrl(this.uid);
    this._dataCollectorService.getData(url)
      .subscribe((res: any) => {
        this.prefillQuotationDetails(res?.data);
      }, (error: any) => {
        if(error?.message){

        }
      });
  }

  prefillQuotationDetails(data: any): void{
    this.selectedQuote = data;
    this.prefillDetails(data);
    this.prefillCustomerAllAddress();
  }

  getProjectDetails(projectUid): void{
    const url: string = this.projectsService.projectsDetailsUrl(projectUid);
    this._dataCollectorService.getData(url).subscribe((response: any)=>{
      this.selectedProject = [response.data];
      this.isProjectRestricted = this.selectedProject[0]?.config?.product?.restrict_to_project;
      this.prefillProjectAddress();
      if(this.selectedProject[0].pricelist?.pricelist_uid){
        if(this.isPricelistEnabled){
          this.setPricelist();
          const pricelistObj = this.pricelistService.constructPricelistObject(this.selectedProject[0]);
          if(pricelistObj){
          this.pricelistUid = this.selectedProject[0]?.pricelist?.pricelist_uid;
          this.pricelistFormControl.setValue(this.pricelistUid);
          this.pricelistFormControl.disable();
            }else{
              this.pricelist = this.getPricelist('');
            }
          }
        }
    });
  }

  getOrganizationDetails(): void {
    this._dataCollectorService.getData(this._organizationService.getOrganizationDetails(this.uid))
      .subscribe((res: any) => {
        if(res?.custom_fields?.length > 0 ){
          this.customFieldValue = res?.custom_fields;
        }
        this.prefillOrganizationDetails(res?.data);
      });
  }

  prefillOrganizationDetails(data: any): void {
    this.selectedOrganizations = [data];
    if(data?.organization_address){
      const serviceGroup = this.jobForm.get('serviceAddress') as UntypedFormGroup;
      this.currentServiceAddress = this.populateAddressFields(data?.organization_address);
      serviceGroup.setValue(this.currentServiceAddress);
      this.getServiceTerritoryDetails();
    }
    if(data?.organization_billing_address){
      this.sameAsServiceAddress = false;
      const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
      this.currentBillingAddress = this.populateAddressFields(data?.organization_billing_address);
      billingGroup.setValue(this.currentBillingAddress);
    }
    this.setOrganizationTimezone();
    this.prefillOrganizationAddress();
    this.prefillDetails(data);
  }

  getPropertyDetails(): void{
    this._dataCollectorService.getData(this._propertyService.getPropertyDetails(this.uid))
    .subscribe((res: any) => {
        setTimeout(() => {
          if (res?.data?.custom_fields?.length > 0) {
            this.customFieldValue = [...res.data.custom_fields];
          }
        }, 1000);
      this.prefillPropertyDetails(res?.data);
    });
  }

  prefillPropertyDetails(data: any): void {
    this.selectedProperty = [data];
    this.sameAsServiceAddress = false;

    if(this.selectedProperty[0]?.property_address?.street){
      const addressObj = this.selectedProperty[0]?.property_address;
      addressObj['title'] = this.utilityService.getLocaleValue('text.property') + ' - "' + this.selectedProperty[0]['property_name'] + '" '+ this.utilityService.getLocaleValue('address.text');
      if(addressObj?.first_name){
        addressObj['first_name'] = addressObj?.first_name;
      }
      if(addressObj?.last_name){
        addressObj['last_name'] = addressObj?.last_name;
      }
      addressObj['module'] = 'PROPERTY';
      this.addressOptions['addressList'].push(addressObj);
    }
    if(data?.property_address){
      const serviceGroup = this.jobForm.get('serviceAddress') as UntypedFormGroup;
      this.currentServiceAddress = this.populateAddressFields(data?.property_address);
      if(!this.currentServiceAddress?.phone){
        this.currentServiceAddress['phone']=this.getPhoneNumber();
      }
      serviceGroup.setValue(this.currentServiceAddress);
      this.getServiceTerritoryDetails();
      if(data?.property_address?.geo_cordinates?.length > 0){
        this.showServiceAddress = false;
        this.serviceMapOption['coords'] = data?.property_address?.geo_cordinates;
        setTimeout(()=>{
          this.showServiceAddress = true;
        });
      }
    }
    if(data?.property_organization){
      this.selectedOrganizations = [data?.property_organization];
    }
    this.customerPickerOptions['showCustomDataOnly'] = true;
    this.customerPickerOptions['data'] = data?.property_customers?.length ? this.selectedProperty[0]?.property_customers?.map(item => item?.customer) ?? []  : [];
    this.propertyPickedFirst = true;

    if(this.selectedOrganizations[0]?.organization_address?.street){
      const addressObj = this.selectedOrganizations[0]?.organization_address;
      const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
      addressObj['title'] = this.utilityService.getLocaleValue('text.organization') + ' - "' + this.selectedOrganizations[0]['organization_name'] + '" '+ this.utilityService.getLocaleValue('address.text');
      if(addressObj?.first_name){
        addressObj['first_name'] = addressObj?.first_name;
      }
      if(addressObj?.last_name){
        addressObj['last_name'] = addressObj?.last_name;
      }
      addressObj['module'] = 'ORGANIZATION';

      this.currentBillingAddress = this.populateAddressFields(addressObj);
      if(!this.currentBillingAddress?.phone){
        this.currentBillingAddress['phone']=this.getPhoneNumber();
      }

      billingGroup.setValue(this.currentBillingAddress);

      this.addressOptions['addressList'].push(addressObj);
    }

    if(this.isPricelistEnabled){
      if(!data?.pricelist?.is_deleted && data?.pricelist?.is_active && data?.pricelist?.pricelist_uid){
        this.currentPricelistObj = this.pricelistService.constructPricelistObject(data);
        if(this.currentPricelistObj){
          this.pricelist = this.getPricelist('', this.currentPricelistObj);
          this.pricelistUid = data?.pricelist?.pricelist_uid;
          this.pricelistFormControl.setValue(data.pricelist.pricelist_uid);
        }
      }else{
        this.pricelist = this.getPricelist('');
      }
      if(this.selectedCustomers[0]?.customer_uid){
        this.getCusDetails(this.selectedCustomers[0].customer_uid, false);
      }
      if(this.selectedOrganizations[0]?.organization_uid){
        this.getOrgDetails(this.selectedOrganizations[0]?.organization_uid, false, false);
      }
    }

  }

  getCustomerDetails(): void {
    this._dataCollectorService.getData(this._customerService.customerUrl + this.uid).subscribe(
      (res: any) => {
        if(res?.data?.custom_fields?.length > 0 ){
          this.customFieldValue = res?.data?.custom_fields;
        }
        this.prefillCustomerDetails(res?.data);
      });
  }

  getPhoneNumber(): string | number {
    if(this.selectedCustomers[0]?.customer_contact_no?.mobile){
      return this.selectedCustomers[0]?.customer_contact_no?.mobile;
    }else if(this.selectedCustomers[0]?.customer_contact_no?.home){
      return this.selectedCustomers[0]?.customer_contact_no?.home;
    }else if(this.selectedCustomers[0]?.customer_contact_no?.work){
      return this.selectedCustomers[0]?.customer_contact_no?.work;
    }else{
      return '';
    }
  }

  prefillCustomerDetails(data: any): void {
    this.selectedCustomers = [data];
    if(this.selectedCustomers[0]?.customer_organization?.organization_uid){
      this.selectedOrganizations = [this.selectedCustomers[0]?.customer_organization];
      this.prefillOrganizationAddress();
    }
    this.setCustomerTimeZone();
    this.prefillCustomerAllAddress();
    this.prefillDetails(data);
  }

  openLineItemPicker(event: Event, parts?: any, module?: string): void {
    let remoteData = null;
    if(this.selectedProject?.length > 0 && this.selectedProject[0]?.config?.product?.restrict_to_project === true && this.selectedProject[0]?.products?.length > 0){
      parts = this.selectedProject[0]?.products?.filter((prd: any)=>prd?.product_type?.toLowerCase() !== 'bundle').map((data: any)=>({...data,price:data?.unit_price}));
    }
    if(this.utilityService.isEmptyOrUndefined(parts)){
      remoteData = {
        dataUrl: this._lineItemService.lineItemAPIUrls.productUrl,
      };

      if (this.isPricelistEnabled && this.pricelistUid) {
        remoteData.params = {
          ...remoteData.params,
          'pricelist': this.pricelistUid,
        };
      }
    }
    const lineItemPickerData = {
      options: {
        module: this.module,
        multipleLineItems: true,
        data: parts || null,
        remoteData: remoteData,
        pickerType: 'modal',
        columns: this.getLineItemsProductColumns(),
        addFromProductGroup: false,
        filters: {
          search: {
            enabled: true
          },
          productType: {
            enabled: true
          },
          category: {
            enabled: true
          },
          location: {
            enabled: true
          },
          availability: {
            enabled: true
          }
        },
        header: {
          isEnabled: true,
          headerDisplayKey: 'lineitem.picker.header.choose_text',
          headerDisplayName: 'Choose Line Item'
        },
        footer: {
          isEnabled: true,
          buttonDisplayKey: 'lineitem.picker.add.product_text',
          buttonDisplayName: 'Add Product'
        }
      } as LineItemPickerOptions
    };
    this.trackEventAnalytics('add_line_item');
    const lineItemDialog: any = this._zuperDialogService.openCustom(LineItemPickerComponent,
      {
        extraClass: 'line-item-picker-container',
        data: lineItemPickerData
      });
    lineItemDialog.disableClose = true;
    const onAddItemClicked: any = this._lineItemPickerService.onAddItemClicked.subscribe((response: any) => {
      lineItemDialog.close(response);
    });
    lineItemDialog.afterClosed().subscribe((lineItems: any) => {
      onAddItemClicked.unsubscribe();
      if(lineItems){
        this.utilityService.castEventToSdk(`${this.currentPage}:line_items`, {
          oldValue: this.selectedLineItems,
          newValue: [...this.selectedLineItems, ...lineItems]
        });
        this.prepareLineItems(lineItems, module, true);
      }
    });
  }

  openBundleItemPicker(module?: string): void{
    let remoteData = null;
    let parts = null;
    remoteData = {
      dataUrl: this._lineItemService.lineItemAPIUrls.productUrl,
      params: {
        'filter.product_type': 'BUNDLE',
      }
    };
    if (this.isPricelistEnabled && this.pricelistUid) {
      remoteData.params = {
        ...remoteData.params,
        'pricelist': this.pricelistUid,
      };
    }
    if(this.selectedProject?.length > 0 && this.selectedProject[0]?.config?.product?.restrict_to_project === true && this.selectedProject[0]?.products?.length > 0){
      parts = this.selectedProject[0]?.products?.filter((prd: any)=>prd?.product_type?.toLowerCase() === 'bundle').map((data: any)=>({...data,price:data?.unit_price}));
    }
    const bundleItemPickerData = {
      options: {
        module: this.module,
        type: 'NEW',
        multipleLineItems: false,
        data: parts ?? null,
        remoteData: remoteData,
        pickerType: 'modal',
        columns: this.getBundleLineItemsProductColumns(),
        addFromProductGroup: false,
        getCategoryAsObject: true,
        filters: {
          search: {
            enabled: true
          },
          category: {
            enabled: true
          },
          availability: {
            enabled: true
          },
          bundle_pricing_level: {
            enabled: true
          }
        },
        fieldOptions: [
          {
            fieldName: 'quantity',
            fieldLabel: 'text.quantity',
            placeholder: 'create.line_item.quantity.placeholder',
            displayType: 'input',
            isEditable: true,
            isRequired: true,
            showField: true,
          },
          {
            fieldName: 'purchase_price',
            fieldLabel: 'text.bundle_cost',
            placeholder: 'text.bundle_cost',
            displayType: 'input',
            isEditable: true,
            showField: true,
          },
          {
            fieldName: 'markup',
            fieldLabel: 'text.markup',
            displayType: 'input',
            isEditable: true,
            isRequired: false,
          },
          {
            fieldName: 'price',
            fieldLabel: 'text.bundle_selling_price',
            placeholder: 'text.bundle_selling_price',
            displayType: 'input',
            isEditable: true,
            isRequired: true,
            showField: true,
          },
          {
            fieldName: 'is_billable',
            fieldLabel: 'billable',
            placeholder: 'billable',
            displayType: 'input',
            isEditable: true,
            isRequired: false,
            showField: true,
          },
          {
            fieldName: 'product_description',
            fieldLabel: 'description',
            placeholder: 'create.line_item.description.placeholder',
            displayType: 'input',
            isEditable: true,
            isRequired: false,
            showField: true,
          }
        ],
        header: {
          isEnabled: true,
          headerDisplayKey: 'bundle.picker.header.select_bundle_text',
          headerDisplayName: 'Select Bundle'
        },
        footer: {
          isEnabled: true,
          buttonDisplayKey: 'bundle.picker.footer.add_bundle_text',
          buttonDisplayName: 'Add Bundle'
        }
      } as LineItemPickerOptions
    };

    const bundleItemDialog: any = this._zuperDialogService.openCustom(ProductBundleItemPickerComponent,
      {
        extraClass: 'bundle-item-picker-container',
        data: bundleItemPickerData
      });
    bundleItemDialog.disableClose = true;
    const onAddBundleItemClicked: any = this._bundleItemPickerService.onAddBundleItemClicked.subscribe((response: any) => {
      bundleItemDialog.close(response);
    });
    bundleItemDialog.afterClosed().subscribe((lineItems: any) => {
      onAddBundleItemClicked.unsubscribe();
      if(lineItems){
        this.utilityService.castEventToSdk(`${this.currentPage}:line_items`, {
          oldValue: this.selectedLineItems,
          newValue: [...this.selectedLineItems, ...lineItems]
        });
        this.prepareLineItems(lineItems, module, true);
      }
    });
  }

  prepareLineItems(lineItems: any[], module?: string, fromPicker=false): void {
    if (lineItems) {
      if (lineItems.length > 0 && module) {
        const items = [...lineItems];
        lineItems = items.map((item: any) => ({
          ...item,
          'associated_to': module
        }));
      }
      if (fromPicker) {
        this.selectedLineItems = [...this.selectedLineItems, ...lineItems];
      } else {
        this.selectedLineItems = lineItems;
      }
      this.selectedLineItems = this.populateRequiredKeys(this.selectedLineItems);
      this.calculateTotalWithoutTax();
    }
  }

  populateRequiredKeys(products: any): any {
    return products?.map((data: any) => ({
      ...data,
      price: data?.unit_price ?? data?.price,
      unit_price: data?.unit_price ?? data?.price,
      associated_products: data?.associated_products?.length > 0 ? data?.associated_products?.map((prd: any)=>({
        ...prd,
        price: prd?.unit_price ?? prd?.price,
        unit_price: prd?.unit_price ?? prd?.price,
      })) : []
    }));
  }

  calculateTotalWithoutTax(): void {
    this.selectedLineItems.filter((item: any)=> item?.line_item_type !== 'HEADER').forEach((item: any) => {
      this.assignTotal(item);
    });
  }

  get getIsTaxExempt(): boolean{
    let taxExemptState  = false;
    if(this.selectedProperty?.length <=1 && this.selectedProperty[0]?.tax?.tax_exempt){
      taxExemptState = true;
    }else if((this.selectedProperty?.length === 0 || this.selectedProperty?.length > 1) && this.selectedCustomers?.length > 0 && this.selectedCustomers[0]?.tax?.tax_exempt){
      taxExemptState = true;
    }else if((this.selectedProperty?.length === 0 || this.selectedProperty?.length > 1) && this.selectedCustomers?.length === 0 && this.selectedOrganizations?.length > 0 && this.selectedOrganizations[0]?.tax?.tax_exempt){
      taxExemptState = true;
    }
    return taxExemptState;
  }

  getTax(total: number, rate: number): number {
    return total + total * (rate / 100);
  }

  assignTotal(item): void {
    if(item?.product_type === 'BUNDLE'){
      if(item?.associated_products?.length > 0){
        let associateProdTotal = 0;
        let sellingPrice = 0;
        item?.associated_products?.forEach((associateProd: any) => {
          associateProd.total = this.getItemTotal(associateProd,item?.quantity);
          associateProdTotal += associateProd.total;
          sellingPrice += (Number(associateProd?.price) ?? Number(associateProd?.unit_price));
        });
        item.total = item?.pricing_level === 'ROLLUP' ? associateProdTotal : this.getItemTotal(item);
        item.unit_price = item.price = item?.pricing_level === 'ROLLUP' ? sellingPrice : (item.price ?? item.unit_price);
      }
    }else{
      item.total = this.getItemTotal(item);
    }
  }

  getItemTotal(item: any,bundleQuantity?: any): any{
    item.price = item?.price ? item?.price : item?.unit_price;
    item.price = item.price ?? 0;
    const quantity = bundleQuantity ? bundleQuantity * item?.quantity : item?.quantity;
    let total = quantity * item?.price;
    if (item?.tax?.tax_exempt === false && !this.utilityService.isEmptyOrUndefined(item?.tax?.tax_name) && !this.utilityService.isEmptyOrUndefined(item?.tax?.tax_rate) && item?.tax?.tax_rate > 0 && !this.getIsTaxExempt) {
      total = this.getTax(total, item?.tax.tax_rate);
    }
    item.pre_total = total;
    let modifiedTotal = quantity * item?.price;
    if (item?.discount) {
      if (item?.discount_type === 'FIXED') {
        modifiedTotal = modifiedTotal - item?.discount;
      } else if (item?.discount_type === 'PERCENTAGE') {
        modifiedTotal = modifiedTotal - modifiedTotal * (item?.discount / 100);
      } else {
        modifiedTotal = modifiedTotal - item?.discount;
      }
    }
    if (item?.tax?.tax_exempt === false && !this.utilityService.isEmptyOrUndefined(item?.tax?.tax_name) && !this.utilityService.isEmptyOrUndefined(item?.tax?.tax_rate) && item?.tax?.tax_rate > 0 && !this.getIsTaxExempt) {
      modifiedTotal = this.getTax(modifiedTotal, item?.tax.tax_rate);
    }
    if (item?.pre_total === modifiedTotal) {
      item.pre_total = 0;
    }
    return modifiedTotal;
  }

  getLocationName(product: any): string {
    if(product?.product_ref_id?.location_availability?.length){
      const selected = product?.product_ref_id?.location_availability?.find((location: any) => location.location.location_uid === product?.location_uid);
      if(selected){
        return selected?.location?.location_name;
      }else{
        return '---';
      }
    }else if(product?.location_name){
      return product?.location_name;
    }else{
      return '---';
    }
  }

  openItemGroup(event: Event): void {
    const lineItemGroupPickerData = {
      options: {
        multipleLineItems: true,
        pickerType: 'modal',
        columns: [],
        addFromProductGroup: true,
        header: {
          isEnabled: true,
          headerDisplayKey: 'lineitem.picker.group_add.header',
          headerDisplayName: 'Choose Group'
        },
        footer: {
          isEnabled: true,
          buttonDisplayKey: 'lineitem.picker.group_add.text',
          buttonDisplayName: 'Add Group'
        }
      } as LineItemPickerOptions
    };
    if(this.isPricelistEnabled && this.pricelistUid){
      lineItemGroupPickerData.options.remoteData = {
        dataUrl: '',
        params:{
          'pricelist': this.pricelistUid
        }
      };
    }
    this.trackEventAnalytics('add_line_item_group');
    const lineItemDialog: any = this._zuperDialogService.openCustom(LineItemPickerComponent,
      {
        extraClass: 'line-item-group-picker-container',
        data: lineItemGroupPickerData
      });
    lineItemDialog.disableClose = true;
    const onAddItemClicked: any = this._lineItemPickerService.onAddItemClicked.subscribe((response: any) => {
      lineItemDialog.close(response);
    });
    lineItemDialog.afterClosed().subscribe((groupLineItems: any) => {
      onAddItemClicked.unsubscribe();
      this._lineItemService.setGroupLocationPreference(groupLineItems,this.defaultPreferredLocationUid);
      this.prepareLineItems(groupLineItems, 'JOB', true);
      this.calculateTotalWithoutTax();
    });
  }

  updateHeader(product: any, index: number): void {
    this.trackEventAnalytics('update_header');
    const headerDialog = this._zuperDialogService.openCustom(LineitemHeaderComponent, {
      extraClass: 'line-item-header',
      data: {
        title: 'line_item.header.update.title',
        submit: 'update',
        header: product?.product_name
      }
    });
    headerDialog.afterClosed().subscribe(
      (res: any) => {
        if(res){
          this.selectedLineItems[index] = {
            product_name: res,
            line_item_type: 'HEADER'
          };
          this.selectedLineItems = [...this.selectedLineItems];
          this.calculateTotalWithoutTax();
        }
      }
    );
  }

  performPartsAction(action: string,product: any,index?: number, type?: string): void{
    switch(action){
      case 'viewDetails':
        if(action === 'viewDetails' && type !== 'BUNDLE') {
          this.trackEventAnalytics('view_product_details');
          const detailsDialog = this._zuperDialogService.openCustom(ProductDetailsModelComponent,{
            data : product,
            extraClass: 'product-sample-details'
          });
        }
        else{
          this.bundleDetails = product ?? {};
          this.openBundleDetails = true;
          const drawer = this._zuperDrawerService.getComponent('viewBundleDetailDrawer');
          drawer.open();
        }
        break;
      case 'delete':
        this.trackEventAnalytics('remove_product');
        const deleteConfirmationMessage = `${this.utilityService.getLocaleValue('delete.line.item.message.prefix')} ${product?.product_type || 'product'} <span class="text-gray-900 font-medium">
                                           "${product?.product_name || ''}"</span> ${this.utilityService.getLocaleValue('text.from_the_job')}?`;
        let deleteConfirmationTitle = `${this.utilityService.getLocaleValue('delete.line.item.label','Remove Part/Service')}`;
        if(type === 'HEADER'){
          deleteConfirmationTitle = `${this.utilityService.getLocaleValue('delete.header.title', 'Remove Line Item Header')}`;
        }
        const deleteConfirmationDialog =  this._zuperDialogService.openCustom(DeletePartsConfirmationComponent,{
          data: {
            dialogTitle: deleteConfirmationTitle,
            isRecurrence: false,
            message: deleteConfirmationMessage
          },
          extraClass: 'delete-parts-dialog',
        });
        deleteConfirmationDialog.afterClosed().subscribe((result: any)=>{
          if(result){
            this.utilityService.castEventToSdk(`${this.currentPage}:line_items`,{
              oldValue: this.selectedLineItems,
              newValue: this.selectedLineItems.filter((_item, i)=> i !== index)
            });
            this.selectedLineItems.splice(index, 1);
            this.selectedLineItems = [...this.selectedLineItems];
            this.calculateTotalWithoutTax();
          }
          });
        break;
      case 'edit':
        if(product?.line_item_type === 'HEADER'){
          this.updateHeader(product, index);
          return;
        }
        if(action === 'edit' && type === 'BUNDLE') {
          this.trackEventAnalytics('update_line_item');
          this.editBundleDialog(product, index);
        }
        else{
          this.trackEventAnalytics('update_line_item');
          this.editPartsDialog(product, index);
        }
        break;
      case 'clone':
        const item = _.cloneDeep(product);
        delete item?.line_item_uid;
        delete item?.project_line_item_uid;
        const jobProduct = this.selectedLineItems?.filter((data: any)=> data?.product_uid === product?.product_uid);
        const existingSerialNumbers = [];
        jobProduct?.forEach((ele: any)=>{
          ele?.associated_products?.forEach((prd: any)=>{
            if(prd?.serial_nos?.length > 0){
              existingSerialNumbers.push([...prd?.serial_nos]);
            }
          });
        });
        item?.associated_products?.forEach((ele: any)=>{
          const locationAvailability = ele?.location_availability ?? ele?.product?.location_availability;
          locationAvailability?.forEach((location: any) => {
            if (location?.location?.location_uid === ele?.location_uid) {
              location.serial_nos = location?.serial_nos?.filter((sn: any)=> !existingSerialNumbers?.includes(sn));
            }
          });
          ele.serial_nos = null;
        });
        this.selectedLineItems.push(item);
        this.selectedLineItems = [...this.selectedLineItems];
        this.calculateTotalWithoutTax();
        break;
      case 'BULKACTION':
        const products = _.cloneDeep(product);
        this.selectedJobParts = products;
        this.showPartsBulkAction = this.utilityService?.hasSelectedRecord(products);
        this.selectedProductCount = this.utilityService?.getSelectedProductCount(products);
        break;
    }
  }

  updateLineItemsOrder(event): void{
    this.selectedLineItems = [...event?.products];
  }

  editPartsDialog(product: any,index?: number): any {
    this.trackEventAnalytics('update_line_item');
    const editPartsDialog = this._zuperDialogService.openCustom(UpdatePartsOrServicesComponent,{
      product: product,
      module: this.module,
      is_recurrence: (!this.redirect?.state?.disableRecurrence) ? this.jobDetails?.is_recurrence : false,
      options: {
        type: 'edit',
        titleDisplayKey: 'edit.line.item.lebel',
        submitDisplayKey: 'update.line.item.lebel',
        fieldOptions: [{
          fieldName: 'product_id',
          fieldLabel: 'product.details.product.id.label',
          displayType: 'text',
          showField: true
        },{
          fieldName: 'product_name',
          fieldLabel: 'text.product_name',
          displayType: 'text',
          showField: true
        },{
          fieldName: 'location_uid',
          fieldLabel: 'text.location',
          placeholder: 'text.choose_location',
          displayType: 'input',
          isEditable: true,
          isRequired: false,
          showField: product?.product_ref_id?.location_availability?.length > 0 || product?.product?.location_availability?.length > 0 || product?.location_availability?.length > 0
        },{
          fieldName: 'brand',
          fieldLabel: 'brand',
          displayType: 'input',
          placeholder: 'brand',
          isEditable: true,
          isRequired: false,
          showField: true
        },{
          fieldName: 'specification',
          fieldLabel: 'text.specification',
          displayType: 'input',
          placeholder: 'text.specification',
          isEditable: true,
          isRequired: false,
          showField: true
        },{
          fieldName: 'purchase_price',
          fieldLabel: 'text.unit_purchase_price',
          placeholder: 'text.unit_purchase_price',
          displayType: 'input',
          isEditable: true,
          showField: true
        },{
          fieldName: 'markup',
          fieldLabel: 'text.markup',
          displayType: 'input',
          isEditable: true,
          isRequired: false,
        },{
          fieldName: 'price',
          fieldLabel: 'text.unit_selling_price',
          displayType: 'input',
          placeholder: 'text.unit_selling_price',
          isEditable: true,
          isRequired: true,
          showField: true
        },{
          fieldName: 'quantity',
          fieldLabel: 'text.quantity',
          displayType: 'input',
          placeholder: 'text.quantity',
          isEditable: true,
          isRequired: true,
          showField: true
        },{
          fieldName: 'serial_nos',
          fieldLabel: 'text.serial_number',
          displayType: 'input',
          placeholder: 'text.serial_number',
          isEditable: true,
          isRequired: false,
          showField: true,
          allowAddValue: true
        },
        {
          fieldName: 'product_description',
          fieldLabel: 'description',
          displayType: 'input',
          placeholder: 'description',
          isEditable: true,
          isRequired: false,
          showField: true
        },
        {
          fieldName: 'is_billable',
          fieldLabel: 'billable',
          placeholder: 'billable',
          displayType: 'input',
          isEditable: true,
          isRequired: false,
          showField: true,
        }]
      },
      extraClass:'update-job-part'
    });

    editPartsDialog.afterClosed().subscribe((result: any)=>{
      if(result){
        // When the dialog markup field is removed, update the actual markup in the `this.selectedLineItems` variable.
        if((result.hasOwnProperty('markup') === false) && this.selectedLineItems[index]?.markup){
          delete this.selectedLineItems[index].markup;
        }
        this.selectedLineItems[index] = {...this.selectedLineItems[index], ...result};
        this.selectedLineItems = [...this.selectedLineItems];
        this.calculateTotalWithoutTax();
      }
    });
  }

  editBundleDialog(product: any,index?: number): any {
    this.trackEventAnalytics('update_line_item');
    const editBundleDialog = this._zuperDialogService.openCustom(ProductBundleEditFormComponent,{
      selectedBundleDetails: product,
      products: this.selectedLineItems,
      module: this.module,
      options: {
        type: 'EDIT',
        columns: this.getBundleLineItemsProductColumns(),
        modal: {
          header: {
            isEnabled: true,
            headerDisplayKey: 'bundle.picker.header.edit_bundle_text',
            headerDisplayName: 'Edit Bundle'
          },
          footer: {
            isEnabled: true,
            buttonDisplayKey: 'bundle.picker.footer.update_bundle_text',
            buttonDisplayName: 'Update Bundle'
          }
        },
        fieldOptions: [
        {
          fieldName: 'quantity',
          fieldLabel: 'text.quantity',
          displayType: 'input',
          placeholder: 'text.quantity',
          isEditable: true,
          isRequired: true,
          showField: true
        },
          {
          fieldName: 'purchase_price',
          fieldLabel: 'text.unit_purchase_price',
          placeholder: 'text.unit_purchase_price',
          displayType: 'input',
          isEditable: true,
          showField: true
        },{
          fieldName: 'markup',
          fieldLabel: 'text.markup',
          displayType: 'input',
          isEditable: true,
          isRequired: false,
        },{
          fieldName: 'price',
          fieldLabel: 'text.unit_selling_price',
          displayType: 'input',
          placeholder: 'text.unit_selling_price',
          isEditable: true,
          isRequired: true,
          showField: true
        },
        {
          fieldName: 'is_billable',
          fieldLabel: 'billable',
          placeholder: 'billable',
          displayType: 'input',
          isEditable: true,
          isRequired: true,
          showField: true,
        },
        {
          fieldName: 'product_description',
          fieldLabel: 'description',
          displayType: 'input',
          placeholder: 'description',
          isEditable: true,
          isRequired: false,
          showField: true
        }]
      },
      extraClass:'edit-bundle-item-picker-container'
    });

    editBundleDialog.afterClosed().subscribe((result: any)=>{
      if(result){
        // When the dialog markup field is removed, update the actual markup in the `this.selectedLineItems` variable.
        if((result.hasOwnProperty('markup') === false) && this.selectedLineItems[index]?.markup){
          delete this.selectedLineItems[index].markup;
        }

        this.selectedLineItems[index] = {
          ...this.selectedLineItems[index],
          ...result
        };

        this.selectedLineItems = [...this.selectedLineItems];
        this.calculateTotalWithoutTax();
        this._changeDetectorRef.detectChanges();
      }
    });
  }

  onJobAssigneeChanged(event: any): void {

  }

  onTaskChanged(event: any): void {

  }

  onServiceTaskClose(event: any, drawerName: string): void {
    const drawer = this._zuperDrawerService.getComponent(drawerName);
    drawer.toggle();
    this.openTask = false;
    if(event?.data?.service_task_title && event?.state === 'new'){
      this.selectedServiceTask = [...this.selectedServiceTask, event?.data];
    } if(event?.state === 'edit') {
      this.selectedServiceTask[this.serviceTaskIndex] = {...this.selectedServiceTask[this.serviceTaskIndex], ...event?.data};
      this.selectedServiceTask = [...this.selectedServiceTask];
    }
    this.calculateTotalMin();
  }

  createCustomTask(drawerName: string): void{
    this.serviceTaskOption = {
      drawerName: 'serviceTaskDrawer',
      header: 'header.task.create.custom',
      footer: {
        submit: 'text.save'
      },
      isCustom: true,
      state: 'new'
    };
    this.toggleTaskDrawer(drawerName);
  }

  toggleTaskDrawer(drawerName: string): void {
    const drawer = this._zuperDrawerService.getComponent(drawerName);
    drawer.toggle();
    this.openTask = true;
  }

  checkUserSkill(data: any): any[] {
    const unskilledUser = [];
    let hasSkill = false;
    if(data?.length > 0 && this.skillValue?.length){
      data?.forEach((assign: any) => {
        if(assign?.user?.user_skills?.length > 0) {
          assign?.user?.user_skills.forEach((skill: any)=> {
            if(this.skillValue.includes(skill?.skillsets?.skillset_uid)){
              hasSkill = true;
            }
          });
        }else{
          hasSkill = false;
        }
        if(!hasSkill){
          unskilledUser.push(assign);
        }
      });
    }else{
      hasSkill = true;
    }
    return unskilledUser;
  }

  assignUnassignUser(event: any, castSDKEvent = true): void {
    if(event?.assign?.length && this.selectedServiceTask?.length){
      this.selectedServiceTask.forEach((task: any, index: number) => {
        let isPresent = false;
        if(task?.assigned_to?.user){
          event.assign.forEach((assign: any) => {
            if(task?.assigned_to?.user && (task?.assigned_to?.user?.user_uid === assign?.user?.user_uid)){
              isPresent = true;
            }
          });
          if(!isPresent){
            this.selectedServiceTask[index]['assigned_to'] = null;
          }
        }
      });
    } else if( this.selectedServiceTask.length){
        this.selectedServiceTask.forEach((task: any, index: number) => {
          this.selectedServiceTask[index]['assigned_to'] = null;
      });
    }
    if(castSDKEvent){
      if(event.assign.length > 0){
        this.utilityService.castEventToSdk(`${this.currentPage}:users_assigned`, {
          oldValue: this.assignEmployeeOptions['details']['assigned_to'],
          newValue: event.assign,
        });
      }
      if(event.unassign.length > 0){
        this.utilityService.castEventToSdk(`${this.currentPage}:users_unassigned`, {
          oldValue: this.assignEmployeeOptions['details']['assigned_to'],
          newValue: event.unassign,
        });
      }
    }

    this.assignEmployeeOptions['details']['assigned_to'] = event.assign;
    this.masterAssignmentCopy = [];
    this.constructMasterAssignment(this.assignEmployeeOptions['details']['assigned_to']);
  }

  onAssignmentEventEmitted(event): void{
    const drawer = this._zuperDrawerService.getComponent('assignEmployeeDrawer');
    drawer.toggle();
    this.openEmployee = false;
    if(event !== 'close'){
      const unskilledUsers = this.checkUserSkill(event?.assign);
      if(unskilledUsers?.length > 0){
        const names = unskilledUsers.map((user: any) => (user?.user?.first_name+' '+user?.user?.last_name));
        const assignedUserMessage = `${names.join(', ')}  ${this.utilityService.getLocaleValue('alert.assign.skillset')}`;
        this.trackEventAnalytics('skill_mismatch_alert');
        const assignUserSkillDialog =  this._zuperDialogService.open({
              title:`${this.utilityService.getLocaleValue('alert.header.assign.skillset')}`,
              message:assignedUserMessage,
              type:'error',
              actions    : {
                  confirm: {
                    show : true,
                    label: 'Ok',
                    color: 'error',
                    confirmDisplayKey:'assign.employee',
                  },
                  cancel : {
                      show : true,
                      label: 'Cancel'
                  }
              },
              extraClass: 'w-2/5'
            });
            assignUserSkillDialog.afterClosed().subscribe((result: any)=>{
            if(result){
              this.assignUnassignUser(event);
            }else{
              if(event?.assign?.length > 0 && unskilledUsers?.length > 0) {
                event.assign = event.assign.filter((assign: any) => !unskilledUsers.find((user: any) => user?.user?.user_uid === assign?.user?.user_uid));
              }
              this.assignUnassignUser(event);
            }
          });
      }else{
        this.assignUnassignUser(event);
      }
    }
  }

  toggleAssignmentDrawer(drawerName): void {
    this.assignEmployeeOptions = {...this.assignEmployeeOptions, submitButtonTitle: 'text.save', drawerTitle: this.utilityService.getLocaleValue('header.job_assignment','Job Assignment')};
    const drawer = this._zuperDrawerService.getComponent(drawerName);
    drawer.toggle();
    this.openEmployee = true;
  }

  unassignUser(index: number): void {
      this.selectedServiceTask.forEach((task: any) => {
        const masterCopyIndex = this.masterAssignmentCopy.findIndex((assign: any) => assign?.user?.user_uid === task?.assigned_to?.user?.user_uid );
        if(masterCopyIndex > -1){
          this.masterAssignmentCopy.splice(masterCopyIndex, 1);
        }
        if((task?.assigned_to?.user?.user_uid === this.assignEmployeeOptions['details']['assigned_to'][index]?.user?.user_uid)){
          task.assigned_to = null;
        }
      });
    this.utilityService.castEventToSdk(`${this.currentPage}:assignUser`, {
      oldValue: this.assignEmployeeOptions['details']['assigned_to'],
      newValue: this.assignEmployeeOptions['details']['assigned_to'].filter((item: any, i: number)=> index !== i)
    });
    this.assignEmployeeOptions['details']['assigned_to'].splice(index,  1);
    this.constructMasterAssignment(this.assignEmployeeOptions['details']['assigned_to']);
  }

  unassignSecondaryContacts(index: number): void {
    this.selectedSecondaryContacts.splice(index,  1);
  }

  getPickerFilter(): any {
    if(this.currentPickerModule === 'ORGANIZATION'){
      return [...this.selectedOrganizations];
    } else if(this.currentPickerModule === 'ASSETS' && this.assetPickerState === 'STANDALONE'){
      return [...this.selectedAssets];
    } else if(this.currentPickerModule === 'ASSETS' && this.assetPickerState === 'TASK'){
      if(this.serviceTaskAssets[this.currentTaskAsset?.index]){
        return [this.serviceTaskAssets[this.currentTaskAsset?.index]];
      }
    } else if(this.currentPickerModule === 'JOB'){
      return [...this.selectedJob];
    } else if(this.currentPickerModule === 'CUSTOMER' && this.customerPickerState === 'SECONDARY_CONTACTS'){
      return [...this.selectedSecondaryContacts];
    }
  }

  getPickerFilterOptions(): PickerFilterOptions {
      return {
        filterByCustomer: {
          enabled: this.utilityService.hasModuleAccess('CUSTOMER', false, 'from_sidebar'),
          selectedValue: this.selectedCustomers[0] ?? null
        },
        filterByOrganization: {
          enabled: this.utilityService.hasModuleAccess('ORGANIZATION', false, 'from_sidebar'),
          selectedValue: this.selectedOrganizations[0] ?? null
        },
        filterByProperty: {
          enabled: this.utilityService.hasModuleAccess('PROPERTY', false, 'from_sidebar'),
          selectedValue: this.selectedProperty[0] ?? null
        }
      };
  }

  toggleParentJob(): void {
    if(this.selectedCustomers?.length === 0 && this.selectedOrganizations?.length === 0){
      return;
    }
    this.currentPickerModule='JOB';
    this.currentPickerOptions = this.jobPickerOptions;
    this.currentPickerOptions['customParams'] = {};
    if(this.selectedCustomers[0]?.customer_uid){
      this.currentPickerOptions['customParams']['filter.customer'] = this.selectedCustomers[0]['customer_uid'];
    }else if (this.selectedOrganizations[0]?.organization_uid){
      this.currentPickerOptions['customParams']['filter.customer_organization'] = this.selectedOrganizations[0]['organization_uid'];
    }
    this.currentPickerOptions.filters = this.getPickerFilterOptions();
    this.openDataPicker = true;
    this.getJobPicker();
  }

  toggleOrganization(): void {
    this.currentPickerModule='ORGANIZATION';
    this.organizationPickerOptions['customParams'] = {};
    if(this.selectedCustomers[0]?.customer_organization?.organization_uid && !this.propertyPickedFirst){
      this.organizationPickerOptions['customParams']['filter.organization_uid'] = this.selectedCustomers[0]['customer_organization']['organization_uid'];
    }
    this.organizationPickerOptions.allowQuickCreate = this.isCreatePermissionEnabled();
    this.currentPickerOptions = this.organizationPickerOptions;
    this.openDataPicker = true;
    this.getOrganizationPicker();
  }

  toggleCustomer(): void {
    this.currentPickerModule = 'CUSTOMER';
    this.customerPickerState = 'CUSTOMER';
    this.customerPickerOptions['selectOption'] = PickerSelectOptions.select;
    this.customerPickerOptions['header'] = {
      displayKey: null,
      displayName: this.utilityService.getLocaleValue('text.choose_customer')
    };
    this.customerPickerOptions['selectionDisableBasedOn'] = null;
    this.customerPickerOptions['elementID'] = null;
    this.customerPickerOptions['customParams'] = {};
    if(!this.propertyPickedFirst){
      this.customerPickerOptions['showCustomDataOnly'] = false;
      this.customerPickerOptions['data'] = null;
    }
    if(this.selectedOrganizations[0] && !this.propertyPickedFirst){
      this.customerPickerOptions['customParams']['filter.customer_organization'] = this.selectedOrganizations[0]['organization_uid'];
    }

    this.customerPickerOptions.allowQuickCreate = this.isCreatePermissionEnabled();
    this.currentPickerOptions = {
      ...this.customerPickerOptions,
      prefillValues: {
        'organization': this.selectedOrganizations[0]?.organization_uid ?? null,
        ...(this.utilityService.isTimeZoneEnabled && {'customer_timezone': this.selectedOrganizations[0]?.organization_timezone ?? null,})
      },
    };
    this.openDataPicker = true;
    this.getCustomerPicker();
  }

  toggleSecondaryContacts(): void {
    if(this.disableSecondaryContactField()){
      return;
    }
    this.currentPickerModule = 'CUSTOMER';
    this.customerPickerState = 'SECONDARY_CONTACTS';
    this.customerPickerOptions['filters'] = {
      filterByOrganization: {
        enabled: true,
        selectedValue: this.selectedOrganizations[0] ?? null,
        valueDisabled:  false,
        filterKey: 'filter.customer_organization'
      }
    };
    this.customerPickerOptions['selectOption'] = PickerSelectOptions.multiSelect;
    this.customerPickerOptions['selectionDisableBasedOn'] =  PickerSelectDisableOptions.CUSTOMER;
    this.customerPickerOptions['elementID'] =  this.selectedCustomers[0]?.customer_uid;
    this.customerPickerOptions['maxSelectionLimit'] =  10;
    this.customerPickerOptions['tooltipText'] =  this.utilityService.getLocaleValue('text.datapicker.secondary_contacts.selection_disable');

    this.customerPickerOptions['header'] = {
      displayKey: null,
      displayName: this.utilityService.getLocaleValue('text.choose_secondary_contacts')
    };
    this.customerPickerOptions['customParams'] = {};
    if(this.selectedOrganizations[0]){
      this.customerPickerOptions['customParams']['filter.customer_organization'] = this.selectedOrganizations[0]['organization_uid'];
    }

    if(this.selectedSecondaryContacts?.length > 0) {
      this.customerPickerOptions['selectedCustomers'] = this.selectedSecondaryContacts;
    }
    this.customerPickerOptions['allowQuickCreate'] = this.isCreatePermissionEnabled();
    this.currentPickerOptions = this.customerPickerOptions;
    this.currentPickerOptions = {...this.customerPickerOptions,
      prefillValues: {
        'organization': this.selectedOrganizations[0]?.organization_uid ?? null,
    }};
    this.openDataPicker = true;
    this.getSecondaryContactsPicker();
  }

  toggleProperty(): void {
    this.currentPickerModule = 'PROPERTY';
    if (this.utilityService.hasModuleAccess('CUSTOMER', false, 'from_sidebar') && this.utilityService.hasModuleAccess('ORGANIZATION', false, 'from_sidebar')) {
      this.propertyPickerOptions['filters'] = {
        getPropertyWithoutOrg: true,
        filterByCustomer: {
          enabled: true,
          selectedValue: this.selectedCustomers[0] ?? null,
          valueDisabled: this.selectedCustomers[0] ?? false
        },
        filterByOrganization: {
          enabled: true,
          selectedValue: this.selectedOrganizations[0] ?? null
        }
      };
    } else {
      if(this.selectedCustomers[0]){
        this.propertyPickerOptions['customParams']['filter.customer'] = this.selectedCustomers[0]['customer_uid'];
      }else if(this.selectedOrganizations[0]){
        this.propertyPickerOptions['customParams']['filter.organization'] = this.selectedOrganizations[0]['organization_uid'];
      }
    }
    
    this.propertyPickerOptions.allowQuickCreate = this.isCreatePermissionEnabled();
    this.currentPickerOptions = {...this.propertyPickerOptions,
      prefillValues: {
       'organization': this.selectedOrganizations[0]?.organization_uid ?? null
     }};
    this.openDataPicker = true;
    this.getPropertyPicker();
  }

  toggleRequest(): void {
    if(this.disableRequestField()){
      return;
    }
    this.currentPickerModule = 'REQUEST';
    this.requestPickerOptions['customParams'] = {};
    if(this.selectedCustomers[0]){
      this.requestPickerOptions['customParams']['filter.customer'] = this.selectedCustomers[0]['customer_uid'];
    }

    this.currentPickerOptions = this.requestPickerOptions;
    this.openDataPicker = true;
    this.getRequestPicker();
  }

  toggleProject(): void {
    if(this.disableProjectField()){
      return;
    }
    this.currentPickerModule = 'PROJECT';
    this.projectPickerOptions['customParams'] = {};
    if(this.selectedCustomers[0]){
      this.projectPickerOptions['customParams']['filter.customer'] = this.selectedCustomers[0]['customer_uid'];
    }else if(this.selectedOrganizations[0]){
      this.projectPickerOptions['customParams']['filter.organization'] = this.selectedOrganizations[0]['organization_uid'];
    }
    this.currentPickerOptions = this.projectPickerOptions;
    this.openDataPicker = true;
    this.getProjectPicker();
  }

  toggleContract(): void {
    if(this.disableField()){
      return;
    }
    this.currentPickerModule = 'SERVICE_CONTRACTS';
    this.contractPickerOptions['customParams'] = {};
    this.contractPickerOptions['filters'] = null;
    if (this.utilityService.hasModuleAccess('CUSTOMER', false, 'from_sidebar') && this.utilityService.hasModuleAccess('ORGANIZATION', false, 'from_sidebar')) {
      this.contractPickerOptions['filters'] = {
        filterByCustomer: {
          enabled: true,
          selectedValue: this.selectedCustomers[0] ?? null
        },
        filterByOrganization: {
          enabled: true,
          selectedValue: this.selectedOrganizations[0] ?? null,
          valueDisabled: this.selectedOrganizations[0] ? true : false
        },
      };
    } else {
      if (this.selectedOrganizations[0]) {
        this.contractPickerOptions['customParams']['filter.organization'] = this.selectedOrganizations[0]['organization_uid'];
      } else if (this.selectedCustomers[0]) {
        this.contractPickerOptions['customParams']['filter.customer'] = this.selectedCustomers[0]['customer_uid'];
      }
    }
    this.contractPickerOptions['customParams']['filter.is_expired'] = false;
    this.contractPickerOptions['customParams']['filter.approval_status'] = ['APPROVED', 'CUSTOMER_APPROVED'];
    this.currentPickerOptions = this.contractPickerOptions;
    this.openDataPicker = true;
    this.getContractPicker();
  }

  addLineItems(_event: any, addItemType: string): void {
    if (addItemType === 'add_item') {
      this.openLineItemPicker(_event);
    } else if (addItemType === 'add_group') {
      this.openItemGroup(_event);
    } else if (addItemType === 'add_custom_item') {
      this.addCustomLineItem(_event);
    } else if (addItemType === 'add_header') {
      this.addHeader();
    } else if (addItemType === 'add_bundle') {
      this.openBundleItemPicker();
    }
  }

  addHeader(): void {
    this.trackEventAnalytics('add_header');
    const headerDialog = this._zuperDialogService.openCustom(LineitemHeaderComponent, {
      extraClass: 'line-item-header',
      data: {
        title: 'line_item.header.title',
        submit: 'add.text'
      }
    });
    headerDialog.afterClosed().subscribe(
      (res: any) => {
        if(res){
          this.selectedLineItems.push({
            product_name: res,
            line_item_type: 'HEADER'
          });
          this.selectedLineItems = [...this.selectedLineItems];
          this.calculateTotalWithoutTax();
        }
      }
    );
  }

  addCustomLineItem(event: Event): void {
    this.trackEventAnalytics('add_custom_line_item');
    const editPartsDialog = this._zuperDialogService.openCustom(UpdatePartsOrServicesComponent,{
      is_recurrence: (!this.redirect?.state?.disableRecurrence) ? this.jobDetails?.is_recurrence : false,
      module: this.module,
      options: {
        type: 'new',
        lineItemType: 'CUSTOM',
        titleDisplayKey: 'create.line_item.title.text',
        submitDisplayKey: 'create',
        fieldOptions: [{
          fieldName: 'product_id',
          fieldLabel: 'id',
          placeholder: 'create.line_item.id.placeholder',
          displayType: 'input',
          isEditable: true,
          showField: true
        },{
          fieldName: 'product_name',
          fieldLabel: 'name.text',
          placeholder: 'create.line_item.name.placeholder',
          displayType: 'input',
          isEditable: true,
          showField: true,
          isRequired: true
        },{
          fieldName: 'brand',
          fieldLabel: 'brand',
          placeholder: 'create.line_item.brand.placeholder',
          displayType: 'input',
          isEditable: true,
          showField: true
        },{
          fieldName: 'specification',
          fieldLabel: 'text.specification',
          placeholder: 'text.specification',
          displayType: 'input',
          isEditable: true,
          showField: true
        },{
          fieldName: 'purchase_price',
          fieldLabel: 'text.unit_purchase_price',
          placeholder: 'text.unit_purchase_price',
          displayType: 'input',
          isEditable: true,
          showField: true
        },{
          fieldName: 'markup',
          fieldLabel: 'text.markup',
          displayType: 'input',
          isEditable: true,
          isRequired: false,
        },{
          fieldName: 'price',
          fieldLabel: 'text.unit_selling_price',
          placeholder: 'text.unit_selling_price',
          displayType: 'input',
          isEditable: true,
          isRequired: true,
          showField: true
        },{
          fieldName: 'quantity',
          fieldLabel: 'text.quantity',
          placeholder: 'create.line_item.quantity.placeholder',
          displayType: 'input',
          isEditable: true,
          isRequired: true,
          showField: true
        },{
          fieldName: 'product_description',
          fieldLabel: 'description',
          placeholder: 'create.line_item.description.placeholder',
          displayType: 'input',
          isEditable: true,
          isRequired: false,
          showField: true
        },
        {
          fieldName: 'is_billable',
          fieldLabel: 'billable',
          placeholder: 'billable',
          displayType: 'input',
          isEditable: true,
          isRequired: false,
          showField: true,
        }]
      } as PartsOrServicesOptions,
      extraClass:'update-job-part'
    });

    editPartsDialog.afterClosed().subscribe((lineItem: any)=>{
      if(lineItem){
        lineItem['line_item_type'] = 'ITEM';
        delete lineItem?.update_all_jobs;
        this.selectedLineItems = [...this.selectedLineItems,{...lineItem,line_item_type: 'ITEM'}];
        this.calculateTotalWithoutTax();
      }
    });
  }

  constructAssetPickerFilter(isTask?: boolean): void {
    this.assetPickerOptions['customParams'] = {};
    if(this.selectedCustomers[0]){
      this.assetPickerOptions['customParams']['filter.customer'] = this.selectedCustomers[0]['customer_uid'];
    }else if(this.selectedOrganizations[0]){
      this.assetPickerOptions['customParams']['filter.organization'] = this.selectedOrganizations[0]['organization_uid'];
    }else {
      this.assetPickerOptions['customParams']['filter.orphaned_assets'] = true;
    }
    this.assetPickerOptions['filters'] = {};
    this.assetPickerOptions['filters']['filterByCustomer'] = {
      enabled: this.utilityService.hasModuleAccess('CUSTOMER', false, 'from_sidebar'),
      selectedValue: this.selectedCustomers[0] ?? null
    };
    this.assetPickerOptions['filters']['filterByOrganization'] = {
      enabled: this.utilityService.hasModuleAccess('ORGANIZATION', false, 'from_sidebar'),
      selectedValue: this.selectedOrganizations[0] ?? null
    };
    this.assetPickerOptions['filters']['filterByProperty'] = {
      enabled: this.utilityService.hasModuleAccess('PROPERTY', false, 'from_sidebar'),
      selectedValue: this.selectedProperty[0] ?? null
    };
    this.assetPickerOptions['filters']['enableAssetStatus'] = true;
    if(isTask){
      this.assetPickerOptions['customParams']['populate_inspection_form'] = true;
    }
  }


  toggleAsset(): void {
    if(this.disableField()){
      return;
    }
    this.assetPickerState = 'STANDALONE';
    this.currentPickerModule = 'ASSETS';
    this.constructAssetPickerFilter();
    this.assetPickerOptions['enableFooterCheckbox'] = null;
    this.assetPickerOptions['enableDataTab'] = false;
    this.assetPickerOptions['data'] = null;
    this.assetPickerOptions['selectOption'] = PickerSelectOptions.multiSelect;
    this.assetPickerOptions.allowQuickCreate = this.isCreatePermissionEnabled();
    this.currentPickerOptions = {...this.assetPickerOptions,
      prefillValues: {
        'organization': this.selectedOrganizations[0]?.organization_uid ?? null,
        'customer': this.selectedCustomers[0]?.customer_uid ?? null,
        'property': this.selectedProperty[0]?.property_uid ?? null
    }};
    this.openDataPicker = true;
    this.getAssetPicker();
  }

  toggleTaskAsset(task: any, index: number): void {
    this.assetPickerState = 'TASK';
    this.currentTaskAsset = {
     data: task,
     index: index
    };
    this.currentPickerModule = 'ASSETS';
    this.assetPickerOptions['enableDataTab'] = true;
    this.assetPickerOptions['data'] = this.selectedAssets;
    this.assetPickerOptions['enableFooterCheckbox'] = {
      enabled: true,
      labelKey: 'dataPicker.use_inspection_form.text',
      labelName: 'Use Asset\'s Inspection Form',
      defaultValue: true
    };
    this.constructAssetPickerFilter(true);
    this.assetPickerOptions['selectOption'] = PickerSelectOptions.select;
    this.assetPickerOptions.allowQuickCreate = this.isCreatePermissionEnabled();
    this.assetPickerOptions.prefillValues = {
      'organization': this.selectedOrganizations[0]?.organization_uid ?? null,
      'customer': this.selectedCustomers[0]?.customer_uid ?? null,
      'property': this.selectedProperty[0]?.property_uid ?? null
    };
    this.currentPickerOptions = this.assetPickerOptions;
    this.openDataPicker = true;
    this.getTaskAssetPicker(task, index);
    }

  getJobPicker(): void{
    this.jobPickerSubscription = this._dataPickerService.onInit.subscribe(
      (res: any) => {
          this.selectedJob = res;
          const group = this.jobForm.get('primaryDetails') as UntypedFormGroup;
          const parentJobData = '#' + (this.selectedJob[0]?.prefix ?? '') + (this.selectedJob[0]?.work_order_number ?? '') + ' - ' + this.selectedJob[0]?.job_title;
          group.get('parent').setValue(parentJobData);
      }
    );
  }

  getOrganizationPicker(): void {
    this.organizationPickerSubscription = this._dataPickerService.onInit.subscribe(
      (res: any) => {
        this.utilityService.castEventToSdk(`${this.currentPage}:organization`, {
          oldValue: this.selectedOrganizations[0] || null,
          newValue: res[0]
        });
          this.getOrgDetails(res[0].organization_uid, true);
      }
    );
  }

  prefillOrganizationAddress(): void {
    if(this.selectedOrganizations[0]?.organization_address){
      const orgServiceAddress = this.selectedOrganizations[0]?.organization_address;
      const orgBillingAddress = this.selectedOrganizations[0]?.organization_billing_address;
      if(!this.propertyPickedFirst && this.utilityService.isEmptyOrUndefined(this.selectedCustomers[0]?.customer_address)){
        this.addToAddressList('SERVICE_ADDRESS', orgServiceAddress, orgBillingAddress, this.selectedOrganizations[0],'ORGANIZATION');
      }
      this.addToAddressList('BILLING_ADDRESS', orgServiceAddress, orgBillingAddress, this.selectedOrganizations[0],'ORGANIZATION');
    }
  }

  addToAddressList(addressType, serviceAddress, billingAddress, details, moduleType): void{
    let addressObj: any = {};
    let addressTitle;
    if(addressType === 'SERVICE_ADDRESS'){
      addressObj = serviceAddress;
      addressTitle = (billingAddress && ((billingAddress?.street !== serviceAddress?.street) || (billingAddress?.city !== serviceAddress?.city))) ? this.translateService.instant('text.service_address') : this.translateService.instant('address.text');
    }
    if(addressType === 'BILLING_ADDRESS'){
      if((billingAddress?.street !== serviceAddress?.street) || (billingAddress?.city !== serviceAddress?.city)){
        addressObj = billingAddress;
        addressTitle = this.translateService.instant('billing.address.text');
      }
    }
    if(addressObj) {
      addressObj['title'] = this.utilityService.getLocaleValue('text.organization') + ' - "' + details?.['organization_name'] + '" '+ addressTitle;
      if(addressObj?.first_name){
        addressObj['first_name'] = addressObj?.first_name;
      }
      if(addressObj?.last_name){
        addressObj['last_name'] = addressObj?.last_name;
      }
      addressObj['module'] = moduleType;
      this.addressOptions['addressList'].push(addressObj);

      if(addressType === 'BILLING_ADDRESS') {
        this.sameAsServiceAddress = false;
        const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
        this.currentBillingAddress = this.populateAddressFields(this.selectedOrganizations[0]?.organization_billing_address);
        billingGroup.setValue(this.currentBillingAddress);
      }
      else if(addressType === 'SERVICE_ADDRESS'){
        const serviceGroup = this.jobForm.get('serviceAddress') as UntypedFormGroup;
        this.currentServiceAddress = this.populateAddressFields(addressObj);
        serviceGroup.setValue(this.currentServiceAddress);
        this.getServiceTerritoryDetails();
        if(addressObj?.geo_cordinates?.length > 0){
          this.showServiceAddress = false;
          this.serviceMapOption['coords'] = addressObj?.geo_cordinates;
          setTimeout(()=>{
            this.showServiceAddress = true;
          });
        }
      }
    }
  }

  getSecondaryContactsPicker(): void {
    this.secondaryContactsSubscription = this._dataPickerService.onInit.subscribe(
      (res: any) => {
        this.selectedSecondaryContacts = res;
      }
    );
  }

  getCustomerPicker(): void {
    this.customerPickerSubscription = this._dataPickerService.onInit.subscribe(
      (res: any) => {
        this.utilityService.castEventToSdk(`${this.currentPage}:customer`, {
          oldValue: this.selectedCustomers[0] || null,
          newValue: res[0]
        });
        this.getCusDetails(res[0].customer_uid);
      }
    );
  }

  prefillOrganizationServiceAddress(): void {
    if(this.selectedOrganizations[0]?.organization_address?.street){
      const addressObj = this.selectedOrganizations[0]?.organization_address;
      addressObj['title'] = this.utilityService.getLocaleValue('text.organization') + ' - "' + this.selectedOrganizations[0]['organization_name'] + '" '+ this.utilityService.getLocaleValue('address.text');
      if(addressObj?.first_name || addressObj?.last_name){
        if(addressObj?.first_name){
          addressObj['first_name'] = addressObj?.first_name;
        }
        if(addressObj?.last_name){
          addressObj['last_name'] = addressObj?.last_name;
        }
      }else{
        addressObj['first_name'] = this.selectedOrganizations[0]['organization_name'];
      }
      if(!addressObj?.email && this.selectedOrganizations?.[0]?.['organization_email']){
        addressObj['email'] = this.selectedOrganizations[0]['organization_email'];
      }
      addressObj['module'] = 'ORGANIZATION';

      this.addressOptions['addressList'].push(addressObj);
      this.sameAsServiceAddress = false;
      const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
      this.currentBillingAddress = this.populateAddressFields(addressObj);
      billingGroup.setValue(this.currentBillingAddress);
    }
  }

  prefillOrganizationBillingAddress(): void {
    if(this.selectedOrganizations[0]?.organization_billing_address?.street){
      const addressObj = this.selectedOrganizations[0]?.organization_billing_address;
      addressObj['title'] = this.utilityService.getLocaleValue('text.organization') + ' - "' + this.selectedOrganizations[0]['organization_name'] + '" '+ this.utilityService.getLocaleValue('address.text');
      if(addressObj?.first_name || addressObj?.last_name){
        if(addressObj?.first_name){
          addressObj['first_name'] = addressObj?.first_name;
        }
        if(addressObj?.last_name){
          addressObj['last_name'] = addressObj?.last_name;
        }
      }else{
        addressObj['first_name'] = this.selectedOrganizations[0]['organization_name'];
      }
      if(!addressObj?.email && this.selectedOrganizations?.[0]?.['organization_email']){
        addressObj['email'] = this.selectedOrganizations[0]['organization_email'];
      }
      addressObj['module'] = 'ORGANIZATION';

      this.addressOptions['addressList'].push(addressObj);
      this.sameAsServiceAddress = false;
      const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
      this.currentBillingAddress = this.populateAddressFields(addressObj);
      billingGroup.setValue(this.currentBillingAddress);
    }
  }

  prefillCustomerAddress(): void {
    if(!this.propertyPickedFirst) {
      if(this.selectedCustomers[0]?.customer_address){
        const addressObj = this.selectedCustomers[0]?.customer_address;
        if(addressObj?.first_name){
          addressObj['first_name'] = addressObj?.first_name;
        }else{
          addressObj['first_name'] = this.selectedCustomers[0]?.customer_first_name || '';
        }
        if(addressObj?.last_name){
          addressObj['last_name'] = addressObj?.last_name;
        }else{
          addressObj['last_name'] = this.selectedCustomers[0]?.customer_last_name || '';
        }
        if(!addressObj?.email && this.selectedCustomers?.[0]?.['customer_email']){
          addressObj['email'] = this.selectedCustomers?.[0]?.['customer_email'];
        }
        const serviceGroup = this.jobForm.get('serviceAddress') as UntypedFormGroup;
        this.currentServiceAddress = this.populateAddressFields(addressObj);
        if(!this.currentServiceAddress?.phone){
          this.currentServiceAddress['phone']=this.getPhoneNumber();
        }
        serviceGroup.setValue(this.currentServiceAddress);
        this.getServiceTerritoryDetails();
      }
      if(this.selectedCustomers[0]?.customer_address?.geo_cordinates?.length > 0){
        this.showServiceAddress = false;
        this.serviceMapOption['coords'] = this.selectedCustomers[0]?.customer_address?.geo_cordinates;
        setTimeout(()=>{
          this.showServiceAddress = true;
        });
      }
    }
    if(this.selectedCustomers[0]?.customer_billing_address && !this.selectedCustomers[0]?.customer_organization?.organization_address ){
      this.sameAsServiceAddress = false;
      const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
      this.currentBillingAddress = this.populateAddressFields(this.selectedCustomers[0]?.customer_billing_address);
      if(!this.currentBillingAddress?.phone){
        this.currentBillingAddress['phone']=this.getPhoneNumber();
      }
      billingGroup.setValue(this.currentBillingAddress);
    }

  }

  onAddressSelect(result: any): void{
    if(result?.street){
      const addressData = {
        'firstName': '',
        'lastName': '',
        'email': '',
        'phone': '',
        'street': '',
        'landmark': '',
        'city': '',
        'state': '',
        'country': {
            'value': '',
            'label': ''
        },
        'zipcode': '',
        'latitude': 0,
        'longitude': 0
    };
    addressData['street'] = result?.street;
    if(result?.first_name){
      addressData['firstName'] = result?.first_name;
    }
    if(result?.last_name){
      addressData['lastName'] = result?.last_name;
    }
    if(result?.city){
      addressData['city'] = result?.city;
    }
    if(result?.zip_code){
      addressData['zipcode'] = result?.zip_code;
    }
    if(result?.email){
      addressData['email'] = result?.email;
    }
    if(result?.phone){
      addressData['phone'] = result?.phone;
    }
    if(result?.landmark){
      addressData['landmark'] = result?.landmark;
    }
    if(result?.state){
      addressData['state'] = result?.state;
    }
    if(result?.country){
      addressData['country']['label'] = result?.country;
    }
    if(result?.geo_cordinates?.length > 0){
      addressData['latitude'] = result?.geo_cordinates[0];
    }
    if(result?.geo_cordinates?.length > 0){
      addressData['longitude'] = result?.geo_cordinates[1];
    }

    if(this.currentAddressEdit === 'SERVICE'){
        this.currentServiceAddress = {...addressData};
        this.jobForm.get('serviceAddress').setValue(addressData);
        if(this.sameAsServiceAddress){
          this.currentBillingAddress = {...addressData};
          this.jobForm.get('billingAddress').setValue(addressData);

        }
        this.showServiceAddress = false;
        if(result?.geo_cordinates?.length > 0){
          this.serviceMapOption['coords'] = result?.geo_cordinates;
          setTimeout(()=>{
            this.showServiceAddress = true;
          });
        }
      }else{
        this.currentBillingAddress = {...addressData};
        this.jobForm.get('billingAddress').setValue(addressData);
      }
    }
    this.getServiceTerritoryDetails();
    this.showManageAddress = false;
  }

  getPropertyPicker(): void {
    this.propertyPickerSubscription = this._dataPickerService.onInit.subscribe(
      (res: any) => {
        this.utilityService.castEventToSdk(`${this.currentPage}:property`, {
          oldValue: this.selectedProperty[0] || null,
          newValue: res[0]
        });
        this.getPropDetails(res[0].property_uid);
      }
    );
  }

  prefillPropertyAddress(): void {
    if(this.selectedProperty[0]?.property_address?.street){
      const addressObj = this.selectedProperty[0]?.property_address;
      addressObj['title'] = this.utilityService.getLocaleValue('text.property') + ' - "' + this.selectedProperty[0]['property_name'] + '" '+ this.utilityService.getLocaleValue('address.text');
      if(addressObj?.first_name || addressObj?.last_name){
        if(addressObj?.first_name){
          addressObj['first_name'] = addressObj?.first_name;
        }
        if(addressObj?.last_name){
          addressObj['last_name'] = addressObj?.last_name;
        }
      }else if(this.selectedCustomers?.length){
        const customerAddress = this.selectedCustomers[0]?.customer_address;
        if(addressObj?.first_name){
          addressObj['first_name'] = customerAddress?.first_name;
        }else{
          addressObj['first_name'] = this.selectedCustomers[0]?.customer_first_name || '';
        }
        if(addressObj?.last_name){
          addressObj['last_name'] = customerAddress?.last_name;
        }else{
          addressObj['last_name'] = this.selectedCustomers[0]?.customer_last_name || '';
        }
        if(!addressObj?.email && this.selectedCustomers?.[0]?.['customer_email']){
          addressObj['email'] = this.selectedCustomers?.[0]?.['customer_email'];
        }
      }
      addressObj['module'] = 'PROPERTY';
      this.addressOptions['addressList'].push(addressObj);
        const serviceGroup = this.jobForm.get('serviceAddress') as UntypedFormGroup;
        this.currentServiceAddress = this.populateAddressFields(addressObj);
        if(!this.currentServiceAddress?.phone){
          this.currentServiceAddress['phone']=this.getPhoneNumber();
        }
        serviceGroup.setValue(this.currentServiceAddress);
        this.getServiceTerritoryDetails();
      if(addressObj?.geo_cordinates?.length > 0){
        this.showServiceAddress = false;
        this.serviceMapOption['coords'] = addressObj?.geo_cordinates;
        setTimeout(()=>{
          this.showServiceAddress = true;
        });
      }
    }
  }

  prefillProjectAddress(): void {
    /* Prefill the project billing address with the current job billing address. */
    const addressObj = this.selectedProject[0]?.project_billing_address;
    addressObj['module'] = 'PROJECT';
    this.addressOptions['addressList'].push(addressObj);
    if(addressObj) {
      this.sameAsServiceAddress = false;
      const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
      this.currentBillingAddress = this.populateAddressFields(addressObj);
      if(!this.currentBillingAddress?.phone){
        this.currentBillingAddress['phone']=this.getPhoneNumber();
      }
      billingGroup.setValue(this.currentBillingAddress);
    }
  }

  getRequestPicker(): void {
    this.requestPickerSubscription = this._dataPickerService.onInit.subscribe(
      (res: any) => {
        this.selectedRequest = res;
      }
    );
  }

  getProjectPicker(): void {
    this.projectPickerSubscription = this._dataPickerService.onInit.subscribe(
      (res: any) => {
        this.utilityService.castEventToSdk(`${this.currentPage}:project`, {
          oldValue: this.selectedProject[0] || null,
          newValue: res[0] || null
        });
        this.selectedProject = res;
        this.getProjectDetails(this.selectedProject[0]?.project_uid);
      }
    );
  }

  getAssetPicker(): void {
    this.assetPickerSubscription = this._dataPickerService.onInit.subscribe(
      (res: any) => {
        this.utilityService.castEventToSdk(`${this.currentPage}:assets`, {
          oldValue: this.selectedAssets,
          newValue: res
        });
        this.selectedAssets = res;
      }
    );
  }

  getTaskAssetPicker(task: any, index: number): void {
    this.assetPickerSubscription = this._dataPickerService.onInit.subscribe(
      (res: any) => {
        const selectedAsset = res?.selectedValue[0];
        this.serviceTaskAssets[index] = selectedAsset;
        if(res?.footerCheckboxValue && selectedAsset?.asset_inspection_form){
          this.selectedServiceTask[index]['inspection_form'] = selectedAsset?.asset_inspection_form;
        }
        const found = this.selectedAssets.find((asset: any) => asset?.asset_uid === selectedAsset.asset_uid);
        if(!found && !this.disableField()){
          selectedAsset['fromTask'] = true;
          this.selectedAssets.push(selectedAsset);
        }
      }
    );
  }

  getContractPicker(): void{
    this.contractPickerSubscription = this._dataPickerService.onInit.subscribe(
      (res: any) => {
        this.utilityService.castEventToSdk(`${this.currentPage}:contract`, {
          oldValue: this.selectedContract[0],
          newValue: res[0]
        });
        this.selectedContract = res;
        this.checkandUpdateRecurrenceDate();
      }
    );
  }

  removeParentJob(): void {
    this.selectedJob = [];
    const group = this.jobForm.get('primaryDetails') as UntypedFormGroup;
    group.get('parent').setValue('');
  }

  removeOrganization(): void {
    this.utilityService.castEventToSdk(`${this.currentPage}:organization`, {
      oldValue: this.selectedOrganizations[0] || null,
      newValue: null
    });
    this.selectedOrganizations = [];
    this.selectedAssets = [];
    this.selectedContract = [];
    const addressList = this.addressOptions['addressList'];
    if(addressList?.length > 0){
      this.addressOptions['addressList'] = addressList.filter((address: any) => (address?.module !== 'ORGANIZATION'));
    }
    this.propertyPickedFirst = false;
    this.removeCustomer();
    this.jobTypeChange(false);
    if(!this.jobScheduled){
      this.jobForm.controls['jobSchedule'].get('job_timezone').setValue(this.defaultTimeZone);
    }

  }

  removeCustomer(): void {
    this.utilityService.castEventToSdk(`${this.currentPage}:customer`, {
      oldValue: this.selectedCustomers[0] || null,
      newValue: null
    });
    this.selectedCustomers = [];
    this.selectedAssets = [];
    this.selectedContract = [];
    this.selectedRequest = [];
    this.selectedProject = [];
    if(!this.propertyPickedFirst) {
      this.selectedProperty = [];
    }
    this.addressOptions.addressList = [];
    this.removeParentJob();
    if(this.selectedOrganizations?.[0] && !this.propertyPickedFirst){
      this.prefillOrganizationAddress();
    }
    else if(!this.propertyPickedFirst){
      this.clearServiceAddress();
      this.clearBillingAddress();
    }
    this.conflictingJobs = 0;
    this.endDateChange();
    const addressList = this.addressOptions['addressList'];
    if(addressList?.length > 0){
      this.addressOptions['addressList'] = addressList.filter((address: any) => (address?.module !== 'CUSTOMER'));
    }
    if(this.isPricelistEnabled){
      this.setPricelist();
    }
    this.showContractAlertDisplay = false;
    this.selectedLineItems = this.populateRequiredKeys(this.selectedLineItems);
    this.calculateTotalWithoutTax();
    this.setOrganizationTimezone();
  }

  removeProperty(updatePricelist: boolean = true): void {
    this.utilityService.castEventToSdk(`${this.currentPage}:property`, {
      oldValue: this.selectedProperty[0] || null,
      newValue: null
    });
    this.selectedProperty = [];
    this.propertyPickedFirst = false;
    const addressList = this.addressOptions['addressList'];
    this.clearServiceAddress();
    this.addressOptions.addressList = [];
    if(this.selectedCustomers?.[0]){
      this.prefillCustomerAddress();
    }else if(this.selectedOrganizations?.[0]){
      this.prefillOrganizationAddress();
    }
    if(addressList?.length > 0){
      this.addressOptions['addressList'] = addressList.filter((address: any) => (address?.module !== 'PROPERTY'));
    }
    if(this.isPricelistEnabled && updatePricelist){
      this.setPricelist();
    }
    this.selectedLineItems = this.populateRequiredKeys(this.selectedLineItems);
    this.calculateTotalWithoutTax();
  }

  removeRequest(): void {
    this.selectedRequest = [];
  }

  removeProject(): void {
    this.utilityService.castEventToSdk(`${this.currentPage}:project`, {
      oldValue: this.selectedProject[0] || null,
      newValue: null
    });
    this.selectedProject = [];
    if(this.isPricelistEnabled){
      this.setPricelist();
    }
    const addressList = this.addressOptions['addressList'];
    if(addressList?.length > 0){
      this.addressOptions['addressList'] = addressList.filter((address: any) => (address?.module !== 'PROJECT'));
    }
    const billingGroup = this.jobForm.get('billingAddress') as UntypedFormGroup;
    if(this.selectedCustomers?.[0]){
      if(this.selectedCustomers?.[0]?.customer_organization && !this.selectedCustomers?.[0]?.customer_organization?.is_deleted){
        this.currentBillingAddress = this.populateAddressFields(this.selectedCustomers?.[0]?.customer_organization?.organization_billing_address);
      }else if(this.selectedCustomers?.[0]?.customer_billing_address){
        this.currentBillingAddress = this.populateAddressFields(this.selectedCustomers?.[0]?.customer_billing_address);
      }
    }else if(this.selectedOrganizations.length && this.selectedCustomers?.[0].length === 0){
      this.currentBillingAddress = this.populateAddressFields( this.selectedOrganizations[0]?.organization_billing_address);
    }

    billingGroup.setValue(this.currentBillingAddress);
  }

  removeContract(): void {
    this.selectedContract = [];
    this.showContractAlertDisplay = false;
  }

  removeAsset(index: number): void {
    this.utilityService.castEventToSdk(`${this.currentPage}:assets`, {
      oldValue: this.selectedAssets,
      newValue: this.selectedAssets.filter((_asset, i)=> i !== index)
    });
    this.selectedAssets.splice(index, 1);
  }

  dataPickerEventHandler(event: any): void {
    this.openDataPicker = false;
    if (event.drawerClosed && this.currentPickerModule === 'ORGANIZATION') {
      if(this.organizationPickerSubscription?.unsubscribe){
        this.organizationPickerSubscription.unsubscribe();
      }
    } else if (event.drawerClosed && this.currentPickerModule === 'CUSTOMER') {
      if(this.customerPickerSubscription?.unsubscribe){
        this.customerPickerSubscription.unsubscribe();
      }
      if(this.secondaryContactsSubscription?.unsubscribe){
        this.secondaryContactsSubscription.unsubscribe();
      }
    } else if (event.drawerClosed && this.currentPickerModule === 'PROPERTY'){
      if(this.propertyPickerSubscription?.unsubscribe){
        this.propertyPickerSubscription.unsubscribe();
      }
    } else if (event.drawerClosed && this.currentPickerModule === 'SERVICE_CONTRACTS'){
      if(this.contractPickerSubscription?.unsubscribe){
        this.contractPickerSubscription.unsubscribe();
      }
    } else if (event.drawerClosed && this.currentPickerModule === 'ASSETS'){
      if(this.assetPickerSubscription?.unsubscribe){
        this.assetPickerSubscription.unsubscribe();
      }
    } else if (event.drawerClosed && this.currentPickerModule === 'JOB'){
      if(this.jobPickerSubscription?.unsubscribe){
        this.jobPickerSubscription.unsubscribe();
      }
    } else if (event.drawerClosed && this.currentPickerModule === 'REQUEST'){
      if(this.requestPickerSubscription?.unsubscribe){
        this.requestPickerSubscription.unsubscribe();
      }
    } else if (event.drawerClosed && this.currentPickerModule === 'PROJECT'){
      if(this.projectPickerSubscription?.unsubscribe){
        this.projectPickerSubscription.unsubscribe();
      }
    }
  }

  showInvalidIcon(group?: string): boolean {
    if(this.showError){
      if (group === 'jobSchedule') {
        const scheduleGroup  = this.jobForm.get('jobSchedule') as UntypedFormGroup;
        if(!((scheduleGroup.get('startDate').value && scheduleGroup.get('endDate').value) || scheduleGroup.get('dueDate').value)){
          return true;
        }
        else if(scheduleGroup.get('startDate').value && scheduleGroup.get('endDate').value && (moment(scheduleGroup.get('startDate').value).isSameOrAfter(moment(scheduleGroup.get('endDate').value)))){
          return true;
        }
        return false;
      }
      if(group === 'serviceAddress'){
        if(!(this.currentServiceAddress?.street && this.currentServiceAddress?.city) || !this.jobForm.get('serviceAddress')?.valid){
          return true;
        }
        return false;
      }
      if(group === 'billingAddress'){
        if(!(this.currentBillingAddress?.street && this.currentBillingAddress?.city) || !this.jobForm.get('billingAddress')?.valid){
          return true;
        }
        return false;
      }
      if(group === 'organization'){
        if(!this.selectedOrganizations.length && !this.selectedCustomers.length){
          return true;
        }
        return false;
      }
      if(group === 'customer'){
        if(!this.selectedOrganizations.length && !this.selectedCustomers.length){
          return true;
        }
        return false;
      }
      else if(group && this.jobForm.get(group).invalid){
        return true;
      }
      else{
        return false;
      }
    }
  }

  getTotal(): number{
    let total: number = 0;
    this.selectedLineItems.forEach((item: any)=>{
      total = total + item?.total;
    });
    return total;
  }

  getFormValue(): void {
    this.showError = true;
    this.jobForm.markAllAsTouched();
    this._customFieldService?.formBuilderSubscription.next(true);
    const scheduleGroup  = this.jobForm.get('jobSchedule') as UntypedFormGroup;
    if(!(this.selectedCustomers?.length > 0 || this.selectedOrganizations?.length > 0)){
      this._toast.error(this.utilityService.getLocaleValue('alert.customer_or_organization_mandatory'));
      return;
    }
    if(scheduleGroup.get('dueDate')?.touched && scheduleGroup.get('dueDate')?.invalid){
      return;
    }
    if(!((scheduleGroup.get('startDate').value && scheduleGroup.get('endDate').value) || scheduleGroup.get('dueDate').value)){
      this._toast.error(this.utilityService.getLocaleValue('alert.due_date_schedule_date_mandatory'));
      return;
    }
    if(scheduleGroup.get('startDate').value && scheduleGroup.get('endDate').value && (moment(scheduleGroup.get('startDate').value).isSameOrAfter(moment(scheduleGroup.get('endDate').value)))){
      this._toast.error(this.utilityService.getLocaleValue('alert.job_start_time_before_end_time'));
      return;
    }
    if(!(this.currentServiceAddress?.street && this.currentServiceAddress?.city)){
      this._toast.error(this.utilityService.getLocaleValue('job.service_address.mandatory'));
      return;
    } else if (!this.jobForm.get('serviceAddress')?.valid) {
      this._toast.error(this.utilityService.getLocaleValue('text.service_address.invalid'));
      return;
    }
    if(!(this.currentBillingAddress?.street && this.currentBillingAddress?.city)){
      this._toast.error(this.utilityService.getLocaleValue('job.billing_address.mandatory'));
      return;
    } else if (!this.jobForm.get('billingAddress')?.valid) {
      this._toast.error(this.utilityService.getLocaleValue('text.billing_address.invalid'));
      return;
    }
    if(this.getTotal() < 0){
      this._toast.error(this.utilityService.getLocaleValue('text.negative.value.error'));
      return;
    }
    scheduleGroup.get('rruleForm').disable();
    if(this.jobForm.status === 'INVALID'){
      this._toast.error(this.utilityService.getLocaleValue('alert.mandatory_field'));
      scheduleGroup.get('rruleForm').enable();
      return;
    }else{
      if(!this.jobForm.controls['jobSchedule'].get('recurrence').value && this.isGivenDateAfterDueDate(scheduleGroup.get('endDate').value)) {
        const updateJobScheduleConfirmationDialog = this._zuperDialogService.open({
          title: this.utilityService.getLocaleValue('confirm.job.schedule.dialog.title'),
          type: 'error',
          message: this.utilityService.getLocaleValue('confirm.job.schedule.dialog.message'),
          actions: {
              confirm: {
                  show: true,
                  label: 'Continue',
                  color: 'primary',
                  confirmDisplayKey: 'continue.text'
              },
              cancel: {
                  show: true,
                  label: 'Cancel',
                  cancelDisplayKey: 'cancel.text'
              }
          }
        });
        updateJobScheduleConfirmationDialog.afterClosed().subscribe((result: any) => {
          if (result) {
            this.callCreateJobAPI(scheduleGroup);
          } else {
            return;
          }
        });
      }else {
        this.callCreateJobAPI(scheduleGroup);
      }
    }
  }

  callCreateJobAPI(scheduleGroup: any): any {
    const payload = {};
      if(this.selectedQuote){
        payload['estimate'] = this.selectedQuote?.estimate_uid;
      }
      if(this.selectedAssets?.length > 0){
        const assets = this.selectedAssets.map((asset: any) => ({
          asset: asset?.asset_uid,
          remarks: '',
          asset_serial_number: asset?.asset_serial_number
        }));
        payload['assets'] = assets;
      }
      if(this.assignEmployeeOptions['details']['assigned_to']?.length){
        const assigned_to = this.assignEmployeeOptions['details']['assigned_to'].map((data: any)=>({
          team_uid: data?.team?.team_uid,
          user_uid: data?.user?.user_uid,
          is_primary: data?.is_primary ?? false
        }));
        payload['assigned_to'] = assigned_to;
      }
      payload['custom_fields'] = this._customFieldService.constructCustomFields(this.jobForm.controls['customFields'] as UntypedFormGroup);

      if(this.selectedCustomers?.[0]){
        payload['customer'] = {
          customer_uid: this.selectedCustomers[0]?.customer_uid,
          customer_first_name: this.selectedCustomers[0]?.customer_first_name,
          customer_last_name: this.selectedCustomers[0]?.customer_last_name,
          customer_email: this.selectedCustomers[0]?.customer_email
        };
        payload['customer_uid'] = this.selectedCustomers[0]['customer_uid'];
        if(this.currentServiceAddress?.street){
          payload['customer']['customer_address'] = this.constructAddressFields(this.currentServiceAddress);
        }
        if(this.currentBillingAddress?.street){
          payload['customer']['customer_billing_address'] = this.constructAddressFields(this.currentBillingAddress);
        }
      }
      if(this.currentServiceAddress?.street){
        payload['customer_address'] = this.constructAddressFields(this.currentServiceAddress);
      }
      if(this.currentBillingAddress?.street){
        payload['customer_billing_address'] = this.constructAddressFields(this.currentBillingAddress);
      }
      if(scheduleGroup.get('dueDate')?.value && !scheduleGroup.get('recurrence').value){
        payload['due_date'] = moment.tz(moment(scheduleGroup.get('dueDate')?.value).format('YYYY-MM-DD HH:mm:ss'), this.timeZone).tz(this.timeZone).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
      }
      payload['job_category'] = this.jobForm.controls['primaryDetails'].get('category')?.value;
      payload['job_description'] = this.jobForm.controls['primaryDetails'].get('jobDescription')?.value;
      payload['job_priority'] = this.jobForm.controls['primaryDetails'].get('priority')?.value;
      payload['job_title'] = this.jobForm.controls['jobDetails'].get('jobTitle')?.value;
      payload['prefix'] = this.jobForm.controls['jobDetails'].get('prefix')?.value;
      payload['job_tags'] = this.jobForm.controls['primaryDetails'].get('tags')?.value || [];
      if(this.utilityService.isTimeZoneEnabled){
        payload['job_timezone'] = this.jobForm.controls['jobSchedule'].get('job_timezone').value;
      }
      payload['job_type'] = this.jobForm.controls['primaryDetails'].get('jobType').value || 'NEW';
      if(this.skillValue?.length > 0) {
        const selectedSkills = this.skillOptions.filter((skill: any) => this.skillValue.includes(skill?.value));
        if(selectedSkills?.length > 0){
          payload['skills'] = selectedSkills.map((skill: any) => ({
            skill_uid: skill.value,
            skill_name: skill.key
          }));
        }
      }
      if(this.selectedOrganizations?.[0]){
        payload['organization'] = this.selectedOrganizations[0]?.organization_uid;
      }
      if(this.selectedProperty?.[0]){
        payload['property'] = this.selectedProperty[0]?.property_uid;
      }
      if(this.selectedRequest?.[0]){
        payload['request'] = this.selectedRequest[0]?.request_uid;
      }
      if(this.selectedProject?.[0]){
        payload['project'] = this.selectedProject[0]?.project_uid;
      }
      if(this.selectedJob?.[0]?.job_uid){
        payload['parent_job'] = this.selectedJob[0]['job_uid'];
      }
      if(this.selectedLineItems?.length > 0){
        payload['products'] = [];
        this.selectedLineItems.forEach((product: any)=>{
          const data = product;
          if(data?.product_ref_id){
            delete data.product_ref_id;
        }
        if(data?.tax?.tax_exempt === false && (this.utilityService.isEmptyOrUndefined(data.tax?.tax_name) || this.utilityService.isEmptyOrUndefined(data.tax?.tax_rate))){
          delete data?.tax?.tax_name;
          delete data?.tax?.tax_rate;
        }
        data.product_category = data?.product_category?.category_uid ?? data?.product_category;
        payload['products'].push(data);
      });
    }
    if(scheduleGroup.get('endDate')?.value){
      payload['scheduled_end_time'] = this.timeZone ? moment.tz(moment(scheduleGroup.get('endDate')?.value).format('YYYY-MM-DD HH:mm:ss'), this.timeZone).utc().format('YYYY-MM-DD HH:mm:ss')
      : moment(scheduleGroup.get('endDate')?.value).utc().format('YYYY-MM-DD HH:mm:ss');
    }
    if(scheduleGroup.get('startDate')?.value){
      payload['scheduled_start_time'] = this.timeZone ? moment.tz(moment(scheduleGroup.get('startDate')?.value).format('YYYY-MM-DD HH:mm:ss'), this.timeZone).utc().format('YYYY-MM-DD HH:mm:ss')
      : moment(scheduleGroup.get('startDate')?.value).utc().format('YYYY-MM-DD HH:mm:ss');
    }
    if(this.selectedContract?.length > 0){
      payload['service_contract'] = this.selectedContract[0]?.contract_uid;
    }
    if(this.jobForm.controls['jobSchedule'].get('recurrence')?.value && this.currentRruleValue?.rrule){
      payload['is_recurrence'] = true;
      payload['rrule'] = {};
      if(this.currentRruleValue?.duration){
        payload['rrule']['duration'] = this.currentRruleValue?.duration;
        payload['rrule']['rule_string'] = this.currentRruleValue?.rrule;
      }
      if(this.currentRruleDates?.length > 0){
        payload['recurrence_dates'] = this.currentRruleDates;
      }
    }
    if(this.redirect?.state?.module === 'PPM' && this.uid){
      payload['ppm'] = this.uid;
    }
    if(this.redirect?.state?.module === 'INVOICE' && this.uid){
      payload['invoice'] = this.uid;
    }
    if(this.attachments?.length > 0){
      payload['attachment'] = this.attachments.map((attachment: any) => (
          {
          'file_name': attachment?.file_name || '',
          'url': attachment?.file_url || '',
          'attachment_uid': attachment?.attachment_uid || '',
          'company_attachment_uid': attachment?.attachment_uid || ''
        }
      ));
    }
    if(this.selectedServiceTask?.length > 0){
      const serviceData = this.selectedServiceTask.map((task: any, index: number) => {
        const taskData = {
          'sequence_no': index + 1,
          'service_task_master': task?.service_task_master_uid || null,
          'service_task_title': task?.service_task_title,
          'service_task_description': task?.service_task_description || '',
          'estimated_duration': {
              'days': task?.estimated_duration?.days,
              'hours': task?.estimated_duration?.hours,
              'minutes': task?.estimated_duration?.minutes
          },
          'inspection_form': task?.inspection_form?.asset_form_uid || null,
          'asset': this.serviceTaskAssets[index]?.asset_uid || null
        };
        if(task?.assigned_to?.user){
          taskData['assigned_to'] = [{
            'user_uid': task?.assigned_to?.user?.user_uid,
            'team_uid': task?.assigned_to?.team?.team_uid
          }];
        }else{
          taskData['assigned_to'] = [];
        }
        return taskData;
      });
      payload['service_task'] = {
        'execution_type': this.currentExecution,
        'service_tasks': serviceData,
        'is_enabled': true
      };
    }

    if(this.selectedSecondaryContacts?.length > 0) {
      const customers: any[] = [];
      this.selectedSecondaryContacts.forEach((customer) => {
        customers.push({
          'customer': customer.customer_uid
        });
      });
      payload['secondary_customers'] = customers;
    }

    if(this.isPricelistEnabled && this.pricelistUid){
      payload['pricelist'] = this.pricelistUid;
    }

    if(this.service_territory?.matched_territory?.territory?.territory_uid){
      payload['territory'] = this.service_territory?.matched_territory?.territory?.territory_uid;
    }

    const jobTitle = this.jobForm.controls['jobDetails'].get('jobTitle')?.value.trim() || '';
    const displayJobTitle = jobTitle === '' ? '' : `"${jobTitle}"`;

    const confirmationDialog = this._zuperDialogService.open({
       title: this.utilityService.getLocaleValue('create.job.text', 'Create Job'),
       message: `${this.utilityService.getLocaleValue('job.create.confirmation.title', 'Do you want to create job')} ${displayJobTitle}?`,
       type: 'success',
       confirmDisplayKey: 'create',
       actions: {
         confirm: {
           show: true,
           color: 'primary',
           confirmDisplayKey: 'create'
         },
         cancel: {
           show: true,
           label: 'Cancel',
           cancelDisplayKey: 'cancel.text'
         }
       }
     });
     confirmationDialog.afterClosed().subscribe((result: any) => {      
       if (result) {
         this.isJobCreating = true;
          const loader =  this._toast.loading(this.utilityService.getLocaleValue('loader.alert.creating_job'), {duration: Infinity});
          this._dataCollectorService.postData(this._jobsService.jobAPIUrls?.jobsUrl,{
          'job': payload
          }).subscribe((res: any) => {
            this.isJobCreating = false;
            loader.close();
            let job_uid = '';
            if (payload?.['is_recurrence'] && res?.job_uid?.length > 0) {
              job_uid = res?.job_uid[0];
            } else {
              job_uid = res?.job_uid;
            }
            if (res?.data?.message){
              this._toast.success(res?.data?.message);
            } else {
              this._toast.success(this.utilityService.getLocaleValue('alert.job.created_successfully'));
            }
            if (!this.redirect?.state?.isDialog){
              this._router.navigateByUrl(`/jobs/${job_uid}/details`);
              this._analytics.trackEvent('NEW_JOB_JOB_DETAILS');
            } else {
              this.dialogRef.close({job_uid: job_uid});
            }
         }, (err: any) => {
            this.isJobCreating = false;
             loader.close();
         });
       } else {
         this.isJobCreating = false;
       }
     });
  };

  constructAddressFields(data: UntypedFormGroup): any {
    return {
      street: data['street'],
      city: data['city'],
      country: data['country']?.label || '',
      email: data['email'] || '',
      first_name: data['firstName'] || '',
      last_name: data['lastName'] || '',
      phone_number: data['phone'] || '',
      zip_code: data['zip_code'] || data['zipcode'] || '',
      state: data['state'] || '',
      geo_cordinates: [data['latitude'], data['longitude']],
      landmark: data['landmark'] || ''
    };
  }

  populateAddressFields(data: any): any {
    return {
      street: data?.['street'] || '',
      city: data?.['city'] || '',
      country: {
        label: data?.['country']?.label || data?.['country'] || '',
        value: data?.['country']?.value || ''
      },
      firstName: data?.['first_name'] || '',
      lastName: data?.['last_name'] || '',
      phone: data?.['phone_number'] || '',
      state: data?.['state'] || '',
      email: data?.['email'] || '',
      latitude: data?.['geo_cordinates']?.[0] || 0,
      longitude: data?.['geo_cordinates']?.[1] || 0,
      landmark: data?.['landmark'] || '',
      zipcode: data?.['zip_code'] || data['zipcode'] || ''
    };
  }

  openAllAddressesModal(address?: string): void {
    if(address === 'SERVICE'){
      this.addressOptions['selectedAddress'] = this.currentServiceAddress;
    }else{
      this.addressOptions['selectedAddress'] = this.currentBillingAddress;
    }
    this.showManageAddress = true;
    this.currentAddressEdit = address;
  }

  setAccountTimeZoneValue(): void {
    const selectedFromDate = this.jobForm?.get('jobSchedule')?.get('startDate')?.value;
    const selectedToDate = this.jobForm?.get('jobSchedule')?.get('endDate')?.value;
    const tz = this.jobForm?.get('jobSchedule')?.get('job_timezone')?.value;

    if (selectedFromDate && selectedToDate) {
      let patchFromDate = moment(selectedFromDate);
      let patchToDate = moment(selectedToDate);

      if (tz === this.accountTimeZone) {
        this.fromTimeInAccountTimeZone = patchFromDate.format(this.dateTimeFormat);
        this.toTimeInAccountTimeZone = patchToDate.format(this.dateTimeFormat);
      } else {
        patchFromDate = moment.tz(selectedFromDate?.clone().format('YYYY-MM-DD HH:mm:ss'), tz);
        patchToDate = moment.tz(selectedToDate?.clone().format('YYYY-MM-DD HH:mm:ss'), tz);
        this.fromTimeInAccountTimeZone = moment.tz(patchFromDate, this.accountTimeZone).format(this.dateTimeFormat);
        this.toTimeInAccountTimeZone = moment.tz(patchToDate, this.accountTimeZone).format(this.dateTimeFormat);
      }

      if(this.currentRruleValue?.rrule){
        const dates = rrulestr(this.currentRruleValue.rrule).all();
        if(dates?.length > 0){
          this.currentRruleDates = [];
          dates.forEach((date: any) => {
            const selectedDate = moment.utc(date).tz(this.timeZone, true);
            this.currentRruleDates.push({
              scheduled_end_time: moment.tz(patchToDate.clone()
              .year(selectedDate.year())
              .month(selectedDate.month())
              .date(selectedDate.date())
              ,this.timeZone).utc().format('YYYY-MM-DD HH:mm:ss'),
              scheduled_start_time: moment.tz(patchFromDate.clone()
              .year(selectedDate.year())
              .month(selectedDate.month())
              .date(selectedDate.date())
              ,this.timeZone).utc().format('YYYY-MM-DD HH:mm:ss')
            });
          });
          this.currentRruleCount = this.currentRruleDates?.length;
        }else{
          this.currentRruleDates = [];
          this.currentRruleCount = 0;
        }        
      }
    }


  }


  ngAfterViewInit(): void {
    this.formPlacement['left'] = [this.jobDetailsRef, this.jobScheduleRef, this.serviceAddressRef, this.billingAddressRef];
    this.formPlacement['center'] = [this.primaryDetailsRef, this.serviceTaskRef, this.partServiceRef, this.customFieldRef];
    this.formPlacement['right'] = [this.assignUserRef, this.organizationRef, this.customerRef, this.secondaryContactsRef, this.projectRef, this.propertyRef, this.requestRef, this.contractRef, this.assetRef, this.attachmentsRef];
    setTimeout(()=>{
      this.showEditor = true;
      this.today = moment();
    }, 500);
  }

  ngOnDestroy(): void {
    this.breadcrumbSubscription.unsubscribe();
    if(this.organizationPickerSubscription?.unsubscribe){
      this.organizationPickerSubscription?.unsubscribe();
    }
    if(this.customerPickerSubscription?.unsubscribe){
      this.customerPickerSubscription?.unsubscribe();
    }
    if(this.propertyPickerSubscription?.unsubscribe){
      this.propertyPickerSubscription?.unsubscribe();
    }
    if(this.contractPickerSubscription?.unsubscribe){
      this.contractPickerSubscription.unsubscribe();
    }
    if(this.assetPickerSubscription?.unsubscribe){
      this.assetPickerSubscription.unsubscribe();
    }
    if(this.jobPickerSubscription?.unsubscribe){
      this.jobPickerSubscription.unsubscribe();
    }
    if(this.requestPickerSubscription?.unsubscribe){
      this.requestPickerSubscription.unsubscribe();
    }
    if(this.projectPickerSubscription?.unsubscribe){
      this.projectPickerSubscription.unsubscribe();
    }
    if(this.secondaryContactsSubscription?.unsubscribe){
      this.secondaryContactsSubscription.unsubscribe();
    }
    if(this.timezoneSubscription?.unsubscribe){
      this.timezoneSubscription.unsubscribe();
    }
    if(this.jobFormValueChangeSubscriptions.length > 0){
      this.jobFormValueChangeSubscriptions.forEach(sub=> sub.unsubscribe());
    }
  }

  getAssignEmployee(): any{
    if(this.assignEmployeeOptions['details']['assigned_to']?.length > 0){
      return this.assignEmployeeOptions['details']['assigned_to'];
    }
  }

  showActionsMenu(tooltipName: string): any{
    this.tooltipName = tooltipName;
  }

  assignedEmployeeEmitter(event): void{
    if(event !== 'close'){
      this.assignEmployeeTask=false;
      const currentAssigned = this.masterAssignmentCopy;
      const found = currentAssigned.findIndex((data: any) => data?.user?.user_uid === event?.assigned?.user?.user_uid);
      if(found === -1){
        if(event?.type === 'ASSIGN'){
          event.assigned['fromTask'] = true;
          this.assignEmployeeOptions['details']['assigned_to'].push(event?.assigned);
          if(!this.currentServiceTask?.assigned_to){
            this.currentServiceTask.assigned_to = [];
          }
          this.currentServiceTask['assigned_to'] = event?.assigned;
          this.masterAssignmentCopy.push(event?.assigned);
        }else if(event.type === 'UNASSIGN'){
          if(this.currentServiceTask?.assigned_to){
            this.currentServiceTask['assigned_to'] = null;
          }
        }
      }else{
        const teamFound = currentAssigned.findIndex((data: any) => (data?.team?.team_uid === event?.assigned?.team?.team_uid) && (data?.user?.user_uid === event?.assigned?.user?.user_uid));
        if(event?.type === 'ASSIGN'){
          if(teamFound === -1){
            event.assigned['fromTask'] = true;
            this.masterAssignmentCopy.push(event?.assigned);
          }
          this.currentServiceTask['assigned_to'] = event?.assigned;
        }else if(event?.type === 'UNASSIGN'){
          this.currentServiceTask['assigned_to'] = null;
          const taskTeamFound = this.selectedServiceTask.find((task: any) => (task?.assigned_to?.user?.user_uid === event?.assigned?.user?.user_uid) && (task?.assigned_to?.team?.team_uid === event?.assigned?.team?.team_uid));
          const taskUserFound = this.selectedServiceTask.find((task: any) => (task?.assigned_to?.user?.user_uid === event?.assigned?.user?.user_uid));
          if(!taskTeamFound){
            const masterFound = this.assignEmployeeOptions['details']['assigned_to'].findIndex((data: any) => (data?.user?.user_uid === event?.assigned?.user?.user_uid));
            if(masterFound > -1 && this.assignEmployeeOptions['details']['assigned_to'][masterFound]?.['fromTask'] && found > -1 && !taskUserFound){
                this.assignEmployeeOptions['details']['assigned_to'].splice(masterFound, 1);
            }
            if((found > -1) && (teamFound === -1)){
              if(this.masterAssignmentCopy[found]?.['fromTask']){
                this.masterAssignmentCopy.splice(found, 1);
              }
            }else if((found > -1) && (teamFound > -1)){
              if(this.masterAssignmentCopy[teamFound]?.['fromTask']){
                this.masterAssignmentCopy.splice(teamFound, 1);
              }
            }
          }
        }
      }
    }else{
      this.tippyService.hideAll();
    }
  }

  assignEmployeeForTask(index: number, task: any): void{
    this.assignEmployeeTask=true;
    this.tippyService.hideAll();
    this.currentServiceTask = this.selectedServiceTask[index];
    this._jobsService.taskAssignment.next(this.masterAssignmentCopy);
    if(task?.assigned_to?.user?.user_uid){
      this._jobsService.taskAssignedEmployee.next(task?.assigned_to);
    }else{
      this._jobsService.taskAssignedEmployee.next(null);
    }
  }


  selectExecutionType(event: Event, type: 'PARALLEL' | 'SERIES'): void {
    event?.preventDefault();
    event?.stopPropagation();
    this.currentExecution = type;
  }

  closeModal(): void {
    this.dialogRef.close(false);
  }

  getAnalyticLink(): string {
    if((this.actionState === 'new' || this.actionState === 'clone')){
      return 'NEW_JOB_PRODUCT_DETAILS';
    }else if(this.actionState === 'edit' ){
      return 'EDIT_JOB_PRODUCT_DETAILS';
    }
  }
  isGivenDateAfterDueDate(date): boolean{
    return this.jobForm.controls['jobSchedule'].get('dueDate')?.value ? dayjs(this.jobForm.controls['jobSchedule'].get('dueDate')?.value).endOf('day').isBefore(dayjs(date)) : false;
  }

  getAllCustomerAddressDetails(SelectedCustomerID): void {
    this._dataCollectorService.getData(this._customerService.customerUrl + SelectedCustomerID).subscribe(
      (customers: any) => {
        this.selectedCustomers = [customers.data];
        this.prefillCustomerAllAddress();
      }, (error: any) => {
      });
  }

  prefillCustomerAllAddress(): void {
    if(this.selectedCustomers[0]?.customer_all_addresses?.length > 0){
      const addressList = this.selectedCustomers[0]?.customer_all_addresses.map((address: any)=>{
        const addressObj = {};
        if(address?.first_name){
          addressObj['first_name'] = address?.first_name;
        }
        if(address?.lastame){
          addressObj['first_name'] = address?.last_name;
        }
        addressObj['module'] = 'CUSTOMER';
        return {...addressObj, ...address};
      });
      this.addressOptions['addressList'].push(...addressList);
    }
    this.setCustomerTimeZone();
  }

  setCustomerTimeZone(): void{
    const jobScheduleGroup = this.jobForm.get('jobSchedule') as UntypedFormGroup;

    if (this.selectedCustomers[0]?.customer_timezone && !this.jobScheduled) {
      jobScheduleGroup.get('job_timezone').setValue(this.selectedCustomers[0]?.customer_timezone);
    }else if(this.selectedCustomers[0]?.customer_organization?.organization_timezone  && !this.jobScheduled){
      jobScheduleGroup.get('job_timezone').setValue(this.selectedCustomers[0]?.customer_organization?.organization_timezone);
    }
  }

  setOrganizationTimezone(): void{
    if (this.selectedOrganizations[0]?.organization_timezone && !this.jobScheduled) {
      this.jobForm.controls['jobSchedule'].get('job_timezone').setValue(this.selectedOrganizations[0]?.organization_timezone);
    }
  }

  updateAddressList(addressObj, module): void {
    if (addressObj?.first_name) {
      addressObj['first_name'] = addressObj?.first_name;
    }
    if (addressObj?.last_name) {
      addressObj['first_name'] = addressObj?.lastName;
    }
    addressObj['module'] = module;
    this.addressOptions['addressList'].push(addressObj);
  }

  setDueDate(): void{
    if(this.selectedCustomers[0] && this.selectedCustomers[0]?.has_sla){
      const scheduleGroup  = this.jobForm.get('jobSchedule') as UntypedFormGroup;
      let date;
      if(scheduleGroup.get('startDate').value){
        date = moment(scheduleGroup.get('startDate').value.clone(), this.dateFormat).clone().add(this.selectedCustomers[0]?.sla_duration.days * 24 , 'hours').format(this.dateFormat);
      }else{
        date = moment().clone().add(this.selectedCustomers[0]?.sla_duration.days * 24 , 'hours').format(this.dateFormat);
      }
      setTimeout(() => {
        scheduleGroup.get('dueDate').setValue(moment(date, this.dateFormat).clone());
      }, 10);
    }
  }

  ngOnInit(): void {
    this._localisationService.setDefaultLanguage();
    this.isServiceTaskEnabled = this.utilityService.companyPolicy?.service_task_enabled ?? false;
    this.isPartsServicesEnabled = this.utilityService.hasModuleAccess('PRODUCTS', false, 'from_sidebar');
    this.dateFormat = this.utilityService.dateFormat;
    this.timeFormat = this.utilityService.timeFormat;
    this.dateTimeFormat = this.utilityService.dateTimeFormat;
    this.showMeridian = this.utilityService.showMeridian;
    this.isPricelistEnabled = this.utilityService.companyPolicy?.pricelist_enabled ?? false;
    this.userRole = this._localStorageService.getLocalStorage('user')?.role.role_key || '';
    this.showAssetModule = this.utilityService.hasModuleAccess('ASSETS', false, 'from_sidebar');
    if(!this.showAssetModule){
      this.taskDisplayedColumns = this.taskDisplayedColumns.filter((data: any)=>!['asset'].includes(data));
    }
    this.companyConfig = this._localStorageService.getLocalStorage('company_configuration_data');
    this.company = this._localStorageService.getLocalStorage('company');
    this.currentUser = this.utilityService.user;
    const defaultLocationUid = this.currentUser?.meta_data?.default_product_location;
    if(defaultLocationUid){
      this.getLocationDetails(defaultLocationUid);
    };
    this.currentExecution = 'PARALLEL';
    this._breadcrumbService.count = '';
    this.module = this._route.snapshot.data?.module;
    this.redirect = window.history;
    if(!this.utilityService.isEmptyOrUndefined(this.data)){
      this.redirect = {
        state: this.data?.data
      };
      if(this.data?.data?.job_uid){
        this.uid = this?.data?.data?.job_uid;
      }
      if(this.redirect?.state?.timeZone){
        this.timeZone = this.redirect?.state?.timeZone;
      };
    }
    const actionState = this.redirect.state;
    if(actionState?.action){
      this.actionState = actionState?.action;
    }else{
      if(this._router.url.includes('edit')){
        this.actionState = 'edit';
      }else if(this._router.url.includes('new')){
        this.actionState = 'new';
      }
    }
    this.getJobCategory();
    this.constructForm();
    this.getSkills();
    this.getBreadcrumbData();

    this.timezoneSubscription = this.timezoneService.timeZones.subscribe((timezoneRes: Array<TimeZoneDataType>)=>{
      if(timezoneRes){
        this.timeZoneData = timezoneRes;
      }
    });
    this.defaultTimeZone = this.utilityService.preferredTimeZone;
    this.timeZone = this.defaultTimeZone;
    this.jobForm.controls['jobSchedule'].get('job_timezone').setValue(this.defaultTimeZone);
    this.jobForm.controls['jobSchedule'].get('job_timezone').valueChanges.subscribe((res)=>{
      this.setAccountTimeZoneValue();
      this.timeZone = res;
      this.updateTimezoneUsingDSTData();
    });
    this.jobForm.controls['jobSchedule'].get('startDate').valueChanges.subscribe((res)=>{
      this.updateTimezoneUsingDSTData();
    });

  }

  updateTimezoneUsingDSTData(): void{
    const tz = this.jobForm.controls['jobSchedule'].get('job_timezone').value;
    const startDate = this.jobForm.controls['jobSchedule'].get('startDate').value ?? moment();
    this.timeZoneData = this.timezoneService.updateDisplayNamesUsingDST(this.timeZoneData,moment.tz(startDate,tz));
  }

  drop(event: CdkDragDrop<unknown>): void {
    if (this.isInvalidDragEvent) {
      this.isInvalidDragEvent = false;
      return;
  }

  moveItemInArray(this.selectedLineItems, event.previousIndex, event.currentIndex);
    this.selectedLineItems = [...this.selectedLineItems];
    this.calculateTotalWithoutTax();
  }
  onInvalidDragEventMouseDown(): void{
    this.isInvalidDragEvent=true;
  }

  dragStarted(event): void {
    if(this.isInvalidDragEvent){
       document.dispatchEvent(new Event('mouseup'));
    }
  }

  isCreatePermissionEnabled(): boolean {
    return this.modulesCreatePermission[this.currentPickerModule] ? this.modulesCreatePermission[this.currentPickerModule] : false;
  }

  clearPricelist(): void {
    this.preloadedValue = [];
    this.currentPricelistObj= null;
    this.pricelist = this.getPricelist('');
    this.pricelistUid = '';
    this.currentPricelistType = null;
    if(this.selectedLineItems?.length){
      this.getProductDetails(this.selectedLineItems, this.currentPricelistType);
    }else{
      this.productsInPricelist = [];
    }
  }

  onPricelistSearch(): void {
    this.pricelist = this.pricelistValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(250),
      filter(value => (value !== null && value !== undefined)),
      switchMap(term => this.getPricelist(term))
    );
  }

  onPricelistScrollToEnd(): void {
    if (this.pricelistPagination.loadingIndex < this.pricelistPagination.totalPage) {
      this.pricelistPagination.loadingIndex++;
      this.pricelistParamObj['filter.keyword'] = this.pricelistPagination.keyword;
      this.pricelistParamObj['page'] = this.pricelistPagination.loadingIndex;
      this.isPricelistFetching = true;
      const urlParams = this.utilityService.constructParam(this.pricelistParamObj);
      this.pricelistService.getPricelist( urlParams).subscribe(
        (response: any) => {
          this.isPricelistFetching = false;
          if(this.currentPricelistObj){
            const updatedResponse = response.data.filter(preloadData => preloadData?.pricelist_uid !== this.currentPricelistObj?.pricelist_uid);
            this.preloadedValue = [...this.preloadedValue, ...updatedResponse];
          }else{
            this.preloadedValue = [...this.preloadedValue, ...response.data];
          }
         this.loadLookupValues();
        }, (error: any) => {
          this.isPricelistFetching = false;
        });
    }
  }

  changePricelist(event: any): void {
    this.pricelistFormControl.setValue(event?.pricelist_uid ?? null);
    this.pricelistUid = event?.pricelist_uid ?? '';
    if(event?.pricelist_type){
      this.currentPricelistType = event.pricelist_type;
    }
    if(this.currentPricelistType !== 'PER_ITEM'){
      this.productsInPricelist = [];
    }
    if(!this.utilityService.isEmptyOrUndefined(this.pricelistUid)){
      this.pricelistTypeBasedDetails();
    }else{
      this.getProductDetails(this.selectedLineItems, this.currentPricelistType);
    }
  }

  pricelistTypeBasedDetails(): void{
    if(this.currentPricelistType === 'PER_ITEM'){
      this.pricelistService.getPricelistDetails(this.pricelistUid).subscribe((response)=>{
        this.pricelistDetails = response.data;
        this.productsInPricelist = this.pricelistService.constructPricelistProductUidArray(this.pricelistDetails?.line_items);
        if(this.selectedLineItems?.length){
          this.getProductDetails(this.selectedLineItems, this.currentPricelistType);
        }
      });
    }else{
      if(this.selectedLineItems?.length){
        this.getProductDetails(this.selectedLineItems, this.currentPricelistType);
      }
    }
  }

  getProductDetails(lineItems: any, pricelistType: PricelistType): void{
    const productUidArray = [];
    lineItems.forEach((lineItem) => {
      if(lineItem?.product_uid){
        productUidArray.push(lineItem?.product_uid);
      }
    });
    const payload = {};
    payload['count'] = productUidArray.length;
    payload['filter.product_uid'] = productUidArray.join(',');
    if(this.isPricelistEnabled){
      if(this.pricelistUid){
        payload['pricelist'] = this.pricelistUid;
      }
    }
    if(productUidArray?.length){
      this._dataCollectorService.getData(this._lineItemService.lineItemAPIUrls.productUrl, payload).subscribe((response)=>{
        const productData = response.data;
        const productUidBasedData = {};
        productData.forEach((product) => {
          productUidBasedData[product.product_uid] = product;
        });
        const currentLineItems = _.cloneDeep(this.selectedLineItems);
        if(this.selectedLineItems){
          this.selectedLineItems =  currentLineItems.map((element)=>{
            let product = productUidBasedData[element?.product_uid];
            product.associated_products = product.associated_products?.map((prd: any)=> ({...prd,...prd?.product}));
            element = this.accountingService.updatePricelistPrice(element,product,pricelistType,this.productsInPricelist,this.pricelistUid,this.pricelistDetails)
            return element;
          }); 
          if(this.pricelistUid === ''){
            this.productsInPricelist = [];
            this.currentPricelistType = null;
          }
          this.calculateTotalWithoutTax();
        }
      });
    }
  }

  getPricelist(input: string = '', pricelistListObj?: any): Observable<any[]> {
    this.preloadedValue = [];
    this.pricelistPagination.keyword = input ? input : '';
    this.pricelistParamObj['filter.keyword'] = this.pricelistPagination.keyword;
    this.pricelistParamObj['page'] = 1;
    const urlParams = this.utilityService.constructParam(this.pricelistParamObj);
    this.isPricelistFetching = true;
    return this.pricelistService.getPricelist(urlParams)
      .pipe(
        catchError(() => of([])),
        map((response) => {
          this.pricelistPagination.loadingIndex = response.current_page;
          this.pricelistPagination.totalPage = response.total_pages;
          const pricelistData = response.data;
          if(pricelistListObj){
            const pricelistObjIndex = pricelistData.findIndex(pricelist => pricelist?.pricelist_uid === pricelistListObj?.pricelist_uid);
            if(pricelistObjIndex === -1){
              pricelistData.unshift(pricelistListObj);
            }
          }
          this.preloadedValue = [...this.preloadedValue, ...pricelistData];
          this.isPricelistFetching = false;
          return pricelistData;
        }));
  }

  loadLookupValues(): any {
    this.isPricelistFetching = false;
    this.pricelist = concat(
        of(this.preloadedValue),
        this.pricelistValueSubject.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            tap(() => (this.isPricelistFetching = true)),
            tap(() => (this.pricelistPagination.loadingIndex = 1)),
            switchMap((term: any) =>
                this.getPricelist(term).pipe(
                    catchError(() => of(this.preloadedValue)),
                    tap(() => (this.isPricelistFetching = false))
                )
            )
        )
    );
  }

  setPricelist(): void{
    const pricelistAssociations: PricelistAssociations = {
      selectedProperty: this.selectedProperty[0],
      selectedCustomer: this.selectedCustomers[0],
      selectedOrganization: this.selectedOrganizations[0],
      selectedJob: {},
      selectedProject: this.selectedProject[0]
    };

    const pricelistAssociationsActive: PricelistAssociationsActive = {
        ... pricelistAssociations,
        pricelistUid: this.pricelistUid
    };

    const isActivePricelist = this.pricelistService.isPricelistActive(pricelistAssociations);
    const isDifferentPricelistUid = this.pricelistService.isDifferentPricelist(pricelistAssociationsActive);
    const hasLineItems = this.selectedLineItems?.length;

    if(isDifferentPricelistUid){
      if(isActivePricelist && hasLineItems){
        const module = this.translateService.instant('job');
        const pricelistConfirmationDialog = this.pricelistService.showPricelistConfirmation(module);
        pricelistConfirmationDialog.afterClosed().subscribe((result: any)=>{
          if(result){
            this.setPricelistFormControl();
          }
        });
      }else{
        this.setPricelistFormControl();
      }
    }
  }

  setPricelistFormControl(): void{
    const pricelistAssociations: PricelistAssociations = {
      selectedProperty: this.selectedProperty[0],
      selectedCustomer: this.selectedCustomers[0],
      selectedOrganization: this.selectedOrganizations[0],
      selectedJob: {},
      selectedProject: this.selectedProject[0]
    };
    const pricelistDetails = this.pricelistService.getCurrentPricelistAndDetails(pricelistAssociations);
    this.pricelistUid = pricelistDetails?.pricelistUid;
    const pricelistValue = this.pricelistUid === '' ? null : this.pricelistUid;
    this.pricelistFormControl.setValue(pricelistValue);
    if(this.selectedProject[0]?.pricelist?.pricelist_uid && this.selectedProject[0]?.config?.product?.restrict_to_project){
      this.pricelistFormControl?.disable();
    }else{
      this.pricelistFormControl?.enable();
    }
    if(this.pricelistUid){
      this.currentPricelistType = pricelistDetails?.pricelistType;
      if(this.currentPricelistType !== 'PER_ITEM' || this.pricelistUid === ''){
        this.productsInPricelist = [];
      }
      this.currentPricelistObj = this.pricelistService.constructPricelistObject(pricelistDetails?.associateDetails);
      if(this.currentPricelistObj){
        this.pricelist = this.getPricelist('', this.currentPricelistObj);
      }
      this.pricelistTypeBasedDetails();
    }else{
      this.clearPricelist();
    }
  }

  getOrgDetails(organizationUid: string, prefillOrg, onlySetOrganizationValue: boolean = false): void{
    this._dataCollectorService.getData(this._organizationService.organizationUrl + '/' + organizationUid).subscribe(
      (organization: any) => {
        this.selectedOrganizations = [organization.data];
        this.setOrganizationTimezone();
        if(onlySetOrganizationValue === false){
          if((this.selectedOrganizations?.length === 0 && (this.selectedCustomers?.length || this.selectedProperty?.length)) || (this.selectedOrganizations?.length && organization?.data && organization?.data?.organization_uid !== this.selectedOrganizations[0]?.organization_uid)){
            this.propertyPickedFirst = false;
            this.removeCustomer();
          }
          if(prefillOrg) {
            if(this.selectedOrganizations[0]?.custom_fields?.length > 0){
              this.customFieldValue = this.selectedOrganizations[0]?.custom_fields;
            }
            this.endDateChange();
            this.prefillOrganizationAddress();
          }
          this.selectedLineItems = this.populateRequiredKeys(this.selectedLineItems);
          this.calculateTotalWithoutTax();
          if(this.isPricelistEnabled && !this.selectedCustomers[0]?.pricelist?.pricelist_uid){
            this.setPricelist();
          }
        }
      }
    );
  }

  getCusDetails(customerUID: string, onlySetCustomerValue: boolean = false): void {
    this._dataCollectorService.getData(this._customerService.customerUrl + customerUID).subscribe(
      (customers: any) => {

        this.selectedCustomers = [customers.data];
        this.setCustomerTimeZone();
        if(onlySetCustomerValue === false){
          if(this.selectedCustomers[0]?.custom_fields?.length > 0 ){
            this.customFieldValue = this.selectedCustomers[0]?.custom_fields;
          }
          if(this.selectedCustomers[0]?.customer_organization?.organization_uid && !this.selectedOrganizations?.length && !this.selectedCustomers[0]?.customer_organization?.is_deleted && !this.propertyPickedFirst){
            this._dataCollectorService.getData(this._organizationService.organizationUrl + '/' + this.selectedCustomers[0]?.customer_organization?.organization_uid).subscribe(
              (organization: any) => {
                if(!this.selectedOrganizations[0] || this.selectedOrganizations[0]['organization_uid'] !== organization?.data['uuid']){
                  this.utilityService.castEventToSdk(`${this.currentPage}:organization`, {
                    oldValue: this.selectedOrganizations[0] || null,
                    newValue: organization.data
                  });
                }
                this.selectedOrganizations = [organization?.data];
                this.prefillOrganizationAddress();
                if(this.isPricelistEnabled && !this.selectedCustomers[0]?.pricelist?.pricelist_uid){
                  this.setPricelist();
                }
              });
          }
          this.selectedLineItems = this.populateRequiredKeys(this.selectedLineItems);
          this.calculateTotalWithoutTax();
          if(this.isPricelistEnabled){
            this.setPricelist();
          }
          if(!this.propertyPickedFirst){
            this.removeProperty(false);
          }
          this.prefillCustomerAddress();
          this.prefillCustomerAllAddress();
          this.setDueDate();
          this.endDateChange();
        }
      });
  }

  getPropDetails(propertyUid, onlySetPropertyValue: boolean = false): void{
    this._dataCollectorService.getData(this._propertyService.propertyUrl + '/' + propertyUid).subscribe((property: any)=>{
      this.selectedProperty = [property?.data];
      if(onlySetPropertyValue === false){
        if(this.selectedProperty[0]?.custom_fields?.length > 0 ){
          this.customFieldValue = this.selectedProperty[0]?.custom_fields;
        }
        if(this.module === 'JOB' && this.urlState === 'new' && !this.selectedOrganizations?.length && !this.selectedCustomers?.length){
            if(this.selectedProperty[0]?.property_uid){
              this.propertyPickedFirst = true;
              this.sameAsServiceAddress = false;
              this.customerPickerOptions['showCustomDataOnly'] = true;
            }
            if(this.selectedProperty[0].property_organization){
              this.selectedOrganizations = [this.selectedProperty[0].property_organization];
              this.prefillOrganizationBillingAddress();
            }
            if(this.selectedProperty[0].property_customers) {
              if(this.selectedProperty[0].property_customers?.length === 1) {
                this.selectedCustomers = [this.selectedProperty[0].property_customers[0].customer];
                this.prefillCustomerAddress();
              }
              this.customerPickerOptions['data'] = [];
              this.selectedProperty[0].property_customers.forEach((item) => {
                this.customerPickerOptions['data'].push(item.customer);
              });
            }
        }
        this.prefillPropertyAddress();
        this.selectedLineItems = this.populateRequiredKeys(this.selectedLineItems);
        this.calculateTotalWithoutTax();
        if(this.isPricelistEnabled){
          this.setPricelist();
        }
      }
    });
  }

  updateRRuleKey(rrule: string, newUntil: any): string {
    const rruleSplits = rrule.split(';');
    const foundUntilIndex = rruleSplits.findIndex(component => component.startsWith('UNTIL='));

    if (foundUntilIndex !== -1) {
      rruleSplits[foundUntilIndex] = `UNTIL=${moment(newUntil, 'YYYYMMDDTHHmmss').format('YYYYMMDDTHHmmss')}`;
      const updatedICalString = rruleSplits.join(';');
      return updatedICalString;
    }
  }

  checkandUpdateRecurrenceDate(): void {
    const contractEndDate = moment(this.selectedContract[0]?.end_date).format('YYYYMMDDTHHmmss');
    let recurrenceEndDate = null;
    if (this.currentRruleDates?.length > 0) {
      recurrenceEndDate = moment(this.currentRruleDates[this.currentRruleDates.length - 1].scheduled_end_time).format('YYYYMMDDTHHmmss');
    }

    if(moment(contractEndDate, 'YYYYMMDDTHHmmss').isBefore(moment(recurrenceEndDate, 'YYYYMMDDTHHmmss')) && recurrenceEndDate){
      const updateJobScheduleConfirmationDialog = this._zuperDialogService.open({
        title: this.utilityService.getLocaleValue('button.update_recurrence'),
        type: 'error',
        message: this.utilityService.getLocaleValue('confirm.job.recurrence.dialog.message'),
        actions: {
            confirm: {
                show: true,
                label: 'Update',
                color: 'primary',
                confirmDisplayKey: 'update'
            },
            cancel: {
                show: true,
                label: 'Cancel',
                cancelDisplayKey: 'cancel.text'
            }
        },
        extraClass: 'w-2/5'
      });
      updateJobScheduleConfirmationDialog.afterClosed().subscribe((result: any) => {
        if (result) {
          this.openUpdateRecurrence();
        } else {
          return;
        }
      });
    }
  }

  onPricelistDropdownClose(): void{
    this.isPricelistDropdownOpened = false;
  }

  scrollIntoView(): void {
    const element = this.elementRef.nativeElement.querySelector('#pricelist-ng-select');
    if(element && !this.isPricelistDropdownOpened){
      this.isPricelistDropdownOpened = true;
      element?.scrollIntoView({ behavior: 'smooth'});
    }
 }

 closeToolTip(event): void{
  this.tippyService?.hideAll();
 }

 // #Region: UI SDK

  subscribeFormValueChangesForSDKListeners(): void {
    const customFieldsValueChangeSubscription = this.utilityService.checkDiffAndCastToSdk(this.currentPage, this.jobForm.get('customFields'));
    const jobScheduleFieldsValueChangeSubs = ['dueDate', 'startDate', 'endDate', 'recurrence'].map(controlName => this.utilityService.checkDiffAndCastToSdk(this.currentPage, this.jobForm.get('jobSchedule').get(controlName), controlName));
    const jobPrimaryFieldsValueChangeSubs = ['jobType'].map(controlName => this.utilityService.checkDiffAndCastToSdk(this.currentPage, this.jobForm.get('primaryDetails').get(controlName), controlName));
    const jobDetailsValueChangeSubs = ['prefix', 'jobTitle'].map(controlName => this.utilityService.checkDiffAndCastToSdk(this.currentPage, this.jobForm.get('jobDetails').get(controlName), controlName));
    const priceListValueChangeSubscription =  this.pricelistFormControl.valueChanges.pipe(
      distinctUntilChanged(), 
      debounceTime(1000), pairwise()).subscribe(([prev, next])=>{
        const prevValue = this.preloadedValue.find(priceList => priceList.pricelist_uid === prev) || null;
        const nextValue = this.preloadedValue.find(priceList => priceList.pricelist_uid === next) || null;
        this.utilityService.castEventToSdk(`${this.currentPage}:price_list`, {
          oldValue: { 'price_list': prevValue },
          newValue: { 'price_list': nextValue }
        });
      })
    const formValueChangeSubs = this._zuperSDKDataService.fetchCurrentFormValue.subscribe((params: any) => {
      if (params.key && params.key.includes(this.currentPage)) {
        const jobSchedule = this.utilityService.convertMomentToDate(this.jobForm.get('jobSchedule').value);
        const formValue = { ...this.jobForm.value, jobSchedule: jobSchedule };
        formValue['lineItems'] = this.selectedLineItems;
        this._zuperSDKDataService.sendNewFormValue(params.key, params.data, formValue);
      }
    });
    this.jobFormValueChangeSubscriptions = [
      ...jobScheduleFieldsValueChangeSubs,
      ...jobPrimaryFieldsValueChangeSubs,
      ...jobDetailsValueChangeSubs,
      formValueChangeSubs,
      customFieldsValueChangeSubscription,
      priceListValueChangeSubscription
    ];
  }

  get isServiceTerritoryEnabled(): boolean{
    return this.companyConfig?.service_territory?.is_enabled ?? true;
  }



  listenForPatchFormViaSDK(): void {
    const sub$ = this.utilityService.listenForFormPatchEvent(this.currentPage).pipe(map((res: MetaData) => {
      const key = res.key.replace('patchForm:' + this.currentPage + ':', '');
      return { controlName: key, value: res.data };
    })).subscribe((res: any) => {
      if (['prefix', 'jobTitle'].includes(res.controlName)) {
        this.jobForm.get('jobDetails').patchValue({ [res.controlName]: res.value }, { emitEvent: false });
      } else if (['dueDate', 'startDate', 'endDate', 'recurrence'].includes(res.controlName)) {
        res.value = moment(res.value, res.controlName === 'dueDate' ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss');
        this.jobForm.get('jobSchedule').patchValue({ [res.controlName]: res.value }, { emitEvent: false });
      } else if (['jobType', 'category'].includes(res.controlName)) {
        this.jobForm.get('primaryDetails').patchValue({ [res.controlName]: res.value }, { emitEvent: false });
      } else if (res.controlName.includes('unassign')){
        if(res.value){
          this.unassignUserOrTeamViaSdk(res.value, res.controlName);
        }
      } else if (res.controlName.includes('assign')) {
        if(res.value){
          this.assignUserOrTeamViaSdk(res.value, res.controlName);
        }
      }
      else {
        switch (res.controlName) {
          case 'billing_address':
            this.currentBillingAddress = this.populateAddressFields(res.value);
            break;
          case 'service_address':
            const currentServiceAddress = this.populateAddressFields(res.value);
            this.prepareServiceAddressDetails(currentServiceAddress);
            break;
          case 'custom_fields':
            this.jobForm.get('customFields').patchValue(res.value, { emitEvent: false });
            break;
          case 'customer': {
            this.getCusDetails(res.value);
            break;
          };
          case 'organization': {
            this.getOrgDetails(res.value, false);
            break;
          }
          case 'line_items': {
            const lineItems = typeof res.value.length === 'number' ? res.value : [res.value];
            this.prepareLineItems(lineItems);
            break;
          }
          case 'assets': {
            const assets = typeof res.value.length === 'number' ? res.value : [res.value];
            this.selectedAssets = assets;
            break;
          }
          case 'contract': {
            this.selectedContract = typeof res.value.length === 'number' ? res.value : [res.value];
            this.checkandUpdateRecurrenceDate();
            break;
          }
          case 'project': {
            this.getProjectDetails(res.value);
            break;
          }
          default: break;
        }
      }
    });
    this.jobFormValueChangeSubscriptions.push(sub$);
  }

  unassignUserOrTeamViaSdk(id: string, control: string): void{
    const currentAssignedUsers = this.assignEmployeeOptions['details']['assigned_to'];
    const userList = currentAssignedUsers.filter((user: any) => {
      if (control === 'unassign_team') {
        return user.team.team_uid !== id;
      } else if (control === 'unassign_user') {
        return user.user.user_uid !== id;
      }
    });
    if (userList.length > 0) {
      this.assignUnassignUser({
        assign: userList,
        notify: true,
        unassign: [],
        update_all_jobs: false
      }, false);
    }
  }

  assignUserOrTeamViaSdk(id: string, control: string): void{
    let $sub: Observable<any>;
    const currentAssignedUsers = this.assignEmployeeOptions['details']['assigned_to'];
    if (control === 'assign_team') {
      const isTeamAlreadyExist = currentAssignedUsers?.some((i: any) => i.team.team_uid === id);
      if (isTeamAlreadyExist) {
        return;
      }
      $sub = this._dataCollectorService.getData(this._jobsService.getTeamDetails(id)).pipe(map((response: any) => {
        const teamDetails = response.data;
        return [...currentAssignedUsers, ...teamDetails.users.map((user: any) => ({
          user: user,
          team: teamDetails.team
        }))];
      }));
    } else if (control === 'assign_user') {
      const isUserAlreadyExist = currentAssignedUsers?.find((i: any) => i.user.user_uid === id);
      if (isUserAlreadyExist) {
        return;
      }
      $sub = forkJoin([
        this._dataCollectorService.getData(this._jobsService?.getUserURL(id)),
        this._dataCollectorService.getData(this._jobsService?.getTeamsOfUser(id))]).pipe(map(responses =>
          [
            ...currentAssignedUsers,
            {
              'user': responses[0]?.data,
              'team': responses[1]?.data[0],
            }
          ]));
    }
    if ($sub) {
      $sub.subscribe((userList: any[]) => {
        this.assignUnassignUser({
          assign: userList,
          notify: true,
          unassign: [],
          update_all_jobs: false
        }, false);
      });
    }
  }

  onBundleDrawerOpenChanged(event: any): void{
    this.openBundleDetails = event;
  }

  revertBulkAction(): void{
    this.selectedLineItems = this.selectedLineItems.map((data: any)=>({...data,selected: false}));
    this.showPartsBulkAction = this.utilityService?.hasSelectedRecord(this.selectedLineItems);
    this.selectedProductCount = this.utilityService?.getSelectedProductCount(this.selectedLineItems);
  }

  setMarkup(products: any,markup): any{
    let items = _.cloneDeep(products);
    items = items?.map((data: any)=>{
      if(data?.selected === true){
        if(data?.product_type === 'BUNDLE'){
          if(data?.pricing_level === 'ROLLUP'){
            data.associated_products = data?.associated_products.map((item: any)=>{
              item = this.setMarkupForLineItem(item,markup);
              return item;
            });
          }else if(data?.pricing_level === 'BUNDLE'){
            data = this.setMarkupForLineItem(data,markup);
          }
        }else{
          data = this.setMarkupForLineItem(data,markup);
        }
      }
      this.assignTotal(data);
      return data;
    });
    return items;
  }

  setMarkupForLineItem(data: any,markup): any{
    let item = _.cloneDeep(data);
    item.markup = {
      markup_type: markup?.markupType,
      markup_value: markup?.markupValue
    }
    item.purchase_price = (item?.purchase_price ?? item?.unit_price_premarkup ?? (item?.product?.unit_price ?? item?.product?.price ?? item?.unit_price ?? item?.price));
    item.unit_price = item.price = Number(this.accountingService.getUpdatedSellingPrice(item.markup,item?.purchase_price,(item?.unit_price ?? item?.price)));
    return item;
  }
  
  performPartsBulkAction(action): void{
    switch(action?.action){
      case 'EDIT_MARKUP':
        const editMarkupDialog = this._zuperDialogService.openCustom(UpdateMarkupComponent,{
          extraClass: 'update-markup-dialog',
          options: {
            title: `${this.translateService.instant('text.bulk_update_markup.title')} ${this.selectedProductCount} ${this.translateService.instant('text.items')}`
          } 
        });
        editMarkupDialog.afterClosed().subscribe((response: any)=>{
          if(!this.utilityService.isEmptyOrUndefined(response?.markupType) && !this.utilityService.isEmptyOrUndefined(response?.markupValue)){
            this.selectedLineItems = this.setMarkup(this.selectedJobParts,response);
            this.calculateTotalWithoutTax();
            this.revertBulkAction();
          }
        });
        break;
      case 'DELETE_PRODUCTS':
        const selectedCount = this.selectedJobParts?.filter((data: any)=> data?.selected === true)?.length;
        const deleteConfirmationMessage = `${this.utilityService.getLocaleValue(
          'delete.line.item.message.prefix'
        )} <span class="text-gray-900 font-medium">
                                           "${
                                            selectedCount || ''
                                           }"</span> <span class="lowercase">${this.utilityService.getLocaleValue(
          'text.line_items'
        )}</span>?`;

        const deleteConfirmationDialog = this._zuperDialogService.openCustom(
          DeletePartsConfirmationComponent,
          {
            data: {
              dialogTitle: `${this.utilityService.getLocaleValue(
                'delete.line.item.contract.label',
                'Remove Line Item'
              )}`,
              isRecurrence: false,
              message: deleteConfirmationMessage,
            },
            extraClass: 'delete-parts-dialog',
          }
        );
        deleteConfirmationDialog.afterClosed().subscribe((result: any) => {
          if (result) {
            this.selectedLineItems = this.selectedJobParts?.filter((data: any)=> data?.selected !== true);
            this.revertBulkAction();
          }
        });
        break;
    } 
  }
  getLocationDetails(locationUid): void{
    const getLocationDetail = `${this._lineItemService?.lineItemAPIUrls?.productLocationUrl}/${locationUid}`
    this._dataCollectorService.getData(getLocationDetail).subscribe({
      next: (response)=>{
        if(response?.data){
          const locationDetails = response?.data;
          if(locationDetails?.is_deleted){
            return;
          };
          this.defaultPreferredLocationUid = locationUid;
        };
      }
    });
  };

}
